import * as __compactRuntime from '@midnight-ntwrk/compact-runtime';
import * as __compactContractsImport_Erc20Vault from '../../Erc20Vault/contract/index.js';
__compactRuntime.checkRuntimeVersion('0.19.0');

const _descriptor_0 = new __compactRuntime.CompactTypeBytes(32);

class _ContractAddress_0 {
  alignment() {
    return _descriptor_0.alignment();
  }
  fromValue(value_0) {
    return {
      bytes: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0.bytes);
  }
}

const _descriptor_1 = new _ContractAddress_0();

class _AffinePoint_0 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment());
  }
  fromValue(value_0) {
    return {
      x: _descriptor_0.fromValue(value_0),
      y: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0.x).concat(_descriptor_0.toValue(value_0.y));
  }
}

const _descriptor_2 = new _AffinePoint_0();

const _descriptor_3 = new __compactRuntime.CompactTypeUnsignedInteger(255n, 1);

class _Signature_0 {
  alignment() {
    return _descriptor_2.alignment().concat(_descriptor_0.alignment().concat(_descriptor_3.alignment()));
  }
  fromValue(value_0) {
    return {
      bigR: _descriptor_2.fromValue(value_0),
      s: _descriptor_0.fromValue(value_0),
      recoveryId: _descriptor_3.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_2.toValue(value_0.bigR).concat(_descriptor_0.toValue(value_0.s).concat(_descriptor_3.toValue(value_0.recoveryId)));
  }
}

const _descriptor_4 = new _Signature_0();

class _RespondBidirectionalEvent_0 {
  alignment() {
    return _descriptor_4.alignment();
  }
  fromValue(value_0) {
    return {
      signature: _descriptor_4.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_4.toValue(value_0.signature);
  }
}

const _descriptor_5 = new _RespondBidirectionalEvent_0();

const _descriptor_6 = new __compactRuntime.CompactTypeBytes(1);

const _descriptor_7 = new __compactRuntime.CompactTypeBytes(192);

const _descriptor_8 = __compactRuntime.CompactTypeBoolean;

const _descriptor_9 = new __compactRuntime.CompactTypeUnsignedInteger(340282366920938463463374607431768211455n, 16);

class _ShieldedCoinInfo_0 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment()));
  }
  fromValue(value_0) {
    return {
      nonce: _descriptor_0.fromValue(value_0),
      color: _descriptor_0.fromValue(value_0),
      value: _descriptor_9.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0.nonce).concat(_descriptor_0.toValue(value_0.color).concat(_descriptor_9.toValue(value_0.value)));
  }
}

const _descriptor_10 = new _ShieldedCoinInfo_0();

class _Maybe_0 {
  alignment() {
    return _descriptor_8.alignment().concat(_descriptor_10.alignment());
  }
  fromValue(value_0) {
    return {
      is_some: _descriptor_8.fromValue(value_0),
      value: _descriptor_10.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_8.toValue(value_0.is_some).concat(_descriptor_10.toValue(value_0.value));
  }
}

const _descriptor_11 = new _Maybe_0();

const _descriptor_12 = new __compactRuntime.CompactTypeBytes(5);

const _descriptor_13 = new __compactRuntime.CompactTypeUnsignedInteger(18446744073709551615n, 8);

const _descriptor_14 = new __compactRuntime.CompactTypeBytes(20);

const _descriptor_15 = __compactRuntime.CompactTypeSecp256k1Point;

const _descriptor_16 = __compactRuntime.CompactTypeSecp256k1Scalar;

class _Secp256k1EcdsaSignature_0 {
  alignment() {
    return _descriptor_16.alignment().concat(_descriptor_16.alignment());
  }
  fromValue(value_0) {
    return {
      r: _descriptor_16.fromValue(value_0),
      s: _descriptor_16.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_16.toValue(value_0.r).concat(_descriptor_16.toValue(value_0.s));
  }
}

const _descriptor_17 = new _Secp256k1EcdsaSignature_0();

const _descriptor_18 = new __compactRuntime.CompactTypeUnsignedInteger(4294967295n, 4);

const _descriptor_19 = __compactRuntime.CompactTypeJubjubPoint;

const _descriptor_20 = __compactRuntime.CompactTypeField;

class _tuple_0 {
  alignment() {
    return _descriptor_10.alignment().concat(_descriptor_11.alignment());
  }
  fromValue(value_0) {
    return [
      _descriptor_10.fromValue(value_0),
      _descriptor_11.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_10.toValue(value_0[0]).concat(_descriptor_11.toValue(value_0[1]));
  }
}

const _descriptor_21 = new _tuple_0();

class _ZswapCoinPublicKey_0 {
  alignment() {
    return _descriptor_0.alignment();
  }
  fromValue(value_0) {
    return {
      bytes: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0.bytes);
  }
}

const _descriptor_22 = new _ZswapCoinPublicKey_0();

class _UserAddress_0 {
  alignment() {
    return _descriptor_0.alignment();
  }
  fromValue(value_0) {
    return {
      bytes: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0.bytes);
  }
}

const _descriptor_23 = new _UserAddress_0();

class _QualifiedShieldedCoinInfo_0 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_13.alignment())));
  }
  fromValue(value_0) {
    return {
      nonce: _descriptor_0.fromValue(value_0),
      color: _descriptor_0.fromValue(value_0),
      value: _descriptor_9.fromValue(value_0),
      mt_index: _descriptor_13.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0.nonce).concat(_descriptor_0.toValue(value_0.color).concat(_descriptor_9.toValue(value_0.value).concat(_descriptor_13.toValue(value_0.mt_index))));
  }
}

const _descriptor_24 = new _QualifiedShieldedCoinInfo_0();

class _Either_0 {
  alignment() {
    return _descriptor_8.alignment().concat(_descriptor_22.alignment().concat(_descriptor_1.alignment()));
  }
  fromValue(value_0) {
    return {
      is_left: _descriptor_8.fromValue(value_0),
      left: _descriptor_22.fromValue(value_0),
      right: _descriptor_1.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_8.toValue(value_0.is_left).concat(_descriptor_22.toValue(value_0.left).concat(_descriptor_1.toValue(value_0.right)));
  }
}

const _descriptor_25 = new _Either_0();

const _descriptor_26 = __compactRuntime.CompactTypeSecp256k1Base;

const _descriptor_27 = __compactRuntime.CompactTypeField;

const _descriptor_28 = new __compactRuntime.CompactTypeBytes(66);

const _descriptor_29 = new __compactRuntime.CompactTypeBytes(384);

const _descriptor_30 = new __compactRuntime.CompactTypeBytes(416);

const _descriptor_31 = new __compactRuntime.CompactTypeBytes(256);

const _descriptor_32 = new __compactRuntime.CompactTypeBytes(160);

const _descriptor_33 = new __compactRuntime.CompactTypeVector(32, _descriptor_3);

class _tuple_1 {
  alignment() {
    return _descriptor_33.alignment().concat(_descriptor_33.alignment());
  }
  fromValue(value_0) {
    return [
      _descriptor_33.fromValue(value_0),
      _descriptor_33.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_33.toValue(value_0[0]).concat(_descriptor_33.toValue(value_0[1]));
  }
}

const _descriptor_34 = new _tuple_1();

const _descriptor_35 = new __compactRuntime.CompactTypeBytes(21);

class _SwapCoinPreimage_0 {
  alignment() {
    return _descriptor_35.alignment().concat(_descriptor_10.alignment().concat(_descriptor_8.alignment().concat(_descriptor_0.alignment())));
  }
  fromValue(value_0) {
    return {
      domain_sep: _descriptor_35.fromValue(value_0),
      info: _descriptor_10.fromValue(value_0),
      dataType: _descriptor_8.fromValue(value_0),
      data: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_35.toValue(value_0.domain_sep).concat(_descriptor_10.toValue(value_0.info).concat(_descriptor_8.toValue(value_0.dataType).concat(_descriptor_0.toValue(value_0.data))));
  }
}

const _descriptor_36 = new _SwapCoinPreimage_0();

class _tuple_2 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_14.alignment().concat(_descriptor_14.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_13.alignment().concat(_descriptor_13.alignment().concat(_descriptor_9.alignment().concat(_descriptor_9.alignment().concat(_descriptor_3.alignment().concat(_descriptor_14.alignment().concat(_descriptor_24.alignment().concat(_descriptor_13.alignment())))))))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_14.fromValue(value_0),
      _descriptor_14.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_13.fromValue(value_0),
      _descriptor_13.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_3.fromValue(value_0),
      _descriptor_14.fromValue(value_0),
      _descriptor_24.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_14.toValue(value_0[2]).concat(_descriptor_14.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_9.toValue(value_0[5]).concat(_descriptor_13.toValue(value_0[6]).concat(_descriptor_13.toValue(value_0[7]).concat(_descriptor_9.toValue(value_0[8]).concat(_descriptor_9.toValue(value_0[9]).concat(_descriptor_3.toValue(value_0[10]).concat(_descriptor_14.toValue(value_0[11]).concat(_descriptor_24.toValue(value_0[12]).concat(_descriptor_13.toValue(value_0[13]))))))))))))));
  }
}

const _descriptor_37 = new _tuple_2();

class _CoinPreimage_0 {
  alignment() {
    return _descriptor_35.alignment().concat(_descriptor_10.alignment().concat(_descriptor_8.alignment().concat(_descriptor_0.alignment())));
  }
  fromValue(value_0) {
    return {
      domain_sep: _descriptor_35.fromValue(value_0),
      info: _descriptor_10.fromValue(value_0),
      dataType: _descriptor_8.fromValue(value_0),
      data: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_35.toValue(value_0.domain_sep).concat(_descriptor_10.toValue(value_0.info).concat(_descriptor_8.toValue(value_0.dataType).concat(_descriptor_0.toValue(value_0.data))));
  }
}

const _descriptor_38 = new _CoinPreimage_0();

class _tuple_3 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_14.alignment().concat(_descriptor_14.alignment().concat(_descriptor_9.alignment().concat(_descriptor_13.alignment().concat(_descriptor_13.alignment().concat(_descriptor_9.alignment().concat(_descriptor_9.alignment().concat(_descriptor_3.alignment().concat(_descriptor_13.alignment()))))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_14.fromValue(value_0),
      _descriptor_14.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_13.fromValue(value_0),
      _descriptor_13.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_3.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_14.toValue(value_0[2]).concat(_descriptor_14.toValue(value_0[3]).concat(_descriptor_9.toValue(value_0[4]).concat(_descriptor_13.toValue(value_0[5]).concat(_descriptor_13.toValue(value_0[6]).concat(_descriptor_9.toValue(value_0[7]).concat(_descriptor_9.toValue(value_0[8]).concat(_descriptor_3.toValue(value_0[9]).concat(_descriptor_13.toValue(value_0[10])))))))))));
  }
}

const _descriptor_39 = new _tuple_3();

const _descriptor_40 = new __compactRuntime.CompactTypeBytes(64);

class _tuple_4 {
  alignment() {
    return _descriptor_40.alignment();
  }
  fromValue(value_0) {
    return [
      _descriptor_40.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_40.toValue(value_0[0]);
  }
}

const _descriptor_41 = new _tuple_4();

class _tuple_5 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_14.alignment().concat(_descriptor_0.alignment().concat(_descriptor_13.alignment()))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_14.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_14.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_13.toValue(value_0[4])))));
  }
}

const _descriptor_42 = new _tuple_5();

class _tuple_6 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_14.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_3.alignment().concat(_descriptor_0.alignment().concat(_descriptor_10.alignment().concat(_descriptor_7.alignment().concat(_descriptor_7.alignment().concat(_descriptor_13.alignment().concat(_descriptor_24.alignment().concat(_descriptor_13.alignment()))))))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_14.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_3.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_13.fromValue(value_0),
      _descriptor_24.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_14.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_9.toValue(value_0[4]).concat(_descriptor_3.toValue(value_0[5]).concat(_descriptor_0.toValue(value_0[6]).concat(_descriptor_10.toValue(value_0[7]).concat(_descriptor_7.toValue(value_0[8]).concat(_descriptor_7.toValue(value_0[9]).concat(_descriptor_13.toValue(value_0[10]).concat(_descriptor_24.toValue(value_0[11]).concat(_descriptor_13.toValue(value_0[12])))))))))))));
  }
}

const _descriptor_43 = new _tuple_6();

class _tuple_7 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_14.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_24.alignment().concat(_descriptor_13.alignment())))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_14.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_24.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_14.toValue(value_0[2]).concat(_descriptor_1.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_9.toValue(value_0[5]).concat(_descriptor_24.toValue(value_0[6]).concat(_descriptor_13.toValue(value_0[7]))))))));
  }
}

const _descriptor_44 = new _tuple_7();

class _tuple_8 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_14.alignment().concat(_descriptor_7.alignment().concat(_descriptor_13.alignment()))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_14.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_14.toValue(value_0[2]).concat(_descriptor_7.toValue(value_0[3]).concat(_descriptor_13.toValue(value_0[4])))));
  }
}

const _descriptor_45 = new _tuple_8();

class _tuple_9 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_14.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_23.alignment().concat(_descriptor_13.alignment()))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_14.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_23.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_14.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_9.toValue(value_0[4]).concat(_descriptor_23.toValue(value_0[5]).concat(_descriptor_13.toValue(value_0[6])))))));
  }
}

const _descriptor_46 = new _tuple_9();

class _tuple_10 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_14.alignment().concat(_descriptor_22.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_24.alignment().concat(_descriptor_13.alignment())))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_14.fromValue(value_0),
      _descriptor_22.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_24.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_14.toValue(value_0[2]).concat(_descriptor_22.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_9.toValue(value_0[5]).concat(_descriptor_24.toValue(value_0[6]).concat(_descriptor_13.toValue(value_0[7]))))))));
  }
}

const _descriptor_47 = new _tuple_10();

class _tuple_11 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_7.alignment().concat(_descriptor_13.alignment())))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_7.toValue(value_0[4]).concat(_descriptor_13.toValue(value_0[5]))))));
  }
}

const _descriptor_48 = new _tuple_11();

class _tuple_12 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_13.alignment())))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_13.toValue(value_0[5]))))));
  }
}

const _descriptor_49 = new _tuple_12();

class _tuple_13 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_22.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_24.alignment().concat(_descriptor_13.alignment()))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_22.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_24.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_22.toValue(value_0[4]).concat(_descriptor_0.toValue(value_0[5]).concat(_descriptor_9.toValue(value_0[6]).concat(_descriptor_24.toValue(value_0[7]).concat(_descriptor_13.toValue(value_0[8])))))))));
  }
}

const _descriptor_50 = new _tuple_13();

class _tuple_14 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_24.alignment().concat(_descriptor_13.alignment()))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_24.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_1.toValue(value_0[4]).concat(_descriptor_0.toValue(value_0[5]).concat(_descriptor_9.toValue(value_0[6]).concat(_descriptor_24.toValue(value_0[7]).concat(_descriptor_13.toValue(value_0[8])))))))));
  }
}

const _descriptor_51 = new _tuple_14();

class _tuple_15 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_19.alignment().concat(_descriptor_19.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_3.alignment().concat(_descriptor_0.alignment().concat(_descriptor_10.alignment().concat(_descriptor_7.alignment().concat(_descriptor_7.alignment().concat(_descriptor_13.alignment().concat(_descriptor_24.alignment().concat(_descriptor_13.alignment().concat(_descriptor_13.alignment()))))))))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_3.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_13.fromValue(value_0),
      _descriptor_24.fromValue(value_0),
      _descriptor_13.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_19.toValue(value_0[2]).concat(_descriptor_19.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_9.toValue(value_0[5]).concat(_descriptor_3.toValue(value_0[6]).concat(_descriptor_0.toValue(value_0[7]).concat(_descriptor_10.toValue(value_0[8]).concat(_descriptor_7.toValue(value_0[9]).concat(_descriptor_7.toValue(value_0[10]).concat(_descriptor_13.toValue(value_0[11]).concat(_descriptor_24.toValue(value_0[12]).concat(_descriptor_13.toValue(value_0[13]).concat(_descriptor_13.toValue(value_0[14])))))))))))))));
  }
}

const _descriptor_52 = new _tuple_15();

class _tuple_16 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_23.alignment().concat(_descriptor_13.alignment())))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_23.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_9.toValue(value_0[5]).concat(_descriptor_23.toValue(value_0[6]).concat(_descriptor_13.toValue(value_0[7]))))))));
  }
}

const _descriptor_53 = new _tuple_16();

class _tuple_17 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_19.alignment().concat(_descriptor_19.alignment().concat(_descriptor_7.alignment().concat(_descriptor_13.alignment().concat(_descriptor_13.alignment()))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_13.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_19.toValue(value_0[2]).concat(_descriptor_19.toValue(value_0[3]).concat(_descriptor_7.toValue(value_0[4]).concat(_descriptor_13.toValue(value_0[5]).concat(_descriptor_13.toValue(value_0[6])))))));
  }
}

const _descriptor_54 = new _tuple_17();

class _tuple_18 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_19.alignment().concat(_descriptor_19.alignment().concat(_descriptor_0.alignment().concat(_descriptor_13.alignment().concat(_descriptor_13.alignment()))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_13.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_19.toValue(value_0[2]).concat(_descriptor_19.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_13.toValue(value_0[5]).concat(_descriptor_13.toValue(value_0[6])))))));
  }
}

const _descriptor_55 = new _tuple_18();

class _tuple_19 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_19.alignment().concat(_descriptor_19.alignment().concat(_descriptor_22.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_24.alignment().concat(_descriptor_13.alignment().concat(_descriptor_13.alignment())))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_22.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_24.fromValue(value_0),
      _descriptor_13.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_19.toValue(value_0[2]).concat(_descriptor_19.toValue(value_0[3]).concat(_descriptor_22.toValue(value_0[4]).concat(_descriptor_0.toValue(value_0[5]).concat(_descriptor_9.toValue(value_0[6]).concat(_descriptor_24.toValue(value_0[7]).concat(_descriptor_13.toValue(value_0[8]).concat(_descriptor_13.toValue(value_0[9]))))))))));
  }
}

const _descriptor_56 = new _tuple_19();

class _tuple_20 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_19.alignment().concat(_descriptor_19.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_24.alignment().concat(_descriptor_13.alignment().concat(_descriptor_13.alignment())))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_24.fromValue(value_0),
      _descriptor_13.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_19.toValue(value_0[2]).concat(_descriptor_19.toValue(value_0[3]).concat(_descriptor_1.toValue(value_0[4]).concat(_descriptor_0.toValue(value_0[5]).concat(_descriptor_9.toValue(value_0[6]).concat(_descriptor_24.toValue(value_0[7]).concat(_descriptor_13.toValue(value_0[8]).concat(_descriptor_13.toValue(value_0[9]))))))))));
  }
}

const _descriptor_57 = new _tuple_20();

const _descriptor_58 = new __compactRuntime.CompactTypeBytes(27);

class _tuple_21 {
  alignment() {
    return _descriptor_58.alignment().concat(_descriptor_0.alignment());
  }
  fromValue(value_0) {
    return [
      _descriptor_58.fromValue(value_0),
      _descriptor_0.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_58.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]));
  }
}

const _descriptor_59 = new _tuple_21();

class _tuple_22 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_19.alignment().concat(_descriptor_19.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_23.alignment().concat(_descriptor_13.alignment().concat(_descriptor_13.alignment()))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_23.fromValue(value_0),
      _descriptor_13.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_19.toValue(value_0[2]).concat(_descriptor_19.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_9.toValue(value_0[5]).concat(_descriptor_23.toValue(value_0[6]).concat(_descriptor_13.toValue(value_0[7]).concat(_descriptor_13.toValue(value_0[8])))))))));
  }
}

const _descriptor_60 = new _tuple_22();

class _tuple_23 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_14.alignment().concat(_descriptor_18.alignment().concat(_descriptor_13.alignment()))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_14.fromValue(value_0),
      _descriptor_18.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_14.toValue(value_0[2]).concat(_descriptor_18.toValue(value_0[3]).concat(_descriptor_13.toValue(value_0[4])))));
  }
}

const _descriptor_61 = new _tuple_23();

class _tuple_24 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_19.alignment().concat(_descriptor_18.alignment().concat(_descriptor_13.alignment()))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_19.fromValue(value_0),
      _descriptor_18.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_19.toValue(value_0[2]).concat(_descriptor_18.toValue(value_0[3]).concat(_descriptor_13.toValue(value_0[4])))));
  }
}

const _descriptor_62 = new _tuple_24();

class _tuple_25 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_3.alignment().concat(_descriptor_18.alignment().concat(_descriptor_13.alignment()))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_3.fromValue(value_0),
      _descriptor_18.fromValue(value_0),
      _descriptor_13.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_3.toValue(value_0[4]).concat(_descriptor_18.toValue(value_0[5]).concat(_descriptor_13.toValue(value_0[6])))))));
  }
}

const _descriptor_63 = new _tuple_25();

class _tuple_26 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_3.alignment()))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_3.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_3.toValue(value_0[4])))));
  }
}

const _descriptor_64 = new _tuple_26();

class _tuple_27 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_14.alignment()));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_14.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_14.toValue(value_0[2])));
  }
}

const _descriptor_65 = new _tuple_27();

const _descriptor_66 = new __compactRuntime.CompactTypeVector(2, _descriptor_20);

class _tuple_28 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_19.alignment()));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_19.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_19.toValue(value_0[2])));
  }
}

const _descriptor_67 = new _tuple_28();

const _descriptor_68 = new __compactRuntime.CompactTypeVector(3, _descriptor_20);

class _Either_1 {
  alignment() {
    return _descriptor_8.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment()));
  }
  fromValue(value_0) {
    return {
      is_left: _descriptor_8.fromValue(value_0),
      left: _descriptor_0.fromValue(value_0),
      right: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_8.toValue(value_0.is_left).concat(_descriptor_0.toValue(value_0.left).concat(_descriptor_0.toValue(value_0.right)));
  }
}

const _descriptor_69 = new _Either_1();

class _Either_2 {
  alignment() {
    return _descriptor_8.alignment().concat(_descriptor_1.alignment().concat(_descriptor_23.alignment()));
  }
  fromValue(value_0) {
    return {
      is_left: _descriptor_8.fromValue(value_0),
      left: _descriptor_1.fromValue(value_0),
      right: _descriptor_23.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_8.toValue(value_0.is_left).concat(_descriptor_1.toValue(value_0.left).concat(_descriptor_23.toValue(value_0.right)));
  }
}

const _descriptor_70 = new _Either_2();

class _ShieldedSendResult_0 {
  alignment() {
    return _descriptor_11.alignment().concat(_descriptor_10.alignment());
  }
  fromValue(value_0) {
    return {
      change: _descriptor_11.fromValue(value_0),
      sent: _descriptor_10.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_11.toValue(value_0.change).concat(_descriptor_10.toValue(value_0.sent));
  }
}

const _descriptor_71 = new _ShieldedSendResult_0();

export class Contract {
  witnesses;
  constructor(...args_0) {
    if (args_0.length !== 1) {
      throw new __compactRuntime.CompactError(`Contract constructor: expected 1 argument, received ${args_0.length}`);
    }
    const witnesses_0 = args_0[0];
    if (typeof(witnesses_0) !== 'object') {
      throw new __compactRuntime.CompactError('first (witnesses) argument to Contract constructor is not an object');
    }
    if (typeof(witnesses_0.held_coin) !== 'function') {
      throw new __compactRuntime.CompactError('first (witnesses) argument to Contract constructor does not contain a function-valued field named held_coin');
    }
    this.witnesses = witnesses_0;
    this.circuits = {
      async evm_account_alias(context, ...args_1) {
        return { result: pureCircuits.evm_account_alias(...args_1), context };
      },
      async evm_domain_separator_for(context, ...args_1) {
        return { result: pureCircuits.evm_domain_separator_for(...args_1), context };
      },
      async evm_struct_hash_withdraw_unshielded(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_withdraw_unshielded(...args_1), context };
      },
      async evm_struct_hash_withdraw_shielded(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_withdraw_shielded(...args_1), context };
      },
      async evm_struct_hash_withdraw_shielded_to_contract(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_withdraw_shielded_to_contract(...args_1), context };
      },
      async evm_struct_hash_append_inbox(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_append_inbox(...args_1), context };
      },
      async evm_struct_hash_rotate_enc_key(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_rotate_enc_key(...args_1), context };
      },
      async evm_struct_hash_add_device(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_add_device(...args_1), context };
      },
      async evm_struct_hash_remove_device(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_remove_device(...args_1), context };
      },
      async evm_struct_hash_open_swap_shielded(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_open_swap_shielded(...args_1), context };
      },
      async evm_struct_hash_bridge_deposit_start(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_bridge_deposit_start(...args_1), context };
      },
      async evm_struct_hash_bridge_withdraw_start(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_bridge_withdraw_start(...args_1), context };
      },
      async evm_digest_withdraw_unshielded(context, ...args_1) {
        return { result: pureCircuits.evm_digest_withdraw_unshielded(...args_1), context };
      },
      async evm_digest_withdraw_shielded(context, ...args_1) {
        return { result: pureCircuits.evm_digest_withdraw_shielded(...args_1), context };
      },
      async evm_digest_withdraw_shielded_to_contract(context, ...args_1) {
        return { result: pureCircuits.evm_digest_withdraw_shielded_to_contract(...args_1), context };
      },
      async evm_digest_append_inbox(context, ...args_1) {
        return { result: pureCircuits.evm_digest_append_inbox(...args_1), context };
      },
      async evm_digest_rotate_enc_key(context, ...args_1) {
        return { result: pureCircuits.evm_digest_rotate_enc_key(...args_1), context };
      },
      async evm_digest_add_device(context, ...args_1) {
        return { result: pureCircuits.evm_digest_add_device(...args_1), context };
      },
      async evm_digest_open_swap_shielded(context, ...args_1) {
        return { result: pureCircuits.evm_digest_open_swap_shielded(...args_1), context };
      },
      async evm_digest_remove_device(context, ...args_1) {
        return { result: pureCircuits.evm_digest_remove_device(...args_1), context };
      },
      async evm_digest_bridge_deposit_start(context, ...args_1) {
        return { result: pureCircuits.evm_digest_bridge_deposit_start(...args_1), context };
      },
      async evm_digest_bridge_withdraw_start(context, ...args_1) {
        return { result: pureCircuits.evm_digest_bridge_withdraw_start(...args_1), context };
      },
      async zswapNullifierOf(context, ...args_1) {
        return { result: pureCircuits.zswapNullifierOf(...args_1), context };
      },
      async zswapCommitmentOf(context, ...args_1) {
        return { result: pureCircuits.zswapCommitmentOf(...args_1), context };
      },
      activate_initial_device_with_jubjub: async (...args_1) => {
        if (args_1.length !== 3) {
          throw new __compactRuntime.CompactError(`activate_initial_device_with_jubjub: expected 3 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const pk_0 = args_1[1];
        const salt_0 = args_1[2];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('activate_initial_device_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 517 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
          __compactRuntime.typeError('activate_initial_device_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 517 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
          __compactRuntime.typeError('activate_initial_device_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 517 char 1',
                                     'Bytes<32>',
                                     salt_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_19.toValue(pk_0).concat(_descriptor_0.toValue(salt_0)),
            alignment: _descriptor_19.alignment().concat(_descriptor_0.alignment())
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._activate_initial_device_with_jubjub_0(context,
                                                                           partialProofData,
                                                                           pk_0,
                                                                           salt_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      activate_initial_device_with_k256: async (...args_1) => {
        if (args_1.length !== 4) {
          throw new __compactRuntime.CompactError(`activate_initial_device_with_k256: expected 4 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const pk_0 = args_1[1];
        const salt_0 = args_1[2];
        const envelope_0 = args_1[3];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('activate_initial_device_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 527 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('activate_initial_device_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 527 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
          __compactRuntime.typeError('activate_initial_device_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 527 char 1',
                                     'Bytes<32>',
                                     salt_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('activate_initial_device_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 527 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_15.toValue(pk_0).concat(_descriptor_0.toValue(salt_0).concat(_descriptor_3.toValue(envelope_0))),
            alignment: _descriptor_15.alignment().concat(_descriptor_0.alignment().concat(_descriptor_3.alignment()))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._activate_initial_device_with_k256_0(context,
                                                                         partialProofData,
                                                                         pk_0,
                                                                         salt_0,
                                                                         envelope_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      activate_initial_device_with_evm: async (...args_1) => {
        if (args_1.length !== 3) {
          throw new __compactRuntime.CompactError(`activate_initial_device_with_evm: expected 3 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const pk_0 = args_1[1];
        const salt_0 = args_1[2];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('activate_initial_device_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 545 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('activate_initial_device_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 545 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
          __compactRuntime.typeError('activate_initial_device_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 545 char 1',
                                     'Bytes<32>',
                                     salt_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_15.toValue(pk_0).concat(_descriptor_0.toValue(salt_0)),
            alignment: _descriptor_15.alignment().concat(_descriptor_0.alignment())
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._activate_initial_device_with_evm_0(context,
                                                                        partialProofData,
                                                                        pk_0,
                                                                        salt_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      async derive_boot_commitment_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.derive_boot_commitment_with_jubjub(...args_1), context };
      },
      async derive_boot_commitment_with_k256(context, ...args_1) {
        return { result: pureCircuits.derive_boot_commitment_with_k256(...args_1), context };
      },
      async derive_boot_commitment_with_evm(context, ...args_1) {
        return { result: pureCircuits.derive_boot_commitment_with_evm(...args_1), context };
      },
      async derive_device_entry_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.derive_device_entry_with_jubjub(...args_1), context };
      },
      async derive_device_entry_with_k256(context, ...args_1) {
        return { result: pureCircuits.derive_device_entry_with_k256(...args_1), context };
      },
      async derive_device_entry_with_evm(context, ...args_1) {
        return { result: pureCircuits.derive_device_entry_with_evm(...args_1), context };
      },
      async envelope_digest(context, ...args_1) {
        return { result: pureCircuits.envelope_digest(...args_1), context };
      },
      async compute_public_point_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.compute_public_point_with_jubjub(...args_1), context };
      },
      async compute_public_point_with_k256(context, ...args_1) {
        return { result: pureCircuits.compute_public_point_with_k256(...args_1), context };
      },
      async challenge_withdraw_unshielded_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_unshielded_with_jubjub(...args_1), context };
      },
      async challenge_withdraw_shielded_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_with_jubjub(...args_1), context };
      },
      async challenge_withdraw_shielded_to_contract_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_to_contract_with_jubjub(...args_1), context };
      },
      async challenge_append_inbox_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_append_inbox_with_jubjub(...args_1), context };
      },
      async challenge_rotate_enc_key_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_rotate_enc_key_with_jubjub(...args_1), context };
      },
      async challenge_add_device_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_add_device_with_jubjub(...args_1), context };
      },
      async challenge_remove_device_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_remove_device_with_jubjub(...args_1), context };
      },
      async challenge_open_swap_shielded_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_open_swap_shielded_with_jubjub(...args_1), context };
      },
      async challenge_withdraw_unshielded_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_unshielded_with_k256(...args_1), context };
      },
      async challenge_withdraw_shielded_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_with_k256(...args_1), context };
      },
      async challenge_withdraw_shielded_to_contract_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_to_contract_with_k256(...args_1), context };
      },
      async challenge_append_inbox_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_append_inbox_with_k256(...args_1), context };
      },
      async challenge_rotate_enc_key_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_rotate_enc_key_with_k256(...args_1), context };
      },
      async challenge_add_device_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_add_device_with_k256(...args_1), context };
      },
      async challenge_remove_device_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_remove_device_with_k256(...args_1), context };
      },
      async challenge_withdraw_unshielded_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_unshielded_with_evm(...args_1), context };
      },
      async challenge_withdraw_shielded_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_with_evm(...args_1), context };
      },
      async challenge_withdraw_shielded_to_contract_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_to_contract_with_evm(...args_1), context };
      },
      async challenge_append_inbox_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_append_inbox_with_evm(...args_1), context };
      },
      async challenge_rotate_enc_key_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_rotate_enc_key_with_evm(...args_1), context };
      },
      async challenge_add_device_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_add_device_with_evm(...args_1), context };
      },
      async challenge_remove_device_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_remove_device_with_evm(...args_1), context };
      },
      async challenge_open_swap_shielded_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_open_swap_shielded_with_evm(...args_1), context };
      },
      async challenge_bridge_deposit_start_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_bridge_deposit_start_with_evm(...args_1), context };
      },
      async challenge_bridge_withdraw_start_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_bridge_withdraw_start_with_evm(...args_1), context };
      },
      async assert_open_swap_terms(context, ...args_1) {
        return { result: pureCircuits.assert_open_swap_terms(...args_1), context };
      },
      async swap_change_nonce(context, ...args_1) {
        return { result: pureCircuits.swap_change_nonce(...args_1), context };
      },
      deposit_unshielded: async (...args_1) => {
        if (args_1.length !== 3) {
          throw new __compactRuntime.CompactError(`deposit_unshielded: expected 3 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const color_0 = args_1[1];
        const amount_0 = args_1[2];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('deposit_unshielded',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1728 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('deposit_unshielded',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1728 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('deposit_unshielded',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1728 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(color_0).concat(_descriptor_9.toValue(amount_0)),
            alignment: _descriptor_0.alignment().concat(_descriptor_9.alignment())
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._deposit_unshielded_0(context,
                                                          partialProofData,
                                                          color_0,
                                                          amount_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_unshielded_with_jubjub: async (...args_1) => {
        if (args_1.length !== 9) {
          throw new __compactRuntime.CompactError(`withdraw_unshielded_with_jubjub: expected 9 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const color_0 = args_1[1];
        const amount_0 = args_1[2];
        const recipient_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_r_0 = args_1[6];
        const sig_s_0 = args_1[7];
        const grind_nonce_0 = args_1[8];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1738 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1738 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1738 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1738 char 1',
                                     'struct UserAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1738 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1738 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1738 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 1738 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 1738 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(color_0).concat(_descriptor_9.toValue(amount_0).concat(_descriptor_23.toValue(recipient_0).concat(_descriptor_19.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_19.toValue(sig_r_0).concat(_descriptor_20.toValue(sig_s_0).concat(_descriptor_13.toValue(grind_nonce_0)))))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_23.alignment().concat(_descriptor_19.alignment().concat(_descriptor_13.alignment().concat(_descriptor_19.alignment().concat(_descriptor_20.alignment().concat(_descriptor_13.alignment())))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_unshielded_with_jubjub_0(context,
                                                                       partialProofData,
                                                                       color_0,
                                                                       amount_0,
                                                                       recipient_0,
                                                                       pk_0,
                                                                       use_counter_0,
                                                                       sig_r_0,
                                                                       sig_s_0,
                                                                       grind_nonce_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_unshielded_with_k256: async (...args_1) => {
        if (args_1.length !== 8) {
          throw new __compactRuntime.CompactError(`withdraw_unshielded_with_k256: expected 8 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const color_0 = args_1[1];
        const amount_0 = args_1[2];
        const recipient_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        const envelope_0 = args_1[7];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1755 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1755 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1755 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1755 char 1',
                                     'struct UserAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1755 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1755 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1755 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 1755 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(color_0).concat(_descriptor_9.toValue(amount_0).concat(_descriptor_23.toValue(recipient_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_23.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment().concat(_descriptor_3.alignment()))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_unshielded_with_k256_0(context,
                                                                     partialProofData,
                                                                     color_0,
                                                                     amount_0,
                                                                     recipient_0,
                                                                     pk_0,
                                                                     use_counter_0,
                                                                     sig_0,
                                                                     envelope_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_unshielded_with_evm: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`withdraw_unshielded_with_evm: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const color_0 = args_1[1];
        const amount_0 = args_1[2];
        const recipient_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1771 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1771 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1771 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1771 char 1',
                                     'struct UserAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1771 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1771 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1771 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(color_0).concat(_descriptor_9.toValue(amount_0).concat(_descriptor_23.toValue(recipient_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0)))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_23.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_unshielded_with_evm_0(context,
                                                                    partialProofData,
                                                                    color_0,
                                                                    amount_0,
                                                                    recipient_0,
                                                                    pk_0,
                                                                    use_counter_0,
                                                                    sig_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      deposit_shielded: async (...args_1) => {
        if (args_1.length !== 3) {
          throw new __compactRuntime.CompactError(`deposit_shielded: expected 3 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const coin_0 = args_1[1];
        const entry_0 = args_1[2];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('deposit_shielded',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1797 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('deposit_shielded',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1797 char 1',
                                     'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                     coin_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('deposit_shielded',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1797 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_10.toValue(coin_0).concat(_descriptor_7.toValue(entry_0)),
            alignment: _descriptor_10.alignment().concat(_descriptor_7.alignment())
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._deposit_shielded_0(context,
                                                        partialProofData,
                                                        coin_0,
                                                        entry_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      append_inbox_with_jubjub: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`append_inbox_with_jubjub: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_r_0 = args_1[4];
        const sig_s_0 = args_1[5];
        const grind_nonce_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1808 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1808 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1808 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1808 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1808 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1808 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1808 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_7.toValue(entry_0).concat(_descriptor_19.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_19.toValue(sig_r_0).concat(_descriptor_20.toValue(sig_s_0).concat(_descriptor_13.toValue(grind_nonce_0)))))),
            alignment: _descriptor_7.alignment().concat(_descriptor_19.alignment().concat(_descriptor_13.alignment().concat(_descriptor_19.alignment().concat(_descriptor_20.alignment().concat(_descriptor_13.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._append_inbox_with_jubjub_0(context,
                                                                partialProofData,
                                                                entry_0,
                                                                pk_0,
                                                                use_counter_0,
                                                                sig_r_0,
                                                                sig_s_0,
                                                                grind_nonce_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      append_inbox_with_k256: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`append_inbox_with_k256: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        const envelope_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('append_inbox_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1823 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('append_inbox_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1823 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('append_inbox_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1823 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('append_inbox_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1823 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('append_inbox_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1823 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('append_inbox_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1823 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_7.toValue(entry_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))),
            alignment: _descriptor_7.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment().concat(_descriptor_3.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._append_inbox_with_k256_0(context,
                                                              partialProofData,
                                                              entry_0,
                                                              pk_0,
                                                              use_counter_0,
                                                              sig_0,
                                                              envelope_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      append_inbox_with_evm: async (...args_1) => {
        if (args_1.length !== 5) {
          throw new __compactRuntime.CompactError(`append_inbox_with_evm: expected 5 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('append_inbox_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1840 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('append_inbox_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1840 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('append_inbox_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1840 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('append_inbox_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1840 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('append_inbox_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1840 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_7.toValue(entry_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0)))),
            alignment: _descriptor_7.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment())))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._append_inbox_with_evm_0(context,
                                                             partialProofData,
                                                             entry_0,
                                                             pk_0,
                                                             use_counter_0,
                                                             sig_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_with_jubjub: async (...args_1) => {
        if (args_1.length !== 9) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_with_jubjub: expected 9 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_r_0 = args_1[6];
        const sig_s_0 = args_1[7];
        const grind_nonce_0 = args_1[8];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1864 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1864 char 1',
                                     'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1864 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1864 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1864 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1864 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1864 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 1864 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 1864 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_22.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_9.toValue(amount_0).concat(_descriptor_19.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_19.toValue(sig_r_0).concat(_descriptor_20.toValue(sig_s_0).concat(_descriptor_13.toValue(grind_nonce_0)))))))),
            alignment: _descriptor_22.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_19.alignment().concat(_descriptor_13.alignment().concat(_descriptor_19.alignment().concat(_descriptor_20.alignment().concat(_descriptor_13.alignment())))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_with_jubjub_0(context,
                                                                     partialProofData,
                                                                     recipient_0,
                                                                     color_0,
                                                                     amount_0,
                                                                     pk_0,
                                                                     use_counter_0,
                                                                     sig_r_0,
                                                                     sig_s_0,
                                                                     grind_nonce_0);
        partialProofData.output = { value: _descriptor_11.toValue(result_0), alignment: _descriptor_11.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_with_k256: async (...args_1) => {
        if (args_1.length !== 8) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_with_k256: expected 8 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        const envelope_0 = args_1[7];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_22.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_9.toValue(amount_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))))),
            alignment: _descriptor_22.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment().concat(_descriptor_3.alignment()))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_with_k256_0(context,
                                                                   partialProofData,
                                                                   recipient_0,
                                                                   color_0,
                                                                   amount_0,
                                                                   pk_0,
                                                                   use_counter_0,
                                                                   sig_0,
                                                                   envelope_0);
        partialProofData.output = { value: _descriptor_11.toValue(result_0), alignment: _descriptor_11.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_with_evm: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_with_evm: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1899 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1899 char 1',
                                     'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1899 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1899 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1899 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1899 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1899 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_22.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_9.toValue(amount_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0)))))),
            alignment: _descriptor_22.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_with_evm_0(context,
                                                                  partialProofData,
                                                                  recipient_0,
                                                                  color_0,
                                                                  amount_0,
                                                                  pk_0,
                                                                  use_counter_0,
                                                                  sig_0);
        partialProofData.output = { value: _descriptor_11.toValue(result_0), alignment: _descriptor_11.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_to_contract_with_jubjub: async (...args_1) => {
        if (args_1.length !== 9) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_to_contract_with_jubjub: expected 9 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_r_0 = args_1[6];
        const sig_s_0 = args_1[7];
        const grind_nonce_0 = args_1[8];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1937 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1937 char 1',
                                     'struct ContractAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1937 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1937 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1937 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1937 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1937 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 1937 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 1937 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_1.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_9.toValue(amount_0).concat(_descriptor_19.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_19.toValue(sig_r_0).concat(_descriptor_20.toValue(sig_s_0).concat(_descriptor_13.toValue(grind_nonce_0)))))))),
            alignment: _descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_19.alignment().concat(_descriptor_13.alignment().concat(_descriptor_19.alignment().concat(_descriptor_20.alignment().concat(_descriptor_13.alignment())))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_to_contract_with_jubjub_0(context,
                                                                                 partialProofData,
                                                                                 recipient_0,
                                                                                 color_0,
                                                                                 amount_0,
                                                                                 pk_0,
                                                                                 use_counter_0,
                                                                                 sig_r_0,
                                                                                 sig_s_0,
                                                                                 grind_nonce_0);
        partialProofData.output = { value: _descriptor_21.toValue(result_0), alignment: _descriptor_21.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_to_contract_with_k256: async (...args_1) => {
        if (args_1.length !== 8) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_to_contract_with_k256: expected 8 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        const envelope_0 = args_1[7];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'struct ContractAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_1.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_9.toValue(amount_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))))),
            alignment: _descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment().concat(_descriptor_3.alignment()))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_to_contract_with_k256_0(context,
                                                                               partialProofData,
                                                                               recipient_0,
                                                                               color_0,
                                                                               amount_0,
                                                                               pk_0,
                                                                               use_counter_0,
                                                                               sig_0,
                                                                               envelope_0);
        partialProofData.output = { value: _descriptor_21.toValue(result_0), alignment: _descriptor_21.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_to_contract_with_evm: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_to_contract_with_evm: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1972 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1972 char 1',
                                     'struct ContractAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1972 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1972 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1972 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1972 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1972 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_1.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_9.toValue(amount_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0)))))),
            alignment: _descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_to_contract_with_evm_0(context,
                                                                              partialProofData,
                                                                              recipient_0,
                                                                              color_0,
                                                                              amount_0,
                                                                              pk_0,
                                                                              use_counter_0,
                                                                              sig_0);
        partialProofData.output = { value: _descriptor_21.toValue(result_0), alignment: _descriptor_21.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      rotate_enc_key_with_jubjub: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`rotate_enc_key_with_jubjub: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_key_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_r_0 = args_1[4];
        const sig_s_0 = args_1[5];
        const grind_nonce_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1999 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1999 char 1',
                                     'Bytes<32>',
                                     new_key_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1999 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1999 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1999 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1999 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1999 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_key_0).concat(_descriptor_19.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_19.toValue(sig_r_0).concat(_descriptor_20.toValue(sig_s_0).concat(_descriptor_13.toValue(grind_nonce_0)))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_19.alignment().concat(_descriptor_13.alignment().concat(_descriptor_19.alignment().concat(_descriptor_20.alignment().concat(_descriptor_13.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._rotate_enc_key_with_jubjub_0(context,
                                                                  partialProofData,
                                                                  new_key_0,
                                                                  pk_0,
                                                                  use_counter_0,
                                                                  sig_r_0,
                                                                  sig_s_0,
                                                                  grind_nonce_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      rotate_enc_key_with_k256: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`rotate_enc_key_with_k256: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_key_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        const envelope_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('rotate_enc_key_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2014 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
          __compactRuntime.typeError('rotate_enc_key_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2014 char 1',
                                     'Bytes<32>',
                                     new_key_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('rotate_enc_key_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2014 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('rotate_enc_key_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2014 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('rotate_enc_key_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2014 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('rotate_enc_key_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2014 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_key_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment().concat(_descriptor_3.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._rotate_enc_key_with_k256_0(context,
                                                                partialProofData,
                                                                new_key_0,
                                                                pk_0,
                                                                use_counter_0,
                                                                sig_0,
                                                                envelope_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      rotate_enc_key_with_evm: async (...args_1) => {
        if (args_1.length !== 5) {
          throw new __compactRuntime.CompactError(`rotate_enc_key_with_evm: expected 5 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_key_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('rotate_enc_key_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2028 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
          __compactRuntime.typeError('rotate_enc_key_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2028 char 1',
                                     'Bytes<32>',
                                     new_key_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('rotate_enc_key_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2028 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('rotate_enc_key_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2028 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('rotate_enc_key_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2028 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_key_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0)))),
            alignment: _descriptor_0.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment())))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._rotate_enc_key_with_evm_0(context,
                                                               partialProofData,
                                                               new_key_0,
                                                               pk_0,
                                                               use_counter_0,
                                                               sig_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      add_device_with_jubjub: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`add_device_with_jubjub: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_r_0 = args_1[4];
        const sig_s_0 = args_1[5];
        const grind_nonce_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2111 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2111 char 1',
                                     'Bytes<32>',
                                     new_entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2111 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2111 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2111 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2111 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2111 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_entry_0).concat(_descriptor_19.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_19.toValue(sig_r_0).concat(_descriptor_20.toValue(sig_s_0).concat(_descriptor_13.toValue(grind_nonce_0)))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_19.alignment().concat(_descriptor_13.alignment().concat(_descriptor_19.alignment().concat(_descriptor_20.alignment().concat(_descriptor_13.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._add_device_with_jubjub_0(context,
                                                              partialProofData,
                                                              new_entry_0,
                                                              pk_0,
                                                              use_counter_0,
                                                              sig_r_0,
                                                              sig_s_0,
                                                              grind_nonce_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      add_device_with_k256: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`add_device_with_k256: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        const envelope_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('add_device_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2126 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
          __compactRuntime.typeError('add_device_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2126 char 1',
                                     'Bytes<32>',
                                     new_entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('add_device_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2126 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('add_device_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2126 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('add_device_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2126 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('add_device_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2126 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_entry_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment().concat(_descriptor_3.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._add_device_with_k256_0(context,
                                                            partialProofData,
                                                            new_entry_0,
                                                            pk_0,
                                                            use_counter_0,
                                                            sig_0,
                                                            envelope_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      add_device_with_evm: async (...args_1) => {
        if (args_1.length !== 5) {
          throw new __compactRuntime.CompactError(`add_device_with_evm: expected 5 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('add_device_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2140 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
          __compactRuntime.typeError('add_device_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2140 char 1',
                                     'Bytes<32>',
                                     new_entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('add_device_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2140 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('add_device_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2140 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('add_device_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2140 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_entry_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0)))),
            alignment: _descriptor_0.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment())))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._add_device_with_evm_0(context,
                                                           partialProofData,
                                                           new_entry_0,
                                                           pk_0,
                                                           use_counter_0,
                                                           sig_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      remove_device_with_jubjub: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`remove_device_with_jubjub: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_r_0 = args_1[4];
        const sig_s_0 = args_1[5];
        const grind_nonce_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2163 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2163 char 1',
                                     'Bytes<32>',
                                     entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2163 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2163 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2163 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2163 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2163 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(entry_0).concat(_descriptor_19.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_19.toValue(sig_r_0).concat(_descriptor_20.toValue(sig_s_0).concat(_descriptor_13.toValue(grind_nonce_0)))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_19.alignment().concat(_descriptor_13.alignment().concat(_descriptor_19.alignment().concat(_descriptor_20.alignment().concat(_descriptor_13.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._remove_device_with_jubjub_0(context,
                                                                 partialProofData,
                                                                 entry_0,
                                                                 pk_0,
                                                                 use_counter_0,
                                                                 sig_r_0,
                                                                 sig_s_0,
                                                                 grind_nonce_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      remove_device_with_k256: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`remove_device_with_k256: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        const envelope_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('remove_device_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2182 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
          __compactRuntime.typeError('remove_device_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2182 char 1',
                                     'Bytes<32>',
                                     entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('remove_device_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2182 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('remove_device_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2182 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('remove_device_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2182 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('remove_device_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2182 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(entry_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment().concat(_descriptor_3.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._remove_device_with_k256_0(context,
                                                               partialProofData,
                                                               entry_0,
                                                               pk_0,
                                                               use_counter_0,
                                                               sig_0,
                                                               envelope_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      remove_device_with_evm: async (...args_1) => {
        if (args_1.length !== 5) {
          throw new __compactRuntime.CompactError(`remove_device_with_evm: expected 5 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('remove_device_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2200 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
          __compactRuntime.typeError('remove_device_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2200 char 1',
                                     'Bytes<32>',
                                     entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('remove_device_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2200 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('remove_device_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2200 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('remove_device_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2200 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(entry_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0)))),
            alignment: _descriptor_0.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment())))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._remove_device_with_evm_0(context,
                                                              partialProofData,
                                                              entry_0,
                                                              pk_0,
                                                              use_counter_0,
                                                              sig_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      open_swap_shielded_with_jubjub: async (...args_1) => {
        if (args_1.length !== 14) {
          throw new __compactRuntime.CompactError(`open_swap_shielded_with_jubjub: expected 14 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const give_color_0 = args_1[1];
        const give_amount_0 = args_1[2];
        const recipient_kind_0 = args_1[3];
        const recipient_0 = args_1[4];
        const want_0 = args_1[5];
        const want_entry_0 = args_1[6];
        const change_entry_0 = args_1[7];
        const valid_until_0 = args_1[8];
        const pk_0 = args_1[9];
        const use_counter_0 = args_1[10];
        const sig_r_0 = args_1[11];
        const sig_s_0 = args_1[12];
        const grind_nonce_0 = args_1[13];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'Bytes<32>',
                                     give_color_0)
        }
        if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     give_amount_0)
        }
        if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'Uint<0..256>',
                                     recipient_kind_0)
        }
        if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'Bytes<32>',
                                     recipient_0)
        }
        if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                     want_0)
        }
        if (!(want_entry_0.buffer instanceof ArrayBuffer && want_entry_0.BYTES_PER_ELEMENT === 1 && want_entry_0.length === 192)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'Bytes<192>',
                                     want_entry_0)
        }
        if (!(change_entry_0.buffer instanceof ArrayBuffer && change_entry_0.BYTES_PER_ELEMENT === 1 && change_entry_0.length === 192)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'Bytes<192>',
                                     change_entry_0)
        }
        if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'Uint<0..18446744073709551616>',
                                     valid_until_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 9 (argument 10 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 10 (argument 11 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 11 (argument 12 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 12 (argument 13 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 13 (argument 14 as invoked from Typescript)',
                                     'account.compact line 2246 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(give_color_0).concat(_descriptor_9.toValue(give_amount_0).concat(_descriptor_3.toValue(recipient_kind_0).concat(_descriptor_0.toValue(recipient_0).concat(_descriptor_10.toValue(want_0).concat(_descriptor_7.toValue(want_entry_0).concat(_descriptor_7.toValue(change_entry_0).concat(_descriptor_13.toValue(valid_until_0).concat(_descriptor_19.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_19.toValue(sig_r_0).concat(_descriptor_20.toValue(sig_s_0).concat(_descriptor_13.toValue(grind_nonce_0))))))))))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_3.alignment().concat(_descriptor_0.alignment().concat(_descriptor_10.alignment().concat(_descriptor_7.alignment().concat(_descriptor_7.alignment().concat(_descriptor_13.alignment().concat(_descriptor_19.alignment().concat(_descriptor_13.alignment().concat(_descriptor_19.alignment().concat(_descriptor_20.alignment().concat(_descriptor_13.alignment()))))))))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._open_swap_shielded_with_jubjub_0(context,
                                                                      partialProofData,
                                                                      give_color_0,
                                                                      give_amount_0,
                                                                      recipient_kind_0,
                                                                      recipient_0,
                                                                      want_0,
                                                                      want_entry_0,
                                                                      change_entry_0,
                                                                      valid_until_0,
                                                                      pk_0,
                                                                      use_counter_0,
                                                                      sig_r_0,
                                                                      sig_s_0,
                                                                      grind_nonce_0);
        partialProofData.output = { value: _descriptor_11.toValue(result_0), alignment: _descriptor_11.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      open_swap_shielded_with_evm: async (...args_1) => {
        if (args_1.length !== 12) {
          throw new __compactRuntime.CompactError(`open_swap_shielded_with_evm: expected 12 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const give_color_0 = args_1[1];
        const give_amount_0 = args_1[2];
        const recipient_kind_0 = args_1[3];
        const recipient_0 = args_1[4];
        const want_0 = args_1[5];
        const want_entry_0 = args_1[6];
        const change_entry_0 = args_1[7];
        const valid_until_0 = args_1[8];
        const pk_0 = args_1[9];
        const use_counter_0 = args_1[10];
        const sig_0 = args_1[11];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2274 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2274 char 1',
                                     'Bytes<32>',
                                     give_color_0)
        }
        if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2274 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     give_amount_0)
        }
        if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2274 char 1',
                                     'Uint<0..256>',
                                     recipient_kind_0)
        }
        if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2274 char 1',
                                     'Bytes<32>',
                                     recipient_0)
        }
        if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2274 char 1',
                                     'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                     want_0)
        }
        if (!(want_entry_0.buffer instanceof ArrayBuffer && want_entry_0.BYTES_PER_ELEMENT === 1 && want_entry_0.length === 192)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2274 char 1',
                                     'Bytes<192>',
                                     want_entry_0)
        }
        if (!(change_entry_0.buffer instanceof ArrayBuffer && change_entry_0.BYTES_PER_ELEMENT === 1 && change_entry_0.length === 192)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 2274 char 1',
                                     'Bytes<192>',
                                     change_entry_0)
        }
        if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 2274 char 1',
                                     'Uint<0..18446744073709551616>',
                                     valid_until_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 9 (argument 10 as invoked from Typescript)',
                                     'account.compact line 2274 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 10 (argument 11 as invoked from Typescript)',
                                     'account.compact line 2274 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 11 (argument 12 as invoked from Typescript)',
                                     'account.compact line 2274 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(give_color_0).concat(_descriptor_9.toValue(give_amount_0).concat(_descriptor_3.toValue(recipient_kind_0).concat(_descriptor_0.toValue(recipient_0).concat(_descriptor_10.toValue(want_0).concat(_descriptor_7.toValue(want_entry_0).concat(_descriptor_7.toValue(change_entry_0).concat(_descriptor_13.toValue(valid_until_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0))))))))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_3.alignment().concat(_descriptor_0.alignment().concat(_descriptor_10.alignment().concat(_descriptor_7.alignment().concat(_descriptor_7.alignment().concat(_descriptor_13.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment()))))))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._open_swap_shielded_with_evm_0(context,
                                                                   partialProofData,
                                                                   give_color_0,
                                                                   give_amount_0,
                                                                   recipient_kind_0,
                                                                   recipient_0,
                                                                   want_0,
                                                                   want_entry_0,
                                                                   change_entry_0,
                                                                   valid_until_0,
                                                                   pk_0,
                                                                   use_counter_0,
                                                                   sig_0);
        partialProofData.output = { value: _descriptor_11.toValue(result_0), alignment: _descriptor_11.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      bridge_deposit_start_with_evm: async (...args_1) => {
        if (args_1.length !== 11) {
          throw new __compactRuntime.CompactError(`bridge_deposit_start_with_evm: expected 11 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const erc20_0 = args_1[1];
        const amount_0 = args_1[2];
        const evm_nonce_0 = args_1[3];
        const gas_limit_0 = args_1[4];
        const max_fee_0 = args_1[5];
        const max_priority_fee_0 = args_1[6];
        const key_version_0 = args_1[7];
        const pk_0 = args_1[8];
        const use_counter_0 = args_1[9];
        const sig_0 = args_1[10];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2347 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(erc20_0.buffer instanceof ArrayBuffer && erc20_0.BYTES_PER_ELEMENT === 1 && erc20_0.length === 20)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2347 char 1',
                                     'Bytes<20>',
                                     erc20_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2347 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2347 char 1',
                                     'Uint<0..18446744073709551616>',
                                     evm_nonce_0)
        }
        if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2347 char 1',
                                     'Uint<0..18446744073709551616>',
                                     gas_limit_0)
        }
        if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2347 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     max_fee_0)
        }
        if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2347 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     max_priority_fee_0)
        }
        if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 2347 char 1',
                                     'Uint<0..256>',
                                     key_version_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 2347 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 9 (argument 10 as invoked from Typescript)',
                                     'account.compact line 2347 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 10 (argument 11 as invoked from Typescript)',
                                     'account.compact line 2347 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_14.toValue(erc20_0).concat(_descriptor_9.toValue(amount_0).concat(_descriptor_13.toValue(evm_nonce_0).concat(_descriptor_13.toValue(gas_limit_0).concat(_descriptor_9.toValue(max_fee_0).concat(_descriptor_9.toValue(max_priority_fee_0).concat(_descriptor_3.toValue(key_version_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0)))))))))),
            alignment: _descriptor_14.alignment().concat(_descriptor_9.alignment().concat(_descriptor_13.alignment().concat(_descriptor_13.alignment().concat(_descriptor_9.alignment().concat(_descriptor_9.alignment().concat(_descriptor_3.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment())))))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._bridge_deposit_start_with_evm_0(context,
                                                                     partialProofData,
                                                                     erc20_0,
                                                                     amount_0,
                                                                     evm_nonce_0,
                                                                     gas_limit_0,
                                                                     max_fee_0,
                                                                     max_priority_fee_0,
                                                                     key_version_0,
                                                                     pk_0,
                                                                     use_counter_0,
                                                                     sig_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      bridge_deposit_complete: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`bridge_deposit_complete: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const request_id_0 = args_1[1];
        const attestation_0 = args_1[2];
        const output_0 = args_1[3];
        const mint_nonce_0 = args_1[4];
        const entry_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('bridge_deposit_complete',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2394 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(request_id_0.buffer instanceof ArrayBuffer && request_id_0.BYTES_PER_ELEMENT === 1 && request_id_0.length === 32)) {
          __compactRuntime.typeError('bridge_deposit_complete',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2394 char 1',
                                     'Bytes<32>',
                                     request_id_0)
        }
        if (!(typeof(attestation_0) === 'object' && typeof(attestation_0.signature) === 'object' && typeof(attestation_0.signature.bigR) === 'object' && attestation_0.signature.bigR.x.buffer instanceof ArrayBuffer && attestation_0.signature.bigR.x.BYTES_PER_ELEMENT === 1 && attestation_0.signature.bigR.x.length === 32 && attestation_0.signature.bigR.y.buffer instanceof ArrayBuffer && attestation_0.signature.bigR.y.BYTES_PER_ELEMENT === 1 && attestation_0.signature.bigR.y.length === 32 && attestation_0.signature.s.buffer instanceof ArrayBuffer && attestation_0.signature.s.BYTES_PER_ELEMENT === 1 && attestation_0.signature.s.length === 32 && typeof(attestation_0.signature.recoveryId) === 'bigint' && attestation_0.signature.recoveryId >= 0n && attestation_0.signature.recoveryId <= 255n)) {
          __compactRuntime.typeError('bridge_deposit_complete',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2394 char 1',
                                     'struct RespondBidirectionalEvent<signature: struct Signature<bigR: struct AffinePoint<x: Bytes<32>, y: Bytes<32>>, s: Bytes<32>, recoveryId: Uint<0..256>>>',
                                     attestation_0)
        }
        if (!(output_0.buffer instanceof ArrayBuffer && output_0.BYTES_PER_ELEMENT === 1 && output_0.length === 1)) {
          __compactRuntime.typeError('bridge_deposit_complete',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2394 char 1',
                                     'Bytes<1>',
                                     output_0)
        }
        if (!(mint_nonce_0.buffer instanceof ArrayBuffer && mint_nonce_0.BYTES_PER_ELEMENT === 1 && mint_nonce_0.length === 32)) {
          __compactRuntime.typeError('bridge_deposit_complete',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2394 char 1',
                                     'Bytes<32>',
                                     mint_nonce_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('bridge_deposit_complete',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2394 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(request_id_0).concat(_descriptor_5.toValue(attestation_0).concat(_descriptor_6.toValue(output_0).concat(_descriptor_0.toValue(mint_nonce_0).concat(_descriptor_7.toValue(entry_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_5.alignment().concat(_descriptor_6.alignment().concat(_descriptor_0.alignment().concat(_descriptor_7.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._bridge_deposit_complete_0(context,
                                                               partialProofData,
                                                               request_id_0,
                                                               attestation_0,
                                                               output_0,
                                                               mint_nonce_0,
                                                               entry_0);
        partialProofData.output = { value: _descriptor_11.toValue(result_0), alignment: _descriptor_11.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      bridge_withdraw_start_with_evm: async (...args_1) => {
        if (args_1.length !== 14) {
          throw new __compactRuntime.CompactError(`bridge_withdraw_start_with_evm: expected 14 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const dest_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const evm_nonce_0 = args_1[4];
        const gas_limit_0 = args_1[5];
        const max_fee_0 = args_1[6];
        const max_priority_fee_0 = args_1[7];
        const key_version_0 = args_1[8];
        const erc20_0 = args_1[9];
        const change_entry_0 = args_1[10];
        const pk_0 = args_1[11];
        const use_counter_0 = args_1[12];
        const sig_0 = args_1[13];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(dest_0.buffer instanceof ArrayBuffer && dest_0.BYTES_PER_ELEMENT === 1 && dest_0.length === 20)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'Bytes<20>',
                                     dest_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'Uint<0..18446744073709551616>',
                                     evm_nonce_0)
        }
        if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'Uint<0..18446744073709551616>',
                                     gas_limit_0)
        }
        if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     max_fee_0)
        }
        if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     max_priority_fee_0)
        }
        if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'Uint<0..256>',
                                     key_version_0)
        }
        if (!(erc20_0.buffer instanceof ArrayBuffer && erc20_0.BYTES_PER_ELEMENT === 1 && erc20_0.length === 20)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 9 (argument 10 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'Bytes<20>',
                                     erc20_0)
        }
        if (!(change_entry_0.buffer instanceof ArrayBuffer && change_entry_0.BYTES_PER_ELEMENT === 1 && change_entry_0.length === 192)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 10 (argument 11 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'Bytes<192>',
                                     change_entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 11 (argument 12 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 12 (argument 13 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 13 (argument 14 as invoked from Typescript)',
                                     'account.compact line 2432 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_14.toValue(dest_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_9.toValue(amount_0).concat(_descriptor_13.toValue(evm_nonce_0).concat(_descriptor_13.toValue(gas_limit_0).concat(_descriptor_9.toValue(max_fee_0).concat(_descriptor_9.toValue(max_priority_fee_0).concat(_descriptor_3.toValue(key_version_0).concat(_descriptor_14.toValue(erc20_0).concat(_descriptor_7.toValue(change_entry_0).concat(_descriptor_15.toValue(pk_0).concat(_descriptor_13.toValue(use_counter_0).concat(_descriptor_17.toValue(sig_0))))))))))))),
            alignment: _descriptor_14.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_13.alignment().concat(_descriptor_13.alignment().concat(_descriptor_9.alignment().concat(_descriptor_9.alignment().concat(_descriptor_3.alignment().concat(_descriptor_14.alignment().concat(_descriptor_7.alignment().concat(_descriptor_15.alignment().concat(_descriptor_13.alignment().concat(_descriptor_17.alignment()))))))))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._bridge_withdraw_start_with_evm_0(context,
                                                                      partialProofData,
                                                                      dest_0,
                                                                      color_0,
                                                                      amount_0,
                                                                      evm_nonce_0,
                                                                      gas_limit_0,
                                                                      max_fee_0,
                                                                      max_priority_fee_0,
                                                                      key_version_0,
                                                                      erc20_0,
                                                                      change_entry_0,
                                                                      pk_0,
                                                                      use_counter_0,
                                                                      sig_0);
        partialProofData.output = { value: _descriptor_11.toValue(result_0), alignment: _descriptor_11.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      bridge_withdraw_complete: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`bridge_withdraw_complete: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const request_id_0 = args_1[1];
        const attestation_0 = args_1[2];
        const output_0 = args_1[3];
        const mint_nonce_0 = args_1[4];
        const entry_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('bridge_withdraw_complete',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2490 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(request_id_0.buffer instanceof ArrayBuffer && request_id_0.BYTES_PER_ELEMENT === 1 && request_id_0.length === 32)) {
          __compactRuntime.typeError('bridge_withdraw_complete',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2490 char 1',
                                     'Bytes<32>',
                                     request_id_0)
        }
        if (!(typeof(attestation_0) === 'object' && typeof(attestation_0.signature) === 'object' && typeof(attestation_0.signature.bigR) === 'object' && attestation_0.signature.bigR.x.buffer instanceof ArrayBuffer && attestation_0.signature.bigR.x.BYTES_PER_ELEMENT === 1 && attestation_0.signature.bigR.x.length === 32 && attestation_0.signature.bigR.y.buffer instanceof ArrayBuffer && attestation_0.signature.bigR.y.BYTES_PER_ELEMENT === 1 && attestation_0.signature.bigR.y.length === 32 && attestation_0.signature.s.buffer instanceof ArrayBuffer && attestation_0.signature.s.BYTES_PER_ELEMENT === 1 && attestation_0.signature.s.length === 32 && typeof(attestation_0.signature.recoveryId) === 'bigint' && attestation_0.signature.recoveryId >= 0n && attestation_0.signature.recoveryId <= 255n)) {
          __compactRuntime.typeError('bridge_withdraw_complete',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2490 char 1',
                                     'struct RespondBidirectionalEvent<signature: struct Signature<bigR: struct AffinePoint<x: Bytes<32>, y: Bytes<32>>, s: Bytes<32>, recoveryId: Uint<0..256>>>',
                                     attestation_0)
        }
        if (!(output_0.buffer instanceof ArrayBuffer && output_0.BYTES_PER_ELEMENT === 1 && output_0.length === 1)) {
          __compactRuntime.typeError('bridge_withdraw_complete',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2490 char 1',
                                     'Bytes<1>',
                                     output_0)
        }
        if (!(mint_nonce_0.buffer instanceof ArrayBuffer && mint_nonce_0.BYTES_PER_ELEMENT === 1 && mint_nonce_0.length === 32)) {
          __compactRuntime.typeError('bridge_withdraw_complete',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2490 char 1',
                                     'Bytes<32>',
                                     mint_nonce_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('bridge_withdraw_complete',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2490 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(request_id_0).concat(_descriptor_5.toValue(attestation_0).concat(_descriptor_6.toValue(output_0).concat(_descriptor_0.toValue(mint_nonce_0).concat(_descriptor_7.toValue(entry_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_5.alignment().concat(_descriptor_6.alignment().concat(_descriptor_0.alignment().concat(_descriptor_7.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._bridge_withdraw_complete_0(context,
                                                                partialProofData,
                                                                request_id_0,
                                                                attestation_0,
                                                                output_0,
                                                                mint_nonce_0,
                                                                entry_0);
        partialProofData.output = { value: _descriptor_11.toValue(result_0), alignment: _descriptor_11.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      bridge_withdraw_refund: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`bridge_withdraw_refund: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const request_id_0 = args_1[1];
        const attestation_0 = args_1[2];
        const output_0 = args_1[3];
        const mint_nonce_0 = args_1[4];
        const entry_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('bridge_withdraw_refund',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2520 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(request_id_0.buffer instanceof ArrayBuffer && request_id_0.BYTES_PER_ELEMENT === 1 && request_id_0.length === 32)) {
          __compactRuntime.typeError('bridge_withdraw_refund',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2520 char 1',
                                     'Bytes<32>',
                                     request_id_0)
        }
        if (!(typeof(attestation_0) === 'object' && typeof(attestation_0.signature) === 'object' && typeof(attestation_0.signature.bigR) === 'object' && attestation_0.signature.bigR.x.buffer instanceof ArrayBuffer && attestation_0.signature.bigR.x.BYTES_PER_ELEMENT === 1 && attestation_0.signature.bigR.x.length === 32 && attestation_0.signature.bigR.y.buffer instanceof ArrayBuffer && attestation_0.signature.bigR.y.BYTES_PER_ELEMENT === 1 && attestation_0.signature.bigR.y.length === 32 && attestation_0.signature.s.buffer instanceof ArrayBuffer && attestation_0.signature.s.BYTES_PER_ELEMENT === 1 && attestation_0.signature.s.length === 32 && typeof(attestation_0.signature.recoveryId) === 'bigint' && attestation_0.signature.recoveryId >= 0n && attestation_0.signature.recoveryId <= 255n)) {
          __compactRuntime.typeError('bridge_withdraw_refund',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2520 char 1',
                                     'struct RespondBidirectionalEvent<signature: struct Signature<bigR: struct AffinePoint<x: Bytes<32>, y: Bytes<32>>, s: Bytes<32>, recoveryId: Uint<0..256>>>',
                                     attestation_0)
        }
        if (!(output_0.buffer instanceof ArrayBuffer && output_0.BYTES_PER_ELEMENT === 1 && output_0.length === 5)) {
          __compactRuntime.typeError('bridge_withdraw_refund',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2520 char 1',
                                     'Bytes<5>',
                                     output_0)
        }
        if (!(mint_nonce_0.buffer instanceof ArrayBuffer && mint_nonce_0.BYTES_PER_ELEMENT === 1 && mint_nonce_0.length === 32)) {
          __compactRuntime.typeError('bridge_withdraw_refund',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2520 char 1',
                                     'Bytes<32>',
                                     mint_nonce_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('bridge_withdraw_refund',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2520 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(request_id_0).concat(_descriptor_5.toValue(attestation_0).concat(_descriptor_12.toValue(output_0).concat(_descriptor_0.toValue(mint_nonce_0).concat(_descriptor_7.toValue(entry_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_5.alignment().concat(_descriptor_12.alignment().concat(_descriptor_0.alignment().concat(_descriptor_7.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._bridge_withdraw_refund_0(context,
                                                              partialProofData,
                                                              request_id_0,
                                                              attestation_0,
                                                              output_0,
                                                              mint_nonce_0,
                                                              entry_0);
        partialProofData.output = { value: _descriptor_10.toValue(result_0), alignment: _descriptor_10.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      }
    };
    this.impureCircuits = {
      activate_initial_device_with_jubjub: this.circuits.activate_initial_device_with_jubjub,
      activate_initial_device_with_k256: this.circuits.activate_initial_device_with_k256,
      activate_initial_device_with_evm: this.circuits.activate_initial_device_with_evm,
      deposit_unshielded: this.circuits.deposit_unshielded,
      withdraw_unshielded_with_jubjub: this.circuits.withdraw_unshielded_with_jubjub,
      withdraw_unshielded_with_k256: this.circuits.withdraw_unshielded_with_k256,
      withdraw_unshielded_with_evm: this.circuits.withdraw_unshielded_with_evm,
      deposit_shielded: this.circuits.deposit_shielded,
      append_inbox_with_jubjub: this.circuits.append_inbox_with_jubjub,
      append_inbox_with_k256: this.circuits.append_inbox_with_k256,
      append_inbox_with_evm: this.circuits.append_inbox_with_evm,
      withdraw_shielded_with_jubjub: this.circuits.withdraw_shielded_with_jubjub,
      withdraw_shielded_with_k256: this.circuits.withdraw_shielded_with_k256,
      withdraw_shielded_with_evm: this.circuits.withdraw_shielded_with_evm,
      withdraw_shielded_to_contract_with_jubjub: this.circuits.withdraw_shielded_to_contract_with_jubjub,
      withdraw_shielded_to_contract_with_k256: this.circuits.withdraw_shielded_to_contract_with_k256,
      withdraw_shielded_to_contract_with_evm: this.circuits.withdraw_shielded_to_contract_with_evm,
      rotate_enc_key_with_jubjub: this.circuits.rotate_enc_key_with_jubjub,
      rotate_enc_key_with_k256: this.circuits.rotate_enc_key_with_k256,
      rotate_enc_key_with_evm: this.circuits.rotate_enc_key_with_evm,
      add_device_with_jubjub: this.circuits.add_device_with_jubjub,
      add_device_with_k256: this.circuits.add_device_with_k256,
      add_device_with_evm: this.circuits.add_device_with_evm,
      remove_device_with_jubjub: this.circuits.remove_device_with_jubjub,
      remove_device_with_k256: this.circuits.remove_device_with_k256,
      remove_device_with_evm: this.circuits.remove_device_with_evm,
      open_swap_shielded_with_jubjub: this.circuits.open_swap_shielded_with_jubjub,
      open_swap_shielded_with_evm: this.circuits.open_swap_shielded_with_evm,
      bridge_deposit_start_with_evm: this.circuits.bridge_deposit_start_with_evm,
      bridge_deposit_complete: this.circuits.bridge_deposit_complete,
      bridge_withdraw_start_with_evm: this.circuits.bridge_withdraw_start_with_evm,
      bridge_withdraw_complete: this.circuits.bridge_withdraw_complete,
      bridge_withdraw_refund: this.circuits.bridge_withdraw_refund
    };
    this.provableCircuits = {
      activate_initial_device_with_jubjub: this.circuits.activate_initial_device_with_jubjub,
      activate_initial_device_with_k256: this.circuits.activate_initial_device_with_k256,
      activate_initial_device_with_evm: this.circuits.activate_initial_device_with_evm,
      deposit_unshielded: this.circuits.deposit_unshielded,
      withdraw_unshielded_with_jubjub: this.circuits.withdraw_unshielded_with_jubjub,
      withdraw_unshielded_with_k256: this.circuits.withdraw_unshielded_with_k256,
      withdraw_unshielded_with_evm: this.circuits.withdraw_unshielded_with_evm,
      deposit_shielded: this.circuits.deposit_shielded,
      append_inbox_with_jubjub: this.circuits.append_inbox_with_jubjub,
      append_inbox_with_k256: this.circuits.append_inbox_with_k256,
      append_inbox_with_evm: this.circuits.append_inbox_with_evm,
      withdraw_shielded_with_jubjub: this.circuits.withdraw_shielded_with_jubjub,
      withdraw_shielded_with_k256: this.circuits.withdraw_shielded_with_k256,
      withdraw_shielded_with_evm: this.circuits.withdraw_shielded_with_evm,
      withdraw_shielded_to_contract_with_jubjub: this.circuits.withdraw_shielded_to_contract_with_jubjub,
      withdraw_shielded_to_contract_with_k256: this.circuits.withdraw_shielded_to_contract_with_k256,
      withdraw_shielded_to_contract_with_evm: this.circuits.withdraw_shielded_to_contract_with_evm,
      rotate_enc_key_with_jubjub: this.circuits.rotate_enc_key_with_jubjub,
      rotate_enc_key_with_k256: this.circuits.rotate_enc_key_with_k256,
      rotate_enc_key_with_evm: this.circuits.rotate_enc_key_with_evm,
      add_device_with_jubjub: this.circuits.add_device_with_jubjub,
      add_device_with_k256: this.circuits.add_device_with_k256,
      add_device_with_evm: this.circuits.add_device_with_evm,
      remove_device_with_jubjub: this.circuits.remove_device_with_jubjub,
      remove_device_with_k256: this.circuits.remove_device_with_k256,
      remove_device_with_evm: this.circuits.remove_device_with_evm,
      open_swap_shielded_with_jubjub: this.circuits.open_swap_shielded_with_jubjub,
      open_swap_shielded_with_evm: this.circuits.open_swap_shielded_with_evm,
      bridge_deposit_start_with_evm: this.circuits.bridge_deposit_start_with_evm,
      bridge_deposit_complete: this.circuits.bridge_deposit_complete,
      bridge_withdraw_start_with_evm: this.circuits.bridge_withdraw_start_with_evm,
      bridge_withdraw_complete: this.circuits.bridge_withdraw_complete,
      bridge_withdraw_refund: this.circuits.bridge_withdraw_refund
    };
  }
  async initialState(...args_0) {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`Contract state constructor: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const constructorContext_0 = args_0[0];
    const initial_device_boot_0 = args_0[1];
    const encryption_key_0 = args_0[2];
    const evm_domain_0 = args_0[3];
    const vault_ref_0 = args_0[4];
    const vault_addr_0 = args_0[5];
    if (typeof(constructorContext_0) !== 'object') {
      throw new __compactRuntime.CompactError(`Contract state constructor: expected 'constructorContext' in argument 1 (as invoked from Typescript) to be an object`);
    }
    if (!('initialPrivateState' in constructorContext_0)) {
      throw new __compactRuntime.CompactError(`Contract state constructor: expected 'initialPrivateState' in argument 1 (as invoked from Typescript)`);
    }
    if (!('initialZswapLocalState' in constructorContext_0)) {
      throw new __compactRuntime.CompactError(`Contract state constructor: expected 'initialZswapLocalState' in argument 1 (as invoked from Typescript)`);
    }
    if (typeof(constructorContext_0.initialZswapLocalState) !== 'object') {
      throw new __compactRuntime.CompactError(`Contract state constructor: expected 'initialZswapLocalState' in argument 1 (as invoked from Typescript) to be an object`);
    }
    if (!(initial_device_boot_0.buffer instanceof ArrayBuffer && initial_device_boot_0.BYTES_PER_ELEMENT === 1 && initial_device_boot_0.length === 32)) {
      __compactRuntime.typeError('Contract state constructor',
                                 'argument 1 (argument 2 as invoked from Typescript)',
                                 'account.compact line 472 char 1',
                                 'Bytes<32>',
                                 initial_device_boot_0)
    }
    if (!(encryption_key_0.buffer instanceof ArrayBuffer && encryption_key_0.BYTES_PER_ELEMENT === 1 && encryption_key_0.length === 32)) {
      __compactRuntime.typeError('Contract state constructor',
                                 'argument 2 (argument 3 as invoked from Typescript)',
                                 'account.compact line 472 char 1',
                                 'Bytes<32>',
                                 encryption_key_0)
    }
    if (!(evm_domain_0.buffer instanceof ArrayBuffer && evm_domain_0.BYTES_PER_ELEMENT === 1 && evm_domain_0.length === 32)) {
      __compactRuntime.typeError('Contract state constructor',
                                 'argument 3 (argument 4 as invoked from Typescript)',
                                 'account.compact line 472 char 1',
                                 'Bytes<32>',
                                 evm_domain_0)
    }
    if (!(typeof(vault_ref_0) === 'object' && vault_ref_0.bytes.buffer instanceof ArrayBuffer && vault_ref_0.bytes.BYTES_PER_ELEMENT === 1 && vault_ref_0.bytes.length === 32)) {
      __compactRuntime.typeError('Contract state constructor',
                                 'argument 4 (argument 5 as invoked from Typescript)',
                                 'account.compact line 472 char 1',
                                 'contract Erc20Vault[startDeposit(Uint<0..18446744073709551616>, Uint<0..18446744073709551616>, Uint<0..340282366920938463463374607431768211456>, Uint<0..340282366920938463463374607431768211456>, Uint<0..256>, Bytes<20>, Uint<0..340282366920938463463374607431768211456>, struct Either<is_left: Boolean, left: struct ZswapCoinPublicKey<bytes: Bytes<32>>, right: struct ContractAddress<bytes: Bytes<32>>>): [], completeDeposit(Bytes<32>, struct RespondBidirectionalEvent<signature: struct Signature<bigR: struct AffinePoint<x: Bytes<32>, y: Bytes<32>>, s: Bytes<32>, recoveryId: Uint<0..256>>>, Bytes<1>, Bytes<32>): struct Maybe<is_some: Boolean, value: struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>>, startWithdraw(Uint<0..18446744073709551616>, Uint<0..18446744073709551616>, Uint<0..340282366920938463463374607431768211456>, Uint<0..340282366920938463463374607431768211456>, Uint<0..256>, Bytes<20>, Uint<0..340282366920938463463374607431768211456>, Bytes<20>, struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>, struct Either<is_left: Boolean, left: struct ZswapCoinPublicKey<bytes: Bytes<32>>, right: struct ContractAddress<bytes: Bytes<32>>>): [], completeWithdraw(Bytes<32>, struct RespondBidirectionalEvent<signature: struct Signature<bigR: struct AffinePoint<x: Bytes<32>, y: Bytes<32>>, s: Bytes<32>, recoveryId: Uint<0..256>>>, Bytes<1>, Bytes<32>): struct Maybe<is_some: Boolean, value: struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>>, refundWithdraw(Bytes<32>, struct RespondBidirectionalEvent<signature: struct Signature<bigR: struct AffinePoint<x: Bytes<32>, y: Bytes<32>>, s: Bytes<32>, recoveryId: Uint<0..256>>>, Bytes<5>, Bytes<32>): struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>]',
                                 vault_ref_0)
    }
    if (!(typeof(vault_addr_0) === 'object' && vault_addr_0.bytes.buffer instanceof ArrayBuffer && vault_addr_0.bytes.BYTES_PER_ELEMENT === 1 && vault_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('Contract state constructor',
                                 'argument 5 (argument 6 as invoked from Typescript)',
                                 'account.compact line 472 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 vault_addr_0)
    }
    const state_0 = new __compactRuntime.ContractState();
    let stateValue_0 = __compactRuntime.StateValue.newArray();
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    state_0.data = new __compactRuntime.ChargedState(stateValue_0);
    state_0.setOperation('activate_initial_device_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('activate_initial_device_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('activate_initial_device_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('deposit_unshielded', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_unshielded_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_unshielded_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_unshielded_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('deposit_shielded', new __compactRuntime.ContractOperation());
    state_0.setOperation('append_inbox_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('append_inbox_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('append_inbox_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_to_contract_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_to_contract_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_to_contract_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('rotate_enc_key_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('rotate_enc_key_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('rotate_enc_key_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('add_device_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('add_device_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('add_device_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('remove_device_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('remove_device_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('remove_device_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('open_swap_shielded_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('open_swap_shielded_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('bridge_deposit_start_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('bridge_deposit_complete', new __compactRuntime.ContractOperation());
    state_0.setOperation('bridge_withdraw_start_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('bridge_withdraw_complete', new __compactRuntime.ContractOperation());
    state_0.setOperation('bridge_withdraw_refund', new __compactRuntime.ContractOperation());
    const context = __compactRuntime.createCircuitContext('constructor', __compactRuntime.dummyContractAddress(), constructorContext_0.initialZswapLocalState.coinPublicKey, state_0.data, constructorContext_0.initialPrivateState);
    const partialProofData = {
      input: { value: [], alignment: [] },
      output: undefined,
      publicTranscript: [],
      privateTranscriptOutputs: []
    };
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(0n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(0n),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(1n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(new Uint8Array(32)),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(2n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newMap(
                                                          new __compactRuntime.StateMap()
                                                        ).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(3n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(0n),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(4n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newMap(
                                                          new __compactRuntime.StateMap()
                                                        ).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(5n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_18.toValue(0n),
                                                                                              alignment: _descriptor_18.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(6n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newMap(
                                                          new __compactRuntime.StateMap()
                                                        ).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(7n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_18.toValue(0n),
                                                                                              alignment: _descriptor_18.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(8n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(0n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(0n),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(10n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(new Uint8Array(32)),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(11n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_8.toValue(false),
                                                                                              alignment: _descriptor_8.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(12n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(new Uint8Array(32)),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(13n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_1.toValue({ bytes: new Uint8Array(32) }),
                                                                                              alignment: _descriptor_1.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(14n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_1.toValue({ bytes: new Uint8Array(32) }),
                                                                                              alignment: _descriptor_1.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    const tmp_0 = 0n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(0n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(tmp_0),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(1n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(encryption_key_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    const tmp_1 = 0n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(3n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(tmp_1),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    const tmp_2 = 1n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(5n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_18.toValue(tmp_2),
                                                                                              alignment: _descriptor_18.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(10n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(initial_device_boot_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(11n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_8.toValue(false),
                                                                                              alignment: _descriptor_8.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    const tmp_3 = 0n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(7n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_18.toValue(tmp_3),
                                                                                              alignment: _descriptor_18.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    const tmp_4 = 0n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(8n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(tmp_4),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    const tmp_5 = 0n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(tmp_5),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(12n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(evm_domain_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(13n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_1.toValue(vault_ref_0),
                                                                                              alignment: _descriptor_1.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(14n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_1.toValue(vault_addr_0),
                                                                                              alignment: _descriptor_1.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    state_0.data = new __compactRuntime.ChargedState(context.callContext.currentQueryContext.state.state);
    return {
      currentContractState: state_0,
      currentPrivateState: context.callContext.currentPrivateState,
      currentZswapLocalState: context.callContext.currentZswapLocalState
    }
  }
  _some_0(value_0) { return { is_some: true, value: value_0 }; }
  _none_0() {
    return { is_some: false,
             value:
               { nonce: new Uint8Array(32), color: new Uint8Array(32), value: 0n } };
  }
  _left_0(value_0) {
    return { is_left: true, left: value_0, right: new Uint8Array(32) };
  }
  _left_1(value_0) {
    return { is_left: true, left: value_0, right: { bytes: new Uint8Array(32) } };
  }
  _right_0(value_0) {
    return { is_left: false, left: { bytes: new Uint8Array(32) }, right: value_0 };
  }
  _right_1(value_0) {
    return { is_left: false, left: { bytes: new Uint8Array(32) }, right: value_0 };
  }
  _evolveNonce_0(index_0, nonce_0) {
    return this._upgradeFromTransient_0(this._transientHash_0([__compactRuntime.convertBytesToUint(52435875175126190479447740508185965837690552500527637822603658699938581184512n,
                                                                                                   28,
                                                                                                   new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 107, 101, 114, 110, 101, 108, 58, 110, 111, 110, 99, 101, 95, 101, 118, 111, 108, 118, 101]),
                                                                                                   'Field',
                                                                                                   '<standard library>'),
                                                               index_0,
                                                               this._degradeToTransient_0(nonce_0)]));
  }
  async _receiveShielded_0(context, partialProofData, coin_0) {
    const recipient_0 = this._right_1(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                partialProofData,
                                                                                                [
                                                                                                 { dup: { n: 2 } },
                                                                                                 { idx: { cached: true,
                                                                                                          pushPath: false,
                                                                                                          path: [
                                                                                                                 { tag: 'value',
                                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                 { popeq: { cached: true,
                                                                                                            result: undefined } }]).value));
    this._createZswapOutput_0(context, partialProofData, coin_0, recipient_0);
    const tmp_0 = this._coinCommitment_0(coin_0, recipient_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(1n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    return [];
  }
  async _sendShielded_0(context, partialProofData, input_0, recipient_0, value_0)
  {
    const selfAddr_0 = _descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                 partialProofData,
                                                                                 [
                                                                                  { dup: { n: 2 } },
                                                                                  { idx: { cached: true,
                                                                                           pushPath: false,
                                                                                           path: [
                                                                                                  { tag: 'value',
                                                                                                    value: { value: _descriptor_3.toValue(0n),
                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                  { popeq: { cached: true,
                                                                                             result: undefined } }]).value);
    this._createZswapInput_0(context, partialProofData, input_0);
    const tmp_0 = this._coinNullifier_0(this._downcastQualifiedCoin_0(input_0),
                                        selfAddr_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(0n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    let t_0;
    const change_0 = (t_0 = input_0.value,
                      (__compactRuntime.assert(t_0 >= value_0,
                                               'result of subtraction would be negative'),
                       t_0 - value_0));
    const output_0 = { nonce:
                         this._upgradeFromTransient_0(this._transientHash_1([__compactRuntime.convertBytesToUint(52435875175126190479447740508185965837690552500527637822603658699938581184512n,
                                                                                                                 28,
                                                                                                                 new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 107, 101, 114, 110, 101, 108, 58, 110, 111, 110, 99, 101, 95, 101, 118, 111, 108, 118, 101]),
                                                                                                                 'Field',
                                                                                                                 '<standard library>'),
                                                                             this._degradeToTransient_0(input_0.nonce)])),
                       color: input_0.color,
                       value: value_0 };
    this._createZswapOutput_0(context, partialProofData, output_0, recipient_0);
    const tmp_1 = this._coinCommitment_0(output_0, recipient_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(2n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_1),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    if (!recipient_0.is_left
        &&
        this._equal_0(recipient_0.right.bytes, selfAddr_0.bytes))
    {
      const tmp_2 = this._coinCommitment_0(output_0, recipient_0);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(1n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_2),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newNull().encode() } },
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
    }
    if (change_0 === 0n) {
      return { change: this._none_0(), sent: output_0 };
    } else {
      const changeCoin_0 = { nonce:
                               this._upgradeFromTransient_0(this._transientHash_1([__compactRuntime.convertBytesToUint(52435875175126190479447740508185965837690552500527637822603658699938581184512n,
                                                                                                                       30,
                                                                                                                       new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 107, 101, 114, 110, 101, 108, 58, 110, 111, 110, 99, 101, 95, 101, 118, 111, 108, 118, 101, 47, 50]),
                                                                                                                       'Field',
                                                                                                                       '<standard library>'),
                                                                                   this._degradeToTransient_0(input_0.nonce)])),
                             color: input_0.color,
                             value: change_0 };
      this._createZswapOutput_0(context,
                                partialProofData,
                                changeCoin_0,
                                this._right_1(selfAddr_0));
      const cm_0 = this._coinCommitment_0(changeCoin_0,
                                          this._right_1(selfAddr_0));
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(2n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(cm_0),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newNull().encode() } },
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(1n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(cm_0),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newNull().encode() } },
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
      return { change: this._some_0(changeCoin_0), sent: output_0 };
    }
  }
  _downcastQualifiedCoin_0(coin_0) {
    return { nonce: coin_0.nonce, color: coin_0.color, value: coin_0.value };
  }
  _coinCommitment_0(coin_0, recipient_0) {
    return this._persistentHash_28({ domain_sep:
                                       new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 122, 115, 119, 97, 112, 45, 99, 99, 91, 118, 49, 93]),
                                     info: coin_0,
                                     dataType: recipient_0.is_left,
                                     data:
                                       recipient_0.is_left ?
                                       recipient_0.left.bytes :
                                       recipient_0.right.bytes });
  }
  _coinNullifier_0(coin_0, addr_0) {
    return this._persistentHash_28({ domain_sep:
                                       new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 122, 115, 119, 97, 112, 45, 99, 110, 91, 118, 49, 93]),
                                     info: coin_0,
                                     dataType: false,
                                     data: addr_0.bytes });
  }
  async _blockTimeLt_0(context, partialProofData, time_0) {
    return _descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                     partialProofData,
                                                                     [
                                                                      { dup: { n: 2 } },
                                                                      { idx: { cached: true,
                                                                               pushPath: false,
                                                                               path: [
                                                                                      { tag: 'value',
                                                                                        value: { value: _descriptor_3.toValue(2n),
                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                      { push: { storage: false,
                                                                                value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(time_0),
                                                                                                                             alignment: _descriptor_13.alignment() }).encode() } },
                                                                      'lt',
                                                                      { popeq: { cached: true,
                                                                                 result: undefined } }]).value);
  }
  async _sendUnshielded_0(context,
                          partialProofData,
                          color_0,
                          amount_0,
                          recipient_0)
  {
    const tmp_0 = this._left_0(color_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(7n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_69.toValue(tmp_0),
                                                                                              alignment: _descriptor_69.alignment() }).encode() } },
                                       { dup: { n: 1 } },
                                       { dup: { n: 1 } },
                                       'member',
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_9.toValue(amount_0),
                                                                                              alignment: _descriptor_9.alignment() }).encode() } },
                                       { swap: { n: 0 } },
                                       'neg',
                                       { branch: { skip: 4 } },
                                       { dup: { n: 2 } },
                                       { dup: { n: 2 } },
                                       { idx: { cached: true,
                                                pushPath: false,
                                                path: [ { tag: 'stack' }] } },
                                       'add',
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    const tmp_1 = this._left_0(color_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(8n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell(__compactRuntime.alignedConcat(
                                                                                              { value: _descriptor_69.toValue(tmp_1),
                                                                                                alignment: _descriptor_69.alignment() },
                                                                                              { value: _descriptor_70.toValue(recipient_0),
                                                                                                alignment: _descriptor_70.alignment() }
                                                                                            )).encode() } },
                                       { dup: { n: 1 } },
                                       { dup: { n: 1 } },
                                       'member',
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_9.toValue(amount_0),
                                                                                              alignment: _descriptor_9.alignment() }).encode() } },
                                       { swap: { n: 0 } },
                                       'neg',
                                       { branch: { skip: 4 } },
                                       { dup: { n: 2 } },
                                       { dup: { n: 2 } },
                                       { idx: { cached: true,
                                                pushPath: false,
                                                path: [ { tag: 'stack' }] } },
                                       'add',
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    if (recipient_0.is_left
        &&
        this._equal_1(recipient_0.left.bytes,
                      _descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 2 } },
                                                                                 { idx: { cached: true,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: true,
                                                                                            result: undefined } }]).value).bytes))
    {
      const tmp_2 = this._left_0(color_0);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(6n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_69.toValue(tmp_2),
                                                                                                alignment: _descriptor_69.alignment() }).encode() } },
                                         { dup: { n: 1 } },
                                         { dup: { n: 1 } },
                                         'member',
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_9.toValue(amount_0),
                                                                                                alignment: _descriptor_9.alignment() }).encode() } },
                                         { swap: { n: 0 } },
                                         'neg',
                                         { branch: { skip: 4 } },
                                         { dup: { n: 2 } },
                                         { dup: { n: 2 } },
                                         { idx: { cached: true,
                                                  pushPath: false,
                                                  path: [ { tag: 'stack' }] } },
                                         'add',
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
    }
    return [];
  }
  async _receiveUnshielded_0(context, partialProofData, color_0, amount_0) {
    const tmp_0 = this._left_0(color_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_69.toValue(tmp_0),
                                                                                              alignment: _descriptor_69.alignment() }).encode() } },
                                       { dup: { n: 1 } },
                                       { dup: { n: 1 } },
                                       'member',
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_9.toValue(amount_0),
                                                                                              alignment: _descriptor_9.alignment() }).encode() } },
                                       { swap: { n: 0 } },
                                       'neg',
                                       { branch: { skip: 4 } },
                                       { dup: { n: 2 } },
                                       { dup: { n: 2 } },
                                       { idx: { cached: true,
                                                pushPath: false,
                                                path: [ { tag: 'stack' }] } },
                                       'add',
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    return [];
  }
  _hashToSecp256k1Scalar_0(digest_0) {
    const v_0 = Array.from(digest_0, BigInt);
    const beReversed_0 = Uint8Array.from([v_0[31],
                                          v_0[30],
                                          v_0[29],
                                          v_0[28],
                                          v_0[27],
                                          v_0[26],
                                          v_0[25],
                                          v_0[24],
                                          v_0[23],
                                          v_0[22],
                                          v_0[21],
                                          v_0[20],
                                          v_0[19],
                                          v_0[18],
                                          v_0[17],
                                          v_0[16],
                                          v_0[15],
                                          v_0[14],
                                          v_0[13],
                                          v_0[12],
                                          v_0[11],
                                          v_0[10],
                                          v_0[9],
                                          v_0[8],
                                          v_0[7],
                                          v_0[6],
                                          v_0[5],
                                          v_0[4],
                                          v_0[3],
                                          v_0[2],
                                          v_0[1],
                                          v_0[0]],
                                         Number);
    return __compactRuntime.convertBytesToField(115792089237316195423570985008687907852837564279074904382605163141518161494336n,
                                                32,
                                                beReversed_0,
                                                'Secp256k1Scalar',
                                                '<standard library>');
  }
  _secp256k1EcdsaVerify_0(msgHash_0, sig_0, pk_0) {
    const z_0 = this._hashToSecp256k1Scalar_0(msgHash_0);
    const __compact_pattern_tmp1_0 = sig_0;
    const r_0 = __compact_pattern_tmp1_0.r;
    const s_0 = __compact_pattern_tmp1_0.s;
    const w_0 = this._inv_0(s_0);
    const u1_0 = __compactRuntime.secp256k1ScalarMul(z_0, w_0);
    const u2_0 = __compactRuntime.secp256k1ScalarMul(r_0, w_0);
    const point_0 = this._ecAdd_1(this._ecMulGenerator_1(u1_0),
                                  this._ecMul_1(pk_0, u2_0));
    return __compactRuntime.convertBytesToField(115792089237316195423570985008687907852837564279074904382605163141518161494336n,
                                                32,
                                                __compactRuntime.convertBigintToBytes(32,
                                                                                      this._secp256k1PointX_0(point_0),
                                                                                      '<standard library>'),
                                                'Secp256k1Scalar',
                                                '<standard library>')
           ===
           r_0;
  }
  _secp256k1BaseBigEndian_0(b_0) {
    const vec_0 = Array.from(__compactRuntime.convertBigintToBytes(32,
                                                                   b_0,
                                                                   '<standard library>'),
                             BigInt);
    return [vec_0[31],
            vec_0[30],
            vec_0[29],
            vec_0[28],
            vec_0[27],
            vec_0[26],
            vec_0[25],
            vec_0[24],
            vec_0[23],
            vec_0[22],
            vec_0[21],
            vec_0[20],
            vec_0[19],
            vec_0[18],
            vec_0[17],
            vec_0[16],
            vec_0[15],
            vec_0[14],
            vec_0[13],
            vec_0[12],
            vec_0[11],
            vec_0[10],
            vec_0[9],
            vec_0[8],
            vec_0[7],
            vec_0[6],
            vec_0[5],
            vec_0[4],
            vec_0[3],
            vec_0[2],
            vec_0[1],
            vec_0[0]];
  }
  _secp256k1EthereumAddress_0(pk_0) {
    __compactRuntime.assert(!this._equal_2(pk_0,
                                           ({x: 0n, y: 0n, identity: true})),
                            'Cannot compute the address for the point at infinity');
    const hash_0 = this._keccak256_0([this._secp256k1BaseBigEndian_0(this._secp256k1PointX_0(pk_0)),
                                      this._secp256k1BaseBigEndian_0(this._secp256k1PointY_0(pk_0))]);
    return ((e, i) => e.slice(i, i+20))(hash_0, Number(12n));
  }
  _transientHash_0(value_0) {
    const result_0 = __compactRuntime.transientHash(_descriptor_68, value_0);
    return result_0;
  }
  _transientHash_1(value_0) {
    const result_0 = __compactRuntime.transientHash(_descriptor_66, value_0);
    return result_0;
  }
  _persistentHash_0(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_67, value_0);
    return result_0;
  }
  _persistentHash_1(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_64, value_0);
    return result_0;
  }
  _persistentHash_2(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_65, value_0);
    return result_0;
  }
  _persistentHash_3(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_62, value_0);
    return result_0;
  }
  _persistentHash_4(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_63, value_0);
    return result_0;
  }
  _persistentHash_5(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_61, value_0);
    return result_0;
  }
  _persistentHash_6(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_0, value_0);
    return result_0;
  }
  _persistentHash_7(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_59, value_0);
    return result_0;
  }
  _persistentHash_8(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_60, value_0);
    return result_0;
  }
  _persistentHash_9(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_56, value_0);
    return result_0;
  }
  _persistentHash_10(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_57, value_0);
    return result_0;
  }
  _persistentHash_11(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_54, value_0);
    return result_0;
  }
  _persistentHash_12(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_55, value_0);
    return result_0;
  }
  _persistentHash_13(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_52, value_0);
    return result_0;
  }
  _persistentHash_14(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_53, value_0);
    return result_0;
  }
  _persistentHash_15(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_50, value_0);
    return result_0;
  }
  _persistentHash_16(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_51, value_0);
    return result_0;
  }
  _persistentHash_17(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_48, value_0);
    return result_0;
  }
  _persistentHash_18(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_49, value_0);
    return result_0;
  }
  _persistentHash_19(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_46, value_0);
    return result_0;
  }
  _persistentHash_20(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_47, value_0);
    return result_0;
  }
  _persistentHash_21(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_44, value_0);
    return result_0;
  }
  _persistentHash_22(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_45, value_0);
    return result_0;
  }
  _persistentHash_23(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_42, value_0);
    return result_0;
  }
  _persistentHash_24(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_43, value_0);
    return result_0;
  }
  _persistentHash_25(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_39, value_0);
    return result_0;
  }
  _persistentHash_26(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_41, value_0);
    return result_0;
  }
  _persistentHash_27(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_37, value_0);
    return result_0;
  }
  _persistentHash_28(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_38, value_0);
    return result_0;
  }
  _persistentHash_29(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_36, value_0);
    return result_0;
  }
  _degradeToTransient_0(x_0) {
    const result_0 = __compactRuntime.degradeToTransient(x_0);
    return result_0;
  }
  _upgradeFromTransient_0(x_0) {
    const result_0 = __compactRuntime.upgradeFromTransient(x_0);
    return result_0;
  }
  _keccak256_0(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_34, value_0);
    return result_0;
  }
  _keccak256_1(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_0, value_0);
    return result_0;
  }
  _keccak256_2(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_32, value_0);
    return result_0;
  }
  _keccak256_3(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_31, value_0);
    return result_0;
  }
  _keccak256_4(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_7, value_0);
    return result_0;
  }
  _keccak256_5(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_29, value_0);
    return result_0;
  }
  _keccak256_6(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_30, value_0);
    return result_0;
  }
  _keccak256_7(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_28, value_0);
    return result_0;
  }
  _ecAdd_0(a_0, b_0) {
    const result_0 = __compactRuntime.ecAdd(a_0, b_0);
    return result_0;
  }
  _ecMul_0(a_0, b_0) {
    const result_0 = __compactRuntime.ecMul(a_0, b_0);
    return result_0;
  }
  _ecMulGenerator_0(b_0) {
    const result_0 = __compactRuntime.ecMulGenerator(b_0);
    return result_0;
  }
  _createZswapInput_0(context, partialProofData, coin_0) {
    const result_0 = __compactRuntime.createZswapInput(context, coin_0);
    partialProofData.privateTranscriptOutputs.push({
      value: [],
      alignment: []
    });
    return result_0;
  }
  _createZswapOutput_0(context, partialProofData, coin_0, recipient_0) {
    const result_0 = __compactRuntime.createZswapOutput(context,
                                                        coin_0,
                                                        recipient_0);
    partialProofData.privateTranscriptOutputs.push({
      value: [],
      alignment: []
    });
    return result_0;
  }
  _inv_0(s_0) {
    const result_0 = __compactRuntime.secp256k1ScalarInv(s_0);
    return result_0;
  }
  _secp256k1PointX_0(pt_0) {
    const result_0 = __compactRuntime.secp256k1PointX(pt_0);
    return result_0;
  }
  _secp256k1PointY_0(pt_0) {
    const result_0 = __compactRuntime.secp256k1PointY(pt_0);
    return result_0;
  }
  _ecAdd_1(a_0, b_0) {
    const result_0 = __compactRuntime.secp256k1Add(a_0, b_0);
    return result_0;
  }
  _ecMul_1(a_0, b_0) {
    const result_0 = __compactRuntime.secp256k1Mul(a_0, b_0);
    return result_0;
  }
  _ecMulGenerator_1(b_0) {
    const result_0 = __compactRuntime.secp256k1MulGenerator(b_0);
    return result_0;
  }
  _domain_type_hash_0() {
    return Uint8Array.from([54n,
                            194n,
                            93n,
                            227n,
                            229n,
                            65n,
                            213n,
                            217n,
                            112n,
                            246n,
                            110n,
                            66n,
                            16n,
                            215n,
                            40n,
                            114n,
                            18n,
                            32n,
                            255n,
                            245n,
                            192n,
                            119n,
                            204n,
                            108n,
                            208n,
                            8n,
                            179n,
                            160n,
                            198n,
                            42n,
                            218n,
                            183n],
                           Number);
  }
  _domain_name_hash_0() {
    return Uint8Array.from([100n,
                            209n,
                            201n,
                            35n,
                            229n,
                            157n,
                            162n,
                            13n,
                            2n,
                            201n,
                            45n,
                            192n,
                            214n,
                            202n,
                            160n,
                            134n,
                            140n,
                            181n,
                            200n,
                            171n,
                            23n,
                            238n,
                            6n,
                            88n,
                            170n,
                            252n,
                            95n,
                            11n,
                            114n,
                            213n,
                            108n,
                            133n],
                           Number);
  }
  _domain_version_hash_0() {
    return Uint8Array.from([200n,
                            158n,
                            253n,
                            170n,
                            84n,
                            192n,
                            242n,
                            12n,
                            122n,
                            223n,
                            97n,
                            40n,
                            130n,
                            223n,
                            9n,
                            80n,
                            245n,
                            169n,
                            81n,
                            99n,
                            126n,
                            3n,
                            7n,
                            205n,
                            203n,
                            76n,
                            103n,
                            47n,
                            41n,
                            139n,
                            139n,
                            198n],
                           Number);
  }
  _type_hash_withdraw_unshielded_0() {
    return Uint8Array.from([58n,
                            172n,
                            195n,
                            110n,
                            139n,
                            24n,
                            204n,
                            253n,
                            159n,
                            65n,
                            97n,
                            41n,
                            187n,
                            137n,
                            24n,
                            177n,
                            127n,
                            62n,
                            241n,
                            233n,
                            15n,
                            81n,
                            131n,
                            181n,
                            213n,
                            47n,
                            145n,
                            192n,
                            253n,
                            187n,
                            45n,
                            248n],
                           Number);
  }
  _type_hash_withdraw_shielded_0() {
    return Uint8Array.from([127n,
                            200n,
                            19n,
                            97n,
                            70n,
                            150n,
                            150n,
                            206n,
                            28n,
                            133n,
                            21n,
                            103n,
                            62n,
                            92n,
                            44n,
                            175n,
                            168n,
                            194n,
                            88n,
                            161n,
                            74n,
                            31n,
                            138n,
                            186n,
                            55n,
                            55n,
                            48n,
                            248n,
                            133n,
                            52n,
                            2n,
                            182n],
                           Number);
  }
  _type_hash_withdraw_shielded_to_contract_0() {
    return Uint8Array.from([104n,
                            189n,
                            103n,
                            248n,
                            225n,
                            248n,
                            31n,
                            173n,
                            61n,
                            193n,
                            42n,
                            91n,
                            13n,
                            219n,
                            71n,
                            15n,
                            234n,
                            228n,
                            162n,
                            219n,
                            83n,
                            141n,
                            233n,
                            4n,
                            128n,
                            32n,
                            75n,
                            234n,
                            158n,
                            175n,
                            64n,
                            35n],
                           Number);
  }
  _type_hash_append_inbox_0() {
    return Uint8Array.from([62n,
                            107n,
                            196n,
                            66n,
                            244n,
                            143n,
                            164n,
                            41n,
                            201n,
                            78n,
                            230n,
                            55n,
                            13n,
                            162n,
                            246n,
                            176n,
                            209n,
                            7n,
                            141n,
                            225n,
                            102n,
                            182n,
                            98n,
                            184n,
                            14n,
                            248n,
                            119n,
                            252n,
                            17n,
                            179n,
                            229n,
                            82n],
                           Number);
  }
  _type_hash_rotate_enc_key_0() {
    return Uint8Array.from([90n,
                            44n,
                            49n,
                            193n,
                            138n,
                            84n,
                            184n,
                            132n,
                            148n,
                            136n,
                            188n,
                            174n,
                            90n,
                            242n,
                            41n,
                            59n,
                            220n,
                            222n,
                            16n,
                            24n,
                            120n,
                            228n,
                            195n,
                            110n,
                            120n,
                            61n,
                            170n,
                            96n,
                            161n,
                            41n,
                            82n,
                            161n],
                           Number);
  }
  _type_hash_add_device_0() {
    return Uint8Array.from([143n,
                            205n,
                            110n,
                            39n,
                            168n,
                            143n,
                            24n,
                            63n,
                            180n,
                            194n,
                            171n,
                            253n,
                            25n,
                            5n,
                            167n,
                            145n,
                            221n,
                            176n,
                            69n,
                            136n,
                            183n,
                            133n,
                            233n,
                            115n,
                            196n,
                            219n,
                            252n,
                            18n,
                            171n,
                            180n,
                            215n,
                            228n],
                           Number);
  }
  _type_hash_remove_device_0() {
    return Uint8Array.from([193n,
                            50n,
                            144n,
                            26n,
                            197n,
                            167n,
                            18n,
                            178n,
                            198n,
                            39n,
                            200n,
                            233n,
                            235n,
                            108n,
                            213n,
                            135n,
                            150n,
                            111n,
                            176n,
                            33n,
                            78n,
                            123n,
                            227n,
                            108n,
                            192n,
                            227n,
                            99n,
                            227n,
                            176n,
                            84n,
                            23n,
                            212n],
                           Number);
  }
  _type_hash_open_swap_shielded_0() {
    return Uint8Array.from([52n,
                            98n,
                            103n,
                            147n,
                            171n,
                            215n,
                            198n,
                            125n,
                            33n,
                            225n,
                            166n,
                            26n,
                            153n,
                            241n,
                            207n,
                            255n,
                            79n,
                            130n,
                            174n,
                            14n,
                            35n,
                            37n,
                            166n,
                            186n,
                            157n,
                            253n,
                            196n,
                            255n,
                            18n,
                            214n,
                            104n,
                            174n],
                           Number);
  }
  _type_hash_bridge_deposit_start_0() {
    return Uint8Array.from([103n,
                            55n,
                            198n,
                            139n,
                            32n,
                            211n,
                            223n,
                            43n,
                            32n,
                            182n,
                            101n,
                            60n,
                            123n,
                            105n,
                            152n,
                            54n,
                            49n,
                            174n,
                            231n,
                            32n,
                            127n,
                            216n,
                            30n,
                            64n,
                            20n,
                            189n,
                            38n,
                            139n,
                            1n,
                            118n,
                            37n,
                            238n],
                           Number);
  }
  _type_hash_bridge_withdraw_start_0() {
    return Uint8Array.from([127n,
                            202n,
                            95n,
                            59n,
                            156n,
                            97n,
                            215n,
                            155n,
                            236n,
                            239n,
                            240n,
                            159n,
                            178n,
                            16n,
                            22n,
                            136n,
                            167n,
                            66n,
                            46n,
                            234n,
                            171n,
                            37n,
                            5n,
                            177n,
                            88n,
                            184n,
                            7n,
                            96n,
                            194n,
                            120n,
                            178n,
                            96n],
                           Number);
  }
  _evm_account_alias_0(account_0) {
    return ((e, i) => e.slice(i, i+20))(this._keccak256_1(account_0),
                                        Number(12n));
  }
  _evm_domain_separator_for_0(account_0, salt_0) {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 160))([...Array.from(this._domain_type_hash_0(),
                                                                               BigInt),
                                                                 ...Array.from(this._domain_name_hash_0(),
                                                                               BigInt),
                                                                 ...Array.from(this._domain_version_hash_0(),
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(this._evm_account_alias_0(account_0)),
                                                                               BigInt),
                                                                 ...Array.from(salt_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_2(preimage_0);
  }
  _evm_struct_hash_withdraw_unshielded_0(account_0,
                                         owner_0,
                                         auth_nonce_value_0,
                                         color_0,
                                         amount_0,
                                         recipient_0,
                                         challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 256))([...Array.from(this._type_hash_withdraw_unshielded_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(color_0,
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(amount_0),
                                                                               BigInt),
                                                                 ...Array.from(recipient_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_3(preimage_0);
  }
  _evm_struct_hash_withdraw_shielded_0(account_0,
                                       owner_0,
                                       auth_nonce_value_0,
                                       color_0,
                                       amount_0,
                                       recipient_coin_public_key_0,
                                       challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 256))([...Array.from(this._type_hash_withdraw_shielded_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(color_0,
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(amount_0),
                                                                               BigInt),
                                                                 ...Array.from(recipient_coin_public_key_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_3(preimage_0);
  }
  _evm_struct_hash_withdraw_shielded_to_contract_0(account_0,
                                                   owner_0,
                                                   auth_nonce_value_0,
                                                   color_0,
                                                   amount_0,
                                                   recipient_contract_0,
                                                   challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 256))([...Array.from(this._type_hash_withdraw_shielded_to_contract_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(color_0,
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(amount_0),
                                                                               BigInt),
                                                                 ...Array.from(recipient_contract_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_3(preimage_0);
  }
  _evm_struct_hash_append_inbox_0(account_0,
                                  owner_0,
                                  auth_nonce_value_0,
                                  entry_hash_0,
                                  challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 192))([...Array.from(this._type_hash_append_inbox_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(entry_hash_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_4(preimage_0);
  }
  _evm_struct_hash_rotate_enc_key_0(account_0,
                                    owner_0,
                                    auth_nonce_value_0,
                                    new_key_0,
                                    challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 192))([...Array.from(this._type_hash_rotate_enc_key_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(new_key_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_4(preimage_0);
  }
  _evm_struct_hash_add_device_0(account_0,
                                owner_0,
                                auth_nonce_value_0,
                                new_entry_0,
                                challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 192))([...Array.from(this._type_hash_add_device_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(new_entry_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_4(preimage_0);
  }
  _evm_struct_hash_remove_device_0(account_0,
                                   owner_0,
                                   auth_nonce_value_0,
                                   entry_0,
                                   challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 192))([...Array.from(this._type_hash_remove_device_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(entry_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_4(preimage_0);
  }
  _evm_struct_hash_open_swap_shielded_0(account_0,
                                        owner_0,
                                        auth_nonce_value_0,
                                        give_color_0,
                                        give_amount_0,
                                        recipient_kind_0,
                                        recipient_0,
                                        want_nonce_0,
                                        want_color_0,
                                        want_amount_0,
                                        valid_until_0,
                                        challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 416))([...Array.from(this._type_hash_open_swap_shielded_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(give_color_0,
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(give_amount_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint8Word_0(recipient_kind_0),
                                                                               BigInt),
                                                                 ...Array.from(recipient_0,
                                                                               BigInt),
                                                                 ...Array.from(want_nonce_0,
                                                                               BigInt),
                                                                 ...Array.from(want_color_0,
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(want_amount_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(valid_until_0),
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_6(preimage_0);
  }
  _evm_struct_hash_bridge_deposit_start_0(account_0,
                                          owner_0,
                                          auth_nonce_value_0,
                                          erc20_0,
                                          amount_0,
                                          evm_nonce_0,
                                          gas_limit_0,
                                          max_fee_0,
                                          max_priority_fee_0,
                                          key_version_0,
                                          challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 384))([...Array.from(this._type_hash_bridge_deposit_start_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(erc20_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(amount_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(evm_nonce_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(gas_limit_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(max_fee_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(max_priority_fee_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint8Word_0(key_version_0),
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_5(preimage_0);
  }
  _evm_struct_hash_bridge_withdraw_start_0(account_0,
                                           owner_0,
                                           auth_nonce_value_0,
                                           dest_0,
                                           color_0,
                                           amount_0,
                                           evm_nonce_0,
                                           gas_limit_0,
                                           max_fee_0,
                                           max_priority_fee_0,
                                           key_version_0,
                                           challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 416))([...Array.from(this._type_hash_bridge_withdraw_start_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(dest_0),
                                                                               BigInt),
                                                                 ...Array.from(color_0,
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(amount_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(evm_nonce_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(gas_limit_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(max_fee_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(max_priority_fee_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint8Word_0(key_version_0),
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_6(preimage_0);
  }
  _eip712_digest_0(separator_0, struct_hash_0) {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 66))([25n,
                                                                1n,
                                                                ...Array.from(separator_0,
                                                                              BigInt),
                                                                ...Array.from(struct_hash_0,
                                                                              BigInt)]),
                                       Number);
    return this._keccak256_7(preimage_0);
  }
  _evm_digest_withdraw_unshielded_0(account_0,
                                    salt_0,
                                    owner_0,
                                    auth_nonce_value_0,
                                    color_0,
                                    amount_0,
                                    recipient_0,
                                    challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_withdraw_unshielded_0(account_0,
                                                                             owner_0,
                                                                             auth_nonce_value_0,
                                                                             color_0,
                                                                             amount_0,
                                                                             recipient_0,
                                                                             challenge_0));
  }
  _evm_digest_withdraw_shielded_0(account_0,
                                  salt_0,
                                  owner_0,
                                  auth_nonce_value_0,
                                  color_0,
                                  amount_0,
                                  recipient_coin_public_key_0,
                                  challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_withdraw_shielded_0(account_0,
                                                                           owner_0,
                                                                           auth_nonce_value_0,
                                                                           color_0,
                                                                           amount_0,
                                                                           recipient_coin_public_key_0,
                                                                           challenge_0));
  }
  _evm_digest_withdraw_shielded_to_contract_0(account_0,
                                              salt_0,
                                              owner_0,
                                              auth_nonce_value_0,
                                              color_0,
                                              amount_0,
                                              recipient_contract_0,
                                              challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_withdraw_shielded_to_contract_0(account_0,
                                                                                       owner_0,
                                                                                       auth_nonce_value_0,
                                                                                       color_0,
                                                                                       amount_0,
                                                                                       recipient_contract_0,
                                                                                       challenge_0));
  }
  _evm_digest_append_inbox_0(account_0,
                             salt_0,
                             owner_0,
                             auth_nonce_value_0,
                             entry_hash_0,
                             challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_append_inbox_0(account_0,
                                                                      owner_0,
                                                                      auth_nonce_value_0,
                                                                      entry_hash_0,
                                                                      challenge_0));
  }
  _evm_digest_rotate_enc_key_0(account_0,
                               salt_0,
                               owner_0,
                               auth_nonce_value_0,
                               new_key_0,
                               challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_rotate_enc_key_0(account_0,
                                                                        owner_0,
                                                                        auth_nonce_value_0,
                                                                        new_key_0,
                                                                        challenge_0));
  }
  _evm_digest_add_device_0(account_0,
                           salt_0,
                           owner_0,
                           auth_nonce_value_0,
                           new_entry_0,
                           challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_add_device_0(account_0,
                                                                    owner_0,
                                                                    auth_nonce_value_0,
                                                                    new_entry_0,
                                                                    challenge_0));
  }
  _evm_digest_open_swap_shielded_0(account_0,
                                   salt_0,
                                   owner_0,
                                   auth_nonce_value_0,
                                   give_color_0,
                                   give_amount_0,
                                   recipient_kind_0,
                                   recipient_0,
                                   want_nonce_0,
                                   want_color_0,
                                   want_amount_0,
                                   valid_until_0,
                                   challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_open_swap_shielded_0(account_0,
                                                                            owner_0,
                                                                            auth_nonce_value_0,
                                                                            give_color_0,
                                                                            give_amount_0,
                                                                            recipient_kind_0,
                                                                            recipient_0,
                                                                            want_nonce_0,
                                                                            want_color_0,
                                                                            want_amount_0,
                                                                            valid_until_0,
                                                                            challenge_0));
  }
  _evm_digest_remove_device_0(account_0,
                              salt_0,
                              owner_0,
                              auth_nonce_value_0,
                              entry_0,
                              challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_remove_device_0(account_0,
                                                                       owner_0,
                                                                       auth_nonce_value_0,
                                                                       entry_0,
                                                                       challenge_0));
  }
  _evm_digest_bridge_deposit_start_0(account_0,
                                     salt_0,
                                     owner_0,
                                     auth_nonce_value_0,
                                     erc20_0,
                                     amount_0,
                                     evm_nonce_0,
                                     gas_limit_0,
                                     max_fee_0,
                                     max_priority_fee_0,
                                     key_version_0,
                                     challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_bridge_deposit_start_0(account_0,
                                                                              owner_0,
                                                                              auth_nonce_value_0,
                                                                              erc20_0,
                                                                              amount_0,
                                                                              evm_nonce_0,
                                                                              gas_limit_0,
                                                                              max_fee_0,
                                                                              max_priority_fee_0,
                                                                              key_version_0,
                                                                              challenge_0));
  }
  _evm_digest_bridge_withdraw_start_0(account_0,
                                      salt_0,
                                      owner_0,
                                      auth_nonce_value_0,
                                      dest_0,
                                      color_0,
                                      amount_0,
                                      evm_nonce_0,
                                      gas_limit_0,
                                      max_fee_0,
                                      max_priority_fee_0,
                                      key_version_0,
                                      challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_bridge_withdraw_start_0(account_0,
                                                                               owner_0,
                                                                               auth_nonce_value_0,
                                                                               dest_0,
                                                                               color_0,
                                                                               amount_0,
                                                                               evm_nonce_0,
                                                                               gas_limit_0,
                                                                               max_fee_0,
                                                                               max_priority_fee_0,
                                                                               key_version_0,
                                                                               challenge_0));
  }
  _uint8Word_0(value_0) {
    const b_0 = __compactRuntime.convertBigintToBytes(1,
                                                      value_0,
                                                      'ByteCodec.compact line 37 char 15');
    return Uint8Array.from([0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            BigInt(b_0[0n])],
                           Number);
  }
  _uint64Word_0(value_0) {
    const b_0 = __compactRuntime.convertBigintToBytes(8,
                                                      value_0,
                                                      'ByteCodec.compact line 47 char 15');
    return Uint8Array.from([0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            BigInt(b_0[7n]),
                            BigInt(b_0[6n]),
                            BigInt(b_0[5n]),
                            BigInt(b_0[4n]),
                            BigInt(b_0[3n]),
                            BigInt(b_0[2n]),
                            BigInt(b_0[1n]),
                            BigInt(b_0[0n])],
                           Number);
  }
  _uint128Word_0(value_0) {
    const b_0 = __compactRuntime.convertBigintToBytes(16,
                                                      value_0,
                                                      'ByteCodec.compact line 55 char 15');
    return Uint8Array.from([0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            BigInt(b_0[15n]),
                            BigInt(b_0[14n]),
                            BigInt(b_0[13n]),
                            BigInt(b_0[12n]),
                            BigInt(b_0[11n]),
                            BigInt(b_0[10n]),
                            BigInt(b_0[9n]),
                            BigInt(b_0[8n]),
                            BigInt(b_0[7n]),
                            BigInt(b_0[6n]),
                            BigInt(b_0[5n]),
                            BigInt(b_0[4n]),
                            BigInt(b_0[3n]),
                            BigInt(b_0[2n]),
                            BigInt(b_0[1n]),
                            BigInt(b_0[0n])],
                           Number);
  }
  _addressWord_0(value_0) {
    return Uint8Array.from(((e) => e.slice(0, 32))([...Array.from(new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
                                                                  BigInt),
                                                    ...Array.from(value_0,
                                                                  BigInt)]),
                           Number);
  }
  _zswapCoinCommitment_0(coin_0, recipient_0) {
    return this._persistentHash_29({ domain_sep:
                                       new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 122, 115, 119, 97, 112, 45, 99, 99, 91, 118, 49, 93]),
                                     info: coin_0,
                                     dataType: recipient_0.is_left,
                                     data:
                                       recipient_0.is_left ?
                                       recipient_0.left.bytes :
                                       recipient_0.right.bytes });
  }
  _zswapCoinNullifier_0(coin_0, addr_0) {
    return this._persistentHash_29({ domain_sep:
                                       new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 122, 115, 119, 97, 112, 45, 99, 110, 91, 118, 49, 93]),
                                     info: coin_0,
                                     dataType: false,
                                     data: addr_0.bytes });
  }
  _dropMerkleIndex_0(coin_0) {
    return { nonce: coin_0.nonce, color: coin_0.color, value: coin_0.value };
  }
  _zswapNullifierOf_0(coin_0, addr_0) {
    return this._zswapCoinNullifier_0(coin_0, addr_0);
  }
  _zswapCommitmentOf_0(coin_0, recipient_0) {
    return this._zswapCoinCommitment_0(coin_0, recipient_0);
  }
  _held_coin_0(context, partialProofData, color_0) {
    const witnessContext_0 = __compactRuntime.createWitnessContext(ledger(context.callContext.currentQueryContext.state), context.callContext.currentPrivateState, context.callContext.currentQueryContext.address);
    const [nextPrivateState_0, result_0] = this.witnesses.held_coin(witnessContext_0,
                                                                    color_0);
    context.callContext.currentPrivateState = nextPrivateState_0;
    if (!(typeof(result_0) === 'object' && result_0.nonce.buffer instanceof ArrayBuffer && result_0.nonce.BYTES_PER_ELEMENT === 1 && result_0.nonce.length === 32 && result_0.color.buffer instanceof ArrayBuffer && result_0.color.BYTES_PER_ELEMENT === 1 && result_0.color.length === 32 && typeof(result_0.value) === 'bigint' && result_0.value >= 0n && result_0.value <= 340282366920938463463374607431768211455n && typeof(result_0.mt_index) === 'bigint' && result_0.mt_index >= 0n && result_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('held_coin',
                                 'return value',
                                 'account.compact line 361 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 result_0)
    }
    partialProofData.privateTranscriptOutputs.push({
      value: _descriptor_24.toValue(result_0),
      alignment: _descriptor_24.alignment()
    });
    return result_0;
  }
  async _do_activate_initial_device_0(context, partialProofData, entry_0) {
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = 1n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(8n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(tmp_0),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(11n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_8.toValue(true),
                                                                                              alignment: _descriptor_8.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(10n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _activate_initial_device_with_jubjub_0(context,
                                               partialProofData,
                                               pk_0,
                                               salt_0)
  {
    __compactRuntime.assert(!_descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(11n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { popeq: { cached: false,
                                                                                                   result: undefined } }]).value),
                            'already activated');
    __compactRuntime.assert(!this._equal_3(this._ecMul_0(pk_0,
                                                         __compactRuntime.convertNumericToJubjubScalar(8n)),
                                           this._ecMulGenerator_0(__compactRuntime.convertNumericToJubjubScalar(0n))),
                            'device key has small order');
    __compactRuntime.assert(this._equal_4(this._derive_boot_commitment_with_jubjub_0(salt_0,
                                                                                     pk_0),
                                          _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                    partialProofData,
                                                                                                    [
                                                                                                     { dup: { n: 0 } },
                                                                                                     { idx: { cached: false,
                                                                                                              pushPath: false,
                                                                                                              path: [
                                                                                                                     { tag: 'value',
                                                                                                                       value: { value: _descriptor_3.toValue(10n),
                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                     { popeq: { cached: false,
                                                                                                                result: undefined } }]).value)),
                            'boot commitment mismatch');
    await this._do_activate_initial_device_0(context,
                                             partialProofData,
                                             this._derive_device_entry_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                               partialProofData,
                                                                                                                                               [
                                                                                                                                                { dup: { n: 2 } },
                                                                                                                                                { idx: { cached: true,
                                                                                                                                                         pushPath: false,
                                                                                                                                                         path: [
                                                                                                                                                                { tag: 'value',
                                                                                                                                                                  value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                { popeq: { cached: true,
                                                                                                                                                           result: undefined } }]).value),
                                                                                     pk_0,
                                                                                     _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                                partialProofData,
                                                                                                                                                [
                                                                                                                                                 { dup: { n: 0 } },
                                                                                                                                                 { idx: { cached: false,
                                                                                                                                                          pushPath: false,
                                                                                                                                                          path: [
                                                                                                                                                                 { tag: 'value',
                                                                                                                                                                   value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                 { popeq: { cached: false,
                                                                                                                                                            result: undefined } }]).value),
                                                                                     0n));
    return [];
  }
  async _activate_initial_device_with_k256_0(context,
                                             partialProofData,
                                             pk_0,
                                             salt_0,
                                             envelope_0)
  {
    __compactRuntime.assert(!_descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(11n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { popeq: { cached: false,
                                                                                                   result: undefined } }]).value),
                            'already activated');
    this._require_live_k256_key_0(pk_0);
    __compactRuntime.assert(this._equal_5(this._derive_boot_commitment_with_k256_0(salt_0,
                                                                                   pk_0,
                                                                                   envelope_0),
                                          _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                    partialProofData,
                                                                                                    [
                                                                                                     { dup: { n: 0 } },
                                                                                                     { idx: { cached: false,
                                                                                                              pushPath: false,
                                                                                                              path: [
                                                                                                                     { tag: 'value',
                                                                                                                       value: { value: _descriptor_3.toValue(10n),
                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                     { popeq: { cached: false,
                                                                                                                result: undefined } }]).value)),
                            'boot commitment mismatch');
    await this._do_activate_initial_device_0(context,
                                             partialProofData,
                                             this._derive_device_entry_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                             partialProofData,
                                                                                                                                             [
                                                                                                                                              { dup: { n: 2 } },
                                                                                                                                              { idx: { cached: true,
                                                                                                                                                       pushPath: false,
                                                                                                                                                       path: [
                                                                                                                                                              { tag: 'value',
                                                                                                                                                                value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                              { popeq: { cached: true,
                                                                                                                                                         result: undefined } }]).value),
                                                                                   pk_0,
                                                                                   envelope_0,
                                                                                   _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                              partialProofData,
                                                                                                                                              [
                                                                                                                                               { dup: { n: 0 } },
                                                                                                                                               { idx: { cached: false,
                                                                                                                                                        pushPath: false,
                                                                                                                                                        path: [
                                                                                                                                                               { tag: 'value',
                                                                                                                                                                 value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                               { popeq: { cached: false,
                                                                                                                                                          result: undefined } }]).value),
                                                                                   0n));
    return [];
  }
  async _activate_initial_device_with_evm_0(context,
                                            partialProofData,
                                            pk_0,
                                            salt_0)
  {
    __compactRuntime.assert(!_descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(11n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { popeq: { cached: false,
                                                                                                   result: undefined } }]).value),
                            'already activated');
    this._require_live_k256_key_0(pk_0);
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    __compactRuntime.assert(this._equal_6(this._derive_boot_commitment_with_evm_0(salt_0,
                                                                                  address_0),
                                          _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                    partialProofData,
                                                                                                    [
                                                                                                     { dup: { n: 0 } },
                                                                                                     { idx: { cached: false,
                                                                                                              pushPath: false,
                                                                                                              path: [
                                                                                                                     { tag: 'value',
                                                                                                                       value: { value: _descriptor_3.toValue(10n),
                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                     { popeq: { cached: false,
                                                                                                                result: undefined } }]).value)),
                            'boot commitment mismatch');
    await this._do_activate_initial_device_0(context,
                                             partialProofData,
                                             this._derive_device_entry_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                            partialProofData,
                                                                                                                                            [
                                                                                                                                             { dup: { n: 2 } },
                                                                                                                                             { idx: { cached: true,
                                                                                                                                                      pushPath: false,
                                                                                                                                                      path: [
                                                                                                                                                             { tag: 'value',
                                                                                                                                                               value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                             { popeq: { cached: true,
                                                                                                                                                        result: undefined } }]).value),
                                                                                  address_0,
                                                                                  _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                             partialProofData,
                                                                                                                                             [
                                                                                                                                              { dup: { n: 0 } },
                                                                                                                                              { idx: { cached: false,
                                                                                                                                                       pushPath: false,
                                                                                                                                                       path: [
                                                                                                                                                              { tag: 'value',
                                                                                                                                                                value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                              { popeq: { cached: false,
                                                                                                                                                         result: undefined } }]).value),
                                                                                  0n));
    return [];
  }
  _derive_boot_commitment_with_jubjub_0(salt_0, pk_0) {
    return this._persistentHash_0([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 98, 111, 111, 116, 58, 118, 49, 0, 0, 0, 0, 0, 0, 0, 0]),
                                   salt_0,
                                   pk_0]);
  }
  _derive_boot_commitment_with_k256_0(salt_0, pk_0, envelope_0) {
    return this._persistentHash_1([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 98, 111, 111, 116, 58, 107, 49, 58, 118, 50, 0, 0, 0, 0, 0]),
                                   salt_0,
                                   __compactRuntime.convertBigintToBytes(32,
                                                                         this._secp256k1PointX_0(pk_0),
                                                                         'account.compact line 578 char 6'),
                                   __compactRuntime.convertBigintToBytes(32,
                                                                         this._secp256k1PointY_0(pk_0),
                                                                         'account.compact line 578 char 40'),
                                   envelope_0]);
  }
  _derive_boot_commitment_with_evm_0(salt_0, address_0) {
    return this._persistentHash_2([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 98, 111, 111, 116, 58, 101, 118, 109, 58, 118, 49, 0, 0, 0, 0]),
                                   salt_0,
                                   address_0]);
  }
  _derive_device_entry_with_jubjub_0(self_addr_0, pk_0, epoch_0, counter_0) {
    return this._persistentHash_3([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 100, 101, 118, 105, 99, 101, 58, 118, 49, 0, 0, 0, 0, 0, 0]),
                                   self_addr_0,
                                   pk_0,
                                   epoch_0,
                                   counter_0]);
  }
  _derive_device_entry_with_k256_0(self_addr_0,
                                   pk_0,
                                   envelope_0,
                                   epoch_0,
                                   counter_0)
  {
    return this._persistentHash_4([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 100, 101, 118, 105, 99, 101, 58, 107, 49, 58, 118, 50, 0, 0, 0]),
                                   self_addr_0,
                                   __compactRuntime.convertBigintToBytes(32,
                                                                         this._secp256k1PointX_0(pk_0),
                                                                         'account.compact line 640 char 6'),
                                   __compactRuntime.convertBigintToBytes(32,
                                                                         this._secp256k1PointY_0(pk_0),
                                                                         'account.compact line 640 char 40'),
                                   envelope_0,
                                   epoch_0,
                                   counter_0]);
  }
  _derive_device_entry_with_evm_0(self_addr_0, address_0, epoch_0, counter_0) {
    return this._persistentHash_5([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 100, 101, 118, 105, 99, 101, 58, 101, 118, 109, 58, 118, 49, 0, 0]),
                                   self_addr_0,
                                   address_0,
                                   epoch_0,
                                   counter_0]);
  }
  _require_live_k256_key_0(pk_0) {
    __compactRuntime.assert(!(this._equal_7(__compactRuntime.convertBigintToBytes(32,
                                                                                  this._secp256k1PointX_0(pk_0),
                                                                                  'account.compact line 693 char 8'),
                                            new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]))
                              &&
                              this._equal_8(__compactRuntime.convertBigintToBytes(32,
                                                                                  this._secp256k1PointY_0(pk_0),
                                                                                  'account.compact line 694 char 11'),
                                            new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]))),
                            'device key is the point at infinity');
    return [];
  }
  _envelope_digest_0(envelope_0, challenge_0) {
    __compactRuntime.assert(envelope_0 <= 1n, 'unknown envelope');
    const none_0 = this._persistentHash_6(challenge_0);
    const connector_0 = this._persistentHash_7([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 95, 115, 105, 103, 110, 101, 100, 95, 109, 101, 115, 115, 97, 103, 101, 58, 51, 50, 58]),
                                                challenge_0]);
    if (envelope_0 === 1n) { return connector_0; } else { return none_0; }
  }
  _compute_public_point_with_jubjub_0(scalar_0) {
    return this._ecMulGenerator_0(__compactRuntime.convertNumericToJubjubScalar(scalar_0));
  }
  _compute_public_point_with_k256_0(scalar_0) {
    return this._ecMulGenerator_1(scalar_0);
  }
  _challenge_withdraw_unshielded_with_jubjub_0(self_addr_0,
                                               sig_r_0,
                                               pk_0,
                                               color_0,
                                               amount_0,
                                               recipient_0,
                                               nonce_value_0,
                                               grind_nonce_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 117, 110, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_8([dst_0,
                                   self_addr_0,
                                   sig_r_0,
                                   pk_0,
                                   color_0,
                                   amount_0,
                                   recipient_0,
                                   nonce_value_0,
                                   grind_nonce_0]);
  }
  _challenge_withdraw_shielded_with_jubjub_0(self_addr_0,
                                             sig_r_0,
                                             pk_0,
                                             recipient_0,
                                             color_0,
                                             amount_0,
                                             coin_0,
                                             nonce_value_0,
                                             grind_nonce_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_9([dst_0,
                                   self_addr_0,
                                   sig_r_0,
                                   pk_0,
                                   recipient_0,
                                   color_0,
                                   amount_0,
                                   coin_0,
                                   nonce_value_0,
                                   grind_nonce_0]);
  }
  _challenge_withdraw_shielded_to_contract_with_jubjub_0(self_addr_0,
                                                         sig_r_0,
                                                         pk_0,
                                                         recipient_0,
                                                         color_0,
                                                         amount_0,
                                                         coin_0,
                                                         nonce_value_0,
                                                         grind_nonce_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 95, 116, 111, 95, 99, 111, 110, 116, 114, 97, 99, 116, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_10([dst_0,
                                    self_addr_0,
                                    sig_r_0,
                                    pk_0,
                                    recipient_0,
                                    color_0,
                                    amount_0,
                                    coin_0,
                                    nonce_value_0,
                                    grind_nonce_0]);
  }
  _challenge_append_inbox_with_jubjub_0(self_addr_0,
                                        sig_r_0,
                                        pk_0,
                                        entry_0,
                                        nonce_value_0,
                                        grind_nonce_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 97, 112, 112, 101, 110, 100, 95, 105, 110, 98, 111, 120, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_11([dst_0,
                                    self_addr_0,
                                    sig_r_0,
                                    pk_0,
                                    entry_0,
                                    nonce_value_0,
                                    grind_nonce_0]);
  }
  _challenge_rotate_enc_key_with_jubjub_0(self_addr_0,
                                          sig_r_0,
                                          pk_0,
                                          new_key_0,
                                          nonce_value_0,
                                          grind_nonce_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 114, 111, 116, 97, 116, 101, 95, 101, 110, 99, 95, 107, 101, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_12([dst_0,
                                    self_addr_0,
                                    sig_r_0,
                                    pk_0,
                                    new_key_0,
                                    nonce_value_0,
                                    grind_nonce_0]);
  }
  _challenge_add_device_with_jubjub_0(self_addr_0,
                                      sig_r_0,
                                      pk_0,
                                      new_entry_0,
                                      nonce_value_0,
                                      grind_nonce_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 97, 100, 100, 95, 100, 101, 118, 105, 99, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_12([dst_0,
                                    self_addr_0,
                                    sig_r_0,
                                    pk_0,
                                    new_entry_0,
                                    nonce_value_0,
                                    grind_nonce_0]);
  }
  _challenge_remove_device_with_jubjub_0(self_addr_0,
                                         sig_r_0,
                                         pk_0,
                                         entry_0,
                                         nonce_value_0,
                                         grind_nonce_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 114, 101, 109, 111, 118, 101, 95, 100, 101, 118, 105, 99, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_12([dst_0,
                                    self_addr_0,
                                    sig_r_0,
                                    pk_0,
                                    entry_0,
                                    nonce_value_0,
                                    grind_nonce_0]);
  }
  _challenge_open_swap_shielded_with_jubjub_0(self_addr_0,
                                              sig_r_0,
                                              pk_0,
                                              give_color_0,
                                              give_amount_0,
                                              recipient_kind_0,
                                              recipient_0,
                                              want_0,
                                              want_entry_0,
                                              change_entry_0,
                                              valid_until_0,
                                              coin_0,
                                              nonce_value_0,
                                              grind_nonce_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 111, 112, 101, 110, 95, 115, 119, 97, 112, 95, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_13([dst_0,
                                    self_addr_0,
                                    sig_r_0,
                                    pk_0,
                                    give_color_0,
                                    give_amount_0,
                                    recipient_kind_0,
                                    recipient_0,
                                    want_0,
                                    want_entry_0,
                                    change_entry_0,
                                    valid_until_0,
                                    coin_0,
                                    nonce_value_0,
                                    grind_nonce_0]);
  }
  _challenge_withdraw_unshielded_with_k256_0(self_addr_0,
                                             pk_0,
                                             color_0,
                                             amount_0,
                                             recipient_0,
                                             nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 117, 110, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_14([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 924 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 924 char 40'),
                                    color_0,
                                    amount_0,
                                    recipient_0,
                                    nonce_value_0]);
  }
  _challenge_withdraw_shielded_with_k256_0(self_addr_0,
                                           pk_0,
                                           recipient_0,
                                           color_0,
                                           amount_0,
                                           coin_0,
                                           nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_15([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 943 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 943 char 40'),
                                    recipient_0,
                                    color_0,
                                    amount_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _challenge_withdraw_shielded_to_contract_with_k256_0(self_addr_0,
                                                       pk_0,
                                                       recipient_0,
                                                       color_0,
                                                       amount_0,
                                                       coin_0,
                                                       nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 95, 116, 111, 95, 99, 111, 110, 116, 114, 97, 99, 116, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_16([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 962 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 962 char 40'),
                                    recipient_0,
                                    color_0,
                                    amount_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _challenge_append_inbox_with_k256_0(self_addr_0, pk_0, entry_0, nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 97, 112, 112, 101, 110, 100, 95, 105, 110, 98, 111, 120, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_17([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 978 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 978 char 40'),
                                    entry_0,
                                    nonce_value_0]);
  }
  _challenge_rotate_enc_key_with_k256_0(self_addr_0,
                                        pk_0,
                                        new_key_0,
                                        nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 114, 111, 116, 97, 116, 101, 95, 101, 110, 99, 95, 107, 101, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_18([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 994 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 994 char 40'),
                                    new_key_0,
                                    nonce_value_0]);
  }
  _challenge_add_device_with_k256_0(self_addr_0,
                                    pk_0,
                                    new_entry_0,
                                    nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 97, 100, 100, 95, 100, 101, 118, 105, 99, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_18([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 1010 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 1010 char 40'),
                                    new_entry_0,
                                    nonce_value_0]);
  }
  _challenge_remove_device_with_k256_0(self_addr_0, pk_0, entry_0, nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 114, 101, 109, 111, 118, 101, 95, 100, 101, 118, 105, 99, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_18([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 1026 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 1026 char 40'),
                                    entry_0,
                                    nonce_value_0]);
  }
  _challenge_withdraw_unshielded_with_evm_0(self_addr_0,
                                            address_0,
                                            color_0,
                                            amount_0,
                                            recipient_0,
                                            nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 117, 110, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_19([dst_0,
                                    self_addr_0,
                                    address_0,
                                    color_0,
                                    amount_0,
                                    recipient_0,
                                    nonce_value_0]);
  }
  _challenge_withdraw_shielded_with_evm_0(self_addr_0,
                                          address_0,
                                          recipient_0,
                                          color_0,
                                          amount_0,
                                          coin_0,
                                          nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_20([dst_0,
                                    self_addr_0,
                                    address_0,
                                    recipient_0,
                                    color_0,
                                    amount_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _challenge_withdraw_shielded_to_contract_with_evm_0(self_addr_0,
                                                      address_0,
                                                      recipient_0,
                                                      color_0,
                                                      amount_0,
                                                      coin_0,
                                                      nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 95, 116, 111, 95, 99, 111, 110, 116, 114, 97, 99, 116, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_21([dst_0,
                                    self_addr_0,
                                    address_0,
                                    recipient_0,
                                    color_0,
                                    amount_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _challenge_append_inbox_with_evm_0(self_addr_0,
                                     address_0,
                                     entry_0,
                                     nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 97, 112, 112, 101, 110, 100, 95, 105, 110, 98, 111, 120, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_22([dst_0,
                                    self_addr_0,
                                    address_0,
                                    entry_0,
                                    nonce_value_0]);
  }
  _challenge_rotate_enc_key_with_evm_0(self_addr_0,
                                       address_0,
                                       new_key_0,
                                       nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 114, 111, 116, 97, 116, 101, 95, 101, 110, 99, 95, 107, 101, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_23([dst_0,
                                    self_addr_0,
                                    address_0,
                                    new_key_0,
                                    nonce_value_0]);
  }
  _challenge_add_device_with_evm_0(self_addr_0,
                                   address_0,
                                   new_entry_0,
                                   nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 97, 100, 100, 95, 100, 101, 118, 105, 99, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_23([dst_0,
                                    self_addr_0,
                                    address_0,
                                    new_entry_0,
                                    nonce_value_0]);
  }
  _challenge_remove_device_with_evm_0(self_addr_0,
                                      address_0,
                                      entry_0,
                                      nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 114, 101, 109, 111, 118, 101, 95, 100, 101, 118, 105, 99, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_23([dst_0,
                                    self_addr_0,
                                    address_0,
                                    entry_0,
                                    nonce_value_0]);
  }
  _challenge_open_swap_shielded_with_evm_0(self_addr_0,
                                           address_0,
                                           give_color_0,
                                           give_amount_0,
                                           recipient_kind_0,
                                           recipient_0,
                                           want_0,
                                           want_entry_0,
                                           change_entry_0,
                                           valid_until_0,
                                           coin_0,
                                           nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 111, 112, 101, 110, 95, 115, 119, 97, 112, 95, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_24([dst_0,
                                    self_addr_0,
                                    address_0,
                                    give_color_0,
                                    give_amount_0,
                                    recipient_kind_0,
                                    recipient_0,
                                    want_0,
                                    want_entry_0,
                                    change_entry_0,
                                    valid_until_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _challenge_bridge_deposit_start_with_evm_0(self_addr_0,
                                             address_0,
                                             erc20_0,
                                             amount_0,
                                             evm_nonce_0,
                                             gas_limit_0,
                                             max_fee_0,
                                             max_priority_fee_0,
                                             key_version_0,
                                             nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 98, 114, 105, 100, 103, 101, 95, 100, 101, 112, 111, 115, 105, 116, 95, 115, 116, 97, 114, 116, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_25([dst_0,
                                    self_addr_0,
                                    address_0,
                                    erc20_0,
                                    amount_0,
                                    evm_nonce_0,
                                    gas_limit_0,
                                    max_fee_0,
                                    max_priority_fee_0,
                                    key_version_0,
                                    nonce_value_0]);
  }
  _challenge_bridge_withdraw_start_with_evm_0(self_addr_0,
                                              address_0,
                                              dest_0,
                                              color_0,
                                              amount_0,
                                              evm_nonce_0,
                                              gas_limit_0,
                                              max_fee_0,
                                              max_priority_fee_0,
                                              key_version_0,
                                              erc20_0,
                                              coin_0,
                                              nonce_value_0)
  {
    const dst_0 = this._persistentHash_26([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 98, 114, 105, 100, 103, 101, 95, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 116, 97, 114, 116, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_27([dst_0,
                                    self_addr_0,
                                    address_0,
                                    dest_0,
                                    color_0,
                                    amount_0,
                                    evm_nonce_0,
                                    gas_limit_0,
                                    max_fee_0,
                                    max_priority_fee_0,
                                    key_version_0,
                                    erc20_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  async _require_authorised_with_jubjub_0(context,
                                          partialProofData,
                                          pk_0,
                                          use_counter_0,
                                          sig_r_0,
                                          sig_s_0,
                                          challenge_0)
  {
    __compactRuntime.assert(!this._equal_9(this._ecMul_0(pk_0,
                                                         __compactRuntime.convertNumericToJubjubScalar(8n)),
                                           this._ecMulGenerator_0(__compactRuntime.convertNumericToJubjubScalar(0n))),
                            'device key has small order');
    const entry_0 = this._derive_device_entry_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 2 } },
                                                                                                                       { idx: { cached: true,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: true,
                                                                                                                                  result: undefined } }]).value),
                                                            pk_0,
                                                            _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 0 } },
                                                                                                                        { idx: { cached: false,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: false,
                                                                                                                                   result: undefined } }]).value),
                                                            use_counter_0);
    __compactRuntime.assert(_descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                      partialProofData,
                                                                                      [
                                                                                       { dup: { n: 0 } },
                                                                                       { idx: { cached: false,
                                                                                                pushPath: false,
                                                                                                path: [
                                                                                                       { tag: 'value',
                                                                                                         value: { value: _descriptor_3.toValue(6n),
                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                       { push: { storage: false,
                                                                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                                                                       'member',
                                                                                       { popeq: { cached: true,
                                                                                                  result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = this._derive_device_entry_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                    partialProofData,
                                                                                                                    [
                                                                                                                     { dup: { n: 2 } },
                                                                                                                     { idx: { cached: true,
                                                                                                                              pushPath: false,
                                                                                                                              path: [
                                                                                                                                     { tag: 'value',
                                                                                                                                       value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                     { popeq: { cached: true,
                                                                                                                                result: undefined } }]).value),
                                                          pk_0,
                                                          _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 0 } },
                                                                                                                      { idx: { cached: false,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: false,
                                                                                                                                 result: undefined } }]).value),
                                                          ((t1) => {
                                                            if (t1 > 18446744073709551615n) {
                                                              throw new __compactRuntime.CompactError('account.compact line 1299 char 39: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                            }
                                                            return t1;
                                                          })(use_counter_0 + 1n));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    const c_0 = __compactRuntime.convertBytesToUint(52435875175126190479447740508185965837690552500527637822603658699938581184512n,
                                                    32,
                                                    challenge_0,
                                                    'Field',
                                                    'account.compact line 1304 char 13');
    __compactRuntime.assert(this._equal_10(this._ecMulGenerator_0(__compactRuntime.convertNumericToJubjubScalar(sig_s_0)),
                                           this._ecAdd_0(sig_r_0,
                                                         this._ecMul_0(pk_0,
                                                                       __compactRuntime.convertNumericToJubjubScalar(c_0)))),
                            'invalid signature');
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 1309 char 17: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(tmp_1),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _require_authorised_with_k256_0(context,
                                        partialProofData,
                                        pk_0,
                                        use_counter_0,
                                        sig_0,
                                        challenge_0,
                                        envelope_0)
  {
    this._require_live_k256_key_0(pk_0);
    const entry_0 = this._derive_device_entry_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                    partialProofData,
                                                                                                                    [
                                                                                                                     { dup: { n: 2 } },
                                                                                                                     { idx: { cached: true,
                                                                                                                              pushPath: false,
                                                                                                                              path: [
                                                                                                                                     { tag: 'value',
                                                                                                                                       value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                     { popeq: { cached: true,
                                                                                                                                result: undefined } }]).value),
                                                          pk_0,
                                                          envelope_0,
                                                          _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 0 } },
                                                                                                                      { idx: { cached: false,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: false,
                                                                                                                                 result: undefined } }]).value),
                                                          use_counter_0);
    __compactRuntime.assert(_descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                      partialProofData,
                                                                                      [
                                                                                       { dup: { n: 0 } },
                                                                                       { idx: { cached: false,
                                                                                                pushPath: false,
                                                                                                path: [
                                                                                                       { tag: 'value',
                                                                                                         value: { value: _descriptor_3.toValue(6n),
                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                       { push: { storage: false,
                                                                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                                                                       'member',
                                                                                       { popeq: { cached: true,
                                                                                                  result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = this._derive_device_entry_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                  partialProofData,
                                                                                                                  [
                                                                                                                   { dup: { n: 2 } },
                                                                                                                   { idx: { cached: true,
                                                                                                                            pushPath: false,
                                                                                                                            path: [
                                                                                                                                   { tag: 'value',
                                                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                   { popeq: { cached: true,
                                                                                                                              result: undefined } }]).value),
                                                        pk_0,
                                                        envelope_0,
                                                        _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                   partialProofData,
                                                                                                                   [
                                                                                                                    { dup: { n: 0 } },
                                                                                                                    { idx: { cached: false,
                                                                                                                             pushPath: false,
                                                                                                                             path: [
                                                                                                                                    { tag: 'value',
                                                                                                                                      value: { value: _descriptor_3.toValue(7n),
                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                    { popeq: { cached: false,
                                                                                                                               result: undefined } }]).value),
                                                        ((t1) => {
                                                          if (t1 > 18446744073709551615n) {
                                                            throw new __compactRuntime.CompactError('account.compact line 1328 char 6: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                          }
                                                          return t1;
                                                        })(use_counter_0 + 1n));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    const digest_0 = this._envelope_digest_0(envelope_0, challenge_0);
    __compactRuntime.assert(this._secp256k1EcdsaVerify_0(digest_0, sig_0, pk_0),
                            'invalid signature');
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 1342 char 17: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(tmp_1),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _require_authorised_with_evm_0(context,
                                       partialProofData,
                                       pk_0,
                                       use_counter_0,
                                       sig_0,
                                       digest_0,
                                       address_0)
  {
    this._require_live_k256_key_0(pk_0);
    const entry_0 = this._derive_device_entry_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                   partialProofData,
                                                                                                                   [
                                                                                                                    { dup: { n: 2 } },
                                                                                                                    { idx: { cached: true,
                                                                                                                             pushPath: false,
                                                                                                                             path: [
                                                                                                                                    { tag: 'value',
                                                                                                                                      value: { value: _descriptor_3.toValue(0n),
                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                    { popeq: { cached: true,
                                                                                                                               result: undefined } }]).value),
                                                         address_0,
                                                         _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                    partialProofData,
                                                                                                                    [
                                                                                                                     { dup: { n: 0 } },
                                                                                                                     { idx: { cached: false,
                                                                                                                              pushPath: false,
                                                                                                                              path: [
                                                                                                                                     { tag: 'value',
                                                                                                                                       value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                     { popeq: { cached: false,
                                                                                                                                result: undefined } }]).value),
                                                         use_counter_0);
    __compactRuntime.assert(_descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                      partialProofData,
                                                                                      [
                                                                                       { dup: { n: 0 } },
                                                                                       { idx: { cached: false,
                                                                                                pushPath: false,
                                                                                                path: [
                                                                                                       { tag: 'value',
                                                                                                         value: { value: _descriptor_3.toValue(6n),
                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                       { push: { storage: false,
                                                                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                                                                       'member',
                                                                                       { popeq: { cached: true,
                                                                                                  result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = this._derive_device_entry_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                 partialProofData,
                                                                                                                 [
                                                                                                                  { dup: { n: 2 } },
                                                                                                                  { idx: { cached: true,
                                                                                                                           pushPath: false,
                                                                                                                           path: [
                                                                                                                                  { tag: 'value',
                                                                                                                                    value: { value: _descriptor_3.toValue(0n),
                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                  { popeq: { cached: true,
                                                                                                                             result: undefined } }]).value),
                                                       address_0,
                                                       _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                  partialProofData,
                                                                                                                  [
                                                                                                                   { dup: { n: 0 } },
                                                                                                                   { idx: { cached: false,
                                                                                                                            pushPath: false,
                                                                                                                            path: [
                                                                                                                                   { tag: 'value',
                                                                                                                                     value: { value: _descriptor_3.toValue(7n),
                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                   { popeq: { cached: false,
                                                                                                                              result: undefined } }]).value),
                                                       ((t1) => {
                                                         if (t1 > 18446744073709551615n) {
                                                           throw new __compactRuntime.CompactError('account.compact line 1373 char 6: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                         }
                                                         return t1;
                                                       })(use_counter_0 + 1n));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    __compactRuntime.assert(this._secp256k1EcdsaVerify_0(digest_0, sig_0, pk_0),
                            'invalid signature');
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 1383 char 17: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(tmp_1),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _bump_round_0(context, partialProofData) {
    const tmp_0 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 1388 char 12: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(0n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(tmp_0),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    return [];
  }
  async _credit_unshielded_0(context, partialProofData, color_0, amount_0) {
    if (_descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                  partialProofData,
                                                                  [
                                                                   { dup: { n: 0 } },
                                                                   { idx: { cached: false,
                                                                            pushPath: false,
                                                                            path: [
                                                                                   { tag: 'value',
                                                                                     value: { value: _descriptor_3.toValue(4n),
                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                   { push: { storage: false,
                                                                             value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(color_0),
                                                                                                                          alignment: _descriptor_0.alignment() }).encode() } },
                                                                   'member',
                                                                   { popeq: { cached: true,
                                                                              result: undefined } }]).value))
    {
      const tmp_0 = ((t1) => {
                      if (t1 > 340282366920938463463374607431768211455n) {
                        throw new __compactRuntime.CompactError('account.compact line 1397 char 8: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 340282366920938463463374607431768211455');
                      }
                      return t1;
                    })(_descriptor_9.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                 partialProofData,
                                                                                 [
                                                                                  { dup: { n: 0 } },
                                                                                  { idx: { cached: false,
                                                                                           pushPath: false,
                                                                                           path: [
                                                                                                  { tag: 'value',
                                                                                                    value: { value: _descriptor_3.toValue(4n),
                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                  { idx: { cached: false,
                                                                                           pushPath: false,
                                                                                           path: [
                                                                                                  { tag: 'value',
                                                                                                    value: { value: _descriptor_0.toValue(color_0),
                                                                                                             alignment: _descriptor_0.alignment() } }] } },
                                                                                  { popeq: { cached: false,
                                                                                             result: undefined } }]).value)
                       +
                       amount_0);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { idx: { cached: false,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(4n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(color_0),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: true,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_9.toValue(tmp_0),
                                                                                                alignment: _descriptor_9.alignment() }).encode() } },
                                         { ins: { cached: false, n: 1 } },
                                         { ins: { cached: true, n: 1 } }]);
    } else {
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { idx: { cached: false,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(4n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(color_0),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: true,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_9.toValue(amount_0),
                                                                                                alignment: _descriptor_9.alignment() }).encode() } },
                                         { ins: { cached: false, n: 1 } },
                                         { ins: { cached: true, n: 1 } }]);
    }
    return [];
  }
  async _debit_unshielded_0(context, partialProofData, color_0, amount_0) {
    __compactRuntime.assert(_descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                      partialProofData,
                                                                                      [
                                                                                       { dup: { n: 0 } },
                                                                                       { idx: { cached: false,
                                                                                                pushPath: false,
                                                                                                path: [
                                                                                                       { tag: 'value',
                                                                                                         value: { value: _descriptor_3.toValue(4n),
                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                       { push: { storage: false,
                                                                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(color_0),
                                                                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                                                                       'member',
                                                                                       { popeq: { cached: true,
                                                                                                  result: undefined } }]).value),
                            'no balance for color');
    const bal_0 = _descriptor_9.fromValue(__compactRuntime.queryLedgerState(context,
                                                                            partialProofData,
                                                                            [
                                                                             { dup: { n: 0 } },
                                                                             { idx: { cached: false,
                                                                                      pushPath: false,
                                                                                      path: [
                                                                                             { tag: 'value',
                                                                                               value: { value: _descriptor_3.toValue(4n),
                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                             { idx: { cached: false,
                                                                                      pushPath: false,
                                                                                      path: [
                                                                                             { tag: 'value',
                                                                                               value: { value: _descriptor_0.toValue(color_0),
                                                                                                        alignment: _descriptor_0.alignment() } }] } },
                                                                             { popeq: { cached: false,
                                                                                        result: undefined } }]).value);
    __compactRuntime.assert(bal_0 >= amount_0, 'insufficient balance');
    const tmp_0 = (__compactRuntime.assert(bal_0 >= amount_0,
                                           'result of subtraction would be negative'),
                   bal_0 - amount_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(4n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(color_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_9.toValue(tmp_0),
                                                                                              alignment: _descriptor_9.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    return [];
  }
  async _do_withdraw_unshielded_0(context,
                                  partialProofData,
                                  color_0,
                                  amount_0,
                                  recipient_0)
  {
    const c_0 = color_0;
    const a_0 = amount_0;
    await this._debit_unshielded_0(context, partialProofData, c_0, a_0);
    await this._sendUnshielded_0(context,
                                 partialProofData,
                                 c_0,
                                 a_0,
                                 this._right_0(recipient_0));
    return [];
  }
  async _do_append_inbox_0(context, partialProofData, entry_0) {
    const tmp_0 = _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                             partialProofData,
                                                                             [
                                                                              { dup: { n: 0 } },
                                                                              { idx: { cached: false,
                                                                                       pushPath: false,
                                                                                       path: [
                                                                                              { tag: 'value',
                                                                                                value: { value: _descriptor_3.toValue(3n),
                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                              { popeq: { cached: false,
                                                                                         result: undefined } }]).value);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(2n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(tmp_0),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_7.toValue(entry_0),
                                                                                              alignment: _descriptor_7.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 1432 char 18: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(3n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(3n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(tmp_1),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    return [];
  }
  async _do_withdraw_shielded_0(context,
                                partialProofData,
                                recipient_0,
                                amount_0,
                                coin_0)
  {
    const result_0 = await this._sendShielded_0(context,
                                                partialProofData,
                                                coin_0,
                                                this._left_1(recipient_0),
                                                amount_0);
    if (result_0.change.is_some) {
      return this._some_0(result_0.change.value);
    } else {
      return this._none_0();
    }
  }
  async _do_withdraw_shielded_to_contract_0(context,
                                            partialProofData,
                                            recipient_0,
                                            amount_0,
                                            coin_0)
  {
    const result_0 = await this._sendShielded_0(context,
                                                partialProofData,
                                                coin_0,
                                                this._right_1(recipient_0),
                                                amount_0);
    if (result_0.change.is_some) {
      return [result_0.sent, this._some_0(result_0.change.value)];
    } else {
      return [result_0.sent, this._none_0()];
    }
  }
  async _do_rotate_enc_key_0(context, partialProofData, new_key_0) {
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(1n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(new_key_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    return [];
  }
  async _do_add_device_0(context, partialProofData, new_entry_0) {
    const e_0 = new_entry_0;
    __compactRuntime.assert(!_descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(6n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { push: { storage: false,
                                                                                                  value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(e_0),
                                                                                                                                               alignment: _descriptor_0.alignment() }).encode() } },
                                                                                        'member',
                                                                                        { popeq: { cached: true,
                                                                                                   result: undefined } }]).value),
                            'device entry already present');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(e_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = ((t1) => {
                    if (t1 > 255n) {
                      throw new __compactRuntime.CompactError('account.compact line 1486 char 19: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 255');
                    }
                    return t1;
                  })(_descriptor_3.fromValue(__compactRuntime.queryLedgerState(context,
                                                                               partialProofData,
                                                                               [
                                                                                { dup: { n: 0 } },
                                                                                { idx: { cached: false,
                                                                                         pushPath: false,
                                                                                         path: [
                                                                                                { tag: 'value',
                                                                                                  value: { value: _descriptor_3.toValue(8n),
                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                { popeq: { cached: false,
                                                                                           result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(8n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(tmp_0),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    return [];
  }
  async _do_remove_device_0(context, partialProofData, entry_0, caller_entry_0)
  {
    const e_0 = entry_0;
    let t_0;
    __compactRuntime.assert((t_0 = _descriptor_3.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                             partialProofData,
                                                                                             [
                                                                                              { dup: { n: 0 } },
                                                                                              { idx: { cached: false,
                                                                                                       pushPath: false,
                                                                                                       path: [
                                                                                                              { tag: 'value',
                                                                                                                value: { value: _descriptor_3.toValue(8n),
                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                              { popeq: { cached: false,
                                                                                                         result: undefined } }]).value),
                             t_0 > 1n),
                            'cannot remove last device');
    __compactRuntime.assert(!this._equal_11(e_0, caller_entry_0),
                            'cannot remove the authorising device');
    __compactRuntime.assert(_descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                      partialProofData,
                                                                                      [
                                                                                       { dup: { n: 0 } },
                                                                                       { idx: { cached: false,
                                                                                                pushPath: false,
                                                                                                path: [
                                                                                                       { tag: 'value',
                                                                                                         value: { value: _descriptor_3.toValue(6n),
                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                       { push: { storage: false,
                                                                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(e_0),
                                                                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                                                                       'member',
                                                                                       { popeq: { cached: true,
                                                                                                  result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(e_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    let t_1, t_2;
    const tmp_0 = (t_1 = _descriptor_3.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                   partialProofData,
                                                                                   [
                                                                                    { dup: { n: 0 } },
                                                                                    { idx: { cached: false,
                                                                                             pushPath: false,
                                                                                             path: [
                                                                                                    { tag: 'value',
                                                                                                      value: { value: _descriptor_3.toValue(8n),
                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                    { popeq: { cached: false,
                                                                                               result: undefined } }]).value),
                   (t_2 = 1n,
                    (__compactRuntime.assert(t_1 >= t_2,
                                             'result of subtraction would be negative'),
                     t_1 - t_2)));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(8n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(tmp_0),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    return [];
  }
  _assert_open_swap_terms_0(give_color_0,
                            give_amount_0,
                            recipient_kind_0,
                            recipient_0,
                            want_0,
                            coin_color_0,
                            coin_value_0)
  {
    __compactRuntime.assert(give_amount_0 > 0n,
                            'swap must give a positive amount');
    let t_0;
    __compactRuntime.assert((t_0 = want_0.value, t_0 > 0n),
                            'swap must want a positive amount');
    __compactRuntime.assert(!this._equal_12(give_color_0, want_0.color),
                            'swap legs must be different colours');
    __compactRuntime.assert(recipient_kind_0 <= 2n,
                            'swap recipient kind is invalid');
    __compactRuntime.assert(recipient_kind_0 <= 1n,
                            'swap to a contract taker is not supported');
    if (recipient_kind_0 === 0n) {
      __compactRuntime.assert(this._equal_13(recipient_0, new Uint8Array(32)),
                              'open swap recipient must be zero');
    } else {
      __compactRuntime.assert(!this._equal_14(recipient_0, new Uint8Array(32)),
                              'named swap recipient must be nonzero');
    }
    __compactRuntime.assert(this._equal_15(coin_color_0, give_color_0),
                            'held coin colour does not match the give colour');
    __compactRuntime.assert(coin_value_0 >= give_amount_0,
                            'held coin is smaller than the give amount');
    return [];
  }
  _swap_change_nonce_0(coin_nonce_0) {
    return this._evolveNonce_0(2n, coin_nonce_0);
  }
  async _assert_offer_live_0(context, partialProofData, valid_until_0) {
    const deadline_0 = valid_until_0;
    if (deadline_0 !== 0n) {
      __compactRuntime.assert(await this._blockTimeLt_0(context,
                                                        partialProofData,
                                                        deadline_0),
                              'offer authorisation has expired');
    }
    return [];
  }
  async _do_open_swap_0(context,
                        partialProofData,
                        coin_0,
                        give_amount_0,
                        recipient_kind_0,
                        recipient_0,
                        want_0,
                        want_entry_0,
                        change_entry_0)
  {
    const self_addr_0 = _descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                  partialProofData,
                                                                                  [
                                                                                   { dup: { n: 2 } },
                                                                                   { idx: { cached: true,
                                                                                            pushPath: false,
                                                                                            path: [
                                                                                                   { tag: 'value',
                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                   { popeq: { cached: true,
                                                                                              result: undefined } }]).value);
    const self_rcpt_0 = this._right_1(self_addr_0);
    const c_0 = coin_0;
    const give_0 = give_amount_0;
    const kind_0 = recipient_kind_0;
    let t_0; const safe_give_0 = (t_0 = c_0.value, t_0 >= give_0) ? give_0 : 0n;
    let t_1;
    const change_value_0 = (t_1 = c_0.value,
                            (__compactRuntime.assert(t_1 >= safe_give_0,
                                                     'result of subtraction would be negative'),
                             t_1 - safe_give_0));
    const has_change_0 = change_value_0 > 0n;
    const change_coin_0 = { nonce: this._evolveNonce_0(2n, c_0.nonce),
                            color: c_0.color,
                            value: change_value_0 };
    this._createZswapInput_0(context, partialProofData, c_0);
    const tmp_0 = this._zswapCoinNullifier_0(this._dropMerkleIndex_0(c_0),
                                             self_addr_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(0n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    if (kind_0 !== 0n) {
      const payout_0 = { nonce: this._evolveNonce_0(1n, c_0.nonce),
                         color: c_0.color,
                         value: safe_give_0 };
      const payout_rcpt_0 = this._left_1({ bytes: recipient_0 });
      this._createZswapOutput_0(context,
                                partialProofData,
                                payout_0,
                                payout_rcpt_0);
      const tmp_1 = this._zswapCoinCommitment_0(payout_0, payout_rcpt_0);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(2n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_1),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newNull().encode() } },
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
    }
    if (has_change_0) {
      this._createZswapOutput_0(context,
                                partialProofData,
                                change_coin_0,
                                self_rcpt_0);
      const cm_0 = this._zswapCoinCommitment_0(change_coin_0, self_rcpt_0);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(2n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(cm_0),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newNull().encode() } },
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(1n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(cm_0),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newNull().encode() } },
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
    }
    await this._receiveShielded_0(context, partialProofData, want_0);
    if (has_change_0) {
      await this._do_append_inbox_0(context, partialProofData, change_entry_0);
    }
    await this._do_append_inbox_0(context, partialProofData, want_entry_0);
    if (has_change_0) {
      return this._some_0(change_coin_0);
    } else {
      return this._none_0();
    }
  }
  async _deposit_unshielded_0(context, partialProofData, color_0, amount_0) {
    const c_0 = color_0;
    const a_0 = amount_0;
    await this._receiveUnshielded_0(context, partialProofData, c_0, a_0);
    await this._credit_unshielded_0(context, partialProofData, c_0, a_0);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _withdraw_unshielded_with_jubjub_0(context,
                                           partialProofData,
                                           color_0,
                                           amount_0,
                                           recipient_0,
                                           pk_0,
                                           use_counter_0,
                                           sig_r_0,
                                           sig_s_0,
                                           grind_nonce_0)
  {
    const challenge_0 = this._challenge_withdraw_unshielded_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                    partialProofData,
                                                                                                                                    [
                                                                                                                                     { dup: { n: 2 } },
                                                                                                                                     { idx: { cached: true,
                                                                                                                                              pushPath: false,
                                                                                                                                              path: [
                                                                                                                                                     { tag: 'value',
                                                                                                                                                       value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                     { popeq: { cached: true,
                                                                                                                                                result: undefined } }]).value),
                                                                          sig_r_0,
                                                                          pk_0,
                                                                          color_0,
                                                                          amount_0,
                                                                          recipient_0,
                                                                          _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                     partialProofData,
                                                                                                                                     [
                                                                                                                                      { dup: { n: 0 } },
                                                                                                                                      { idx: { cached: false,
                                                                                                                                               pushPath: false,
                                                                                                                                               path: [
                                                                                                                                                      { tag: 'value',
                                                                                                                                                        value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                      { popeq: { cached: false,
                                                                                                                                                 result: undefined } }]).value),
                                                                          grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    await this._do_withdraw_unshielded_0(context,
                                         partialProofData,
                                         color_0,
                                         amount_0,
                                         recipient_0);
    return [];
  }
  async _withdraw_unshielded_with_k256_0(context,
                                         partialProofData,
                                         color_0,
                                         amount_0,
                                         recipient_0,
                                         pk_0,
                                         use_counter_0,
                                         sig_0,
                                         envelope_0)
  {
    const challenge_0 = this._challenge_withdraw_unshielded_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                  partialProofData,
                                                                                                                                  [
                                                                                                                                   { dup: { n: 2 } },
                                                                                                                                   { idx: { cached: true,
                                                                                                                                            pushPath: false,
                                                                                                                                            path: [
                                                                                                                                                   { tag: 'value',
                                                                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                   { popeq: { cached: true,
                                                                                                                                              result: undefined } }]).value),
                                                                        pk_0,
                                                                        color_0,
                                                                        amount_0,
                                                                        recipient_0,
                                                                        _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 0 } },
                                                                                                                                    { idx: { cached: false,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: false,
                                                                                                                                               result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    await this._do_withdraw_unshielded_0(context,
                                         partialProofData,
                                         color_0,
                                         amount_0,
                                         recipient_0);
    return [];
  }
  async _withdraw_unshielded_with_evm_0(context,
                                        partialProofData,
                                        color_0,
                                        amount_0,
                                        recipient_0,
                                        pk_0,
                                        use_counter_0,
                                        sig_0)
  {
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_withdraw_unshielded_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                 partialProofData,
                                                                                                                                 [
                                                                                                                                  { dup: { n: 2 } },
                                                                                                                                  { idx: { cached: true,
                                                                                                                                           pushPath: false,
                                                                                                                                           path: [
                                                                                                                                                  { tag: 'value',
                                                                                                                                                    value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                  { popeq: { cached: true,
                                                                                                                                             result: undefined } }]).value),
                                                                       address_0,
                                                                       color_0,
                                                                       amount_0,
                                                                       recipient_0,
                                                                       _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                  partialProofData,
                                                                                                                                  [
                                                                                                                                   { dup: { n: 0 } },
                                                                                                                                   { idx: { cached: false,
                                                                                                                                            pushPath: false,
                                                                                                                                            path: [
                                                                                                                                                   { tag: 'value',
                                                                                                                                                     value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                   { popeq: { cached: false,
                                                                                                                                              result: undefined } }]).value));
    const digest_0 = this._evm_digest_withdraw_unshielded_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 2 } },
                                                                                                                       { idx: { cached: true,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: true,
                                                                                                                                  result: undefined } }]).value).bytes,
                                                            _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 0 } },
                                                                                                                       { idx: { cached: false,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: false,
                                                                                                                                  result: undefined } }]).value),
                                                            address_0,
                                                            _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 0 } },
                                                                                                                        { idx: { cached: false,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: false,
                                                                                                                                   result: undefined } }]).value),
                                                            color_0,
                                                            amount_0,
                                                            recipient_0.bytes,
                                                            challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    await this._do_withdraw_unshielded_0(context,
                                         partialProofData,
                                         color_0,
                                         amount_0,
                                         recipient_0);
    return [];
  }
  async _deposit_shielded_0(context, partialProofData, coin_0, entry_0) {
    await this._receiveShielded_0(context, partialProofData, coin_0);
    const tmp_0 = _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                             partialProofData,
                                                                             [
                                                                              { dup: { n: 0 } },
                                                                              { idx: { cached: false,
                                                                                       pushPath: false,
                                                                                       path: [
                                                                                              { tag: 'value',
                                                                                                value: { value: _descriptor_3.toValue(3n),
                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                              { popeq: { cached: false,
                                                                                         result: undefined } }]).value);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(2n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(tmp_0),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_7.toValue(entry_0),
                                                                                              alignment: _descriptor_7.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 1800 char 18: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(3n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(3n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(tmp_1),
                                                                                              alignment: _descriptor_13.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _append_inbox_with_jubjub_0(context,
                                    partialProofData,
                                    entry_0,
                                    pk_0,
                                    use_counter_0,
                                    sig_r_0,
                                    sig_s_0,
                                    grind_nonce_0)
  {
    const challenge_0 = this._challenge_append_inbox_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                             partialProofData,
                                                                                                                             [
                                                                                                                              { dup: { n: 2 } },
                                                                                                                              { idx: { cached: true,
                                                                                                                                       pushPath: false,
                                                                                                                                       path: [
                                                                                                                                              { tag: 'value',
                                                                                                                                                value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                              { popeq: { cached: true,
                                                                                                                                         result: undefined } }]).value),
                                                                   sig_r_0,
                                                                   pk_0,
                                                                   entry_0,
                                                                   _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                              partialProofData,
                                                                                                                              [
                                                                                                                               { dup: { n: 0 } },
                                                                                                                               { idx: { cached: false,
                                                                                                                                        pushPath: false,
                                                                                                                                        path: [
                                                                                                                                               { tag: 'value',
                                                                                                                                                 value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                                               { popeq: { cached: false,
                                                                                                                                          result: undefined } }]).value),
                                                                   grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    await this._do_append_inbox_0(context, partialProofData, entry_0);
    return [];
  }
  async _append_inbox_with_k256_0(context,
                                  partialProofData,
                                  entry_0,
                                  pk_0,
                                  use_counter_0,
                                  sig_0,
                                  envelope_0)
  {
    const challenge_0 = this._challenge_append_inbox_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                           partialProofData,
                                                                                                                           [
                                                                                                                            { dup: { n: 2 } },
                                                                                                                            { idx: { cached: true,
                                                                                                                                     pushPath: false,
                                                                                                                                     path: [
                                                                                                                                            { tag: 'value',
                                                                                                                                              value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                       alignment: _descriptor_3.alignment() } }] } },
                                                                                                                            { popeq: { cached: true,
                                                                                                                                       result: undefined } }]).value),
                                                                 pk_0,
                                                                 entry_0,
                                                                 _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                            partialProofData,
                                                                                                                            [
                                                                                                                             { dup: { n: 0 } },
                                                                                                                             { idx: { cached: false,
                                                                                                                                      pushPath: false,
                                                                                                                                      path: [
                                                                                                                                             { tag: 'value',
                                                                                                                                               value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                             { popeq: { cached: false,
                                                                                                                                        result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    await this._do_append_inbox_0(context, partialProofData, entry_0);
    return [];
  }
  async _append_inbox_with_evm_0(context,
                                 partialProofData,
                                 entry_0,
                                 pk_0,
                                 use_counter_0,
                                 sig_0)
  {
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_append_inbox_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                          partialProofData,
                                                                                                                          [
                                                                                                                           { dup: { n: 2 } },
                                                                                                                           { idx: { cached: true,
                                                                                                                                    pushPath: false,
                                                                                                                                    path: [
                                                                                                                                           { tag: 'value',
                                                                                                                                             value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                                                                           { popeq: { cached: true,
                                                                                                                                      result: undefined } }]).value),
                                                                address_0,
                                                                entry_0,
                                                                _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                           partialProofData,
                                                                                                                           [
                                                                                                                            { dup: { n: 0 } },
                                                                                                                            { idx: { cached: false,
                                                                                                                                     pushPath: false,
                                                                                                                                     path: [
                                                                                                                                            { tag: 'value',
                                                                                                                                              value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                       alignment: _descriptor_3.alignment() } }] } },
                                                                                                                            { popeq: { cached: false,
                                                                                                                                       result: undefined } }]).value));
    const digest_0 = this._evm_digest_append_inbox_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                               partialProofData,
                                                                                                               [
                                                                                                                { dup: { n: 2 } },
                                                                                                                { idx: { cached: true,
                                                                                                                         pushPath: false,
                                                                                                                         path: [
                                                                                                                                { tag: 'value',
                                                                                                                                  value: { value: _descriptor_3.toValue(0n),
                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                { popeq: { cached: true,
                                                                                                                           result: undefined } }]).value).bytes,
                                                     _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                               partialProofData,
                                                                                                               [
                                                                                                                { dup: { n: 0 } },
                                                                                                                { idx: { cached: false,
                                                                                                                         pushPath: false,
                                                                                                                         path: [
                                                                                                                                { tag: 'value',
                                                                                                                                  value: { value: _descriptor_3.toValue(12n),
                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                { popeq: { cached: false,
                                                                                                                           result: undefined } }]).value),
                                                     address_0,
                                                     _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                partialProofData,
                                                                                                                [
                                                                                                                 { dup: { n: 0 } },
                                                                                                                 { idx: { cached: false,
                                                                                                                          pushPath: false,
                                                                                                                          path: [
                                                                                                                                 { tag: 'value',
                                                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                 { popeq: { cached: false,
                                                                                                                            result: undefined } }]).value),
                                                     this._keccak256_4(entry_0),
                                                     challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    await this._do_append_inbox_0(context, partialProofData, entry_0);
    return [];
  }
  async _withdraw_shielded_with_jubjub_0(context,
                                         partialProofData,
                                         recipient_0,
                                         color_0,
                                         amount_0,
                                         pk_0,
                                         use_counter_0,
                                         sig_r_0,
                                         sig_s_0,
                                         grind_nonce_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const challenge_0 = this._challenge_withdraw_shielded_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                  partialProofData,
                                                                                                                                  [
                                                                                                                                   { dup: { n: 2 } },
                                                                                                                                   { idx: { cached: true,
                                                                                                                                            pushPath: false,
                                                                                                                                            path: [
                                                                                                                                                   { tag: 'value',
                                                                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                   { popeq: { cached: true,
                                                                                                                                              result: undefined } }]).value),
                                                                        sig_r_0,
                                                                        pk_0,
                                                                        recipient_0,
                                                                        color_0,
                                                                        amount_0,
                                                                        coin_0,
                                                                        _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 0 } },
                                                                                                                                    { idx: { cached: false,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: false,
                                                                                                                                               result: undefined } }]).value),
                                                                        grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    return await this._do_withdraw_shielded_0(context,
                                              partialProofData,
                                              recipient_0,
                                              amount_0,
                                              coin_0);
  }
  async _withdraw_shielded_with_k256_0(context,
                                       partialProofData,
                                       recipient_0,
                                       color_0,
                                       amount_0,
                                       pk_0,
                                       use_counter_0,
                                       sig_0,
                                       envelope_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const challenge_0 = this._challenge_withdraw_shielded_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 2 } },
                                                                                                                                 { idx: { cached: true,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: true,
                                                                                                                                            result: undefined } }]).value),
                                                                      pk_0,
                                                                      recipient_0,
                                                                      color_0,
                                                                      amount_0,
                                                                      coin_0,
                                                                      _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                 partialProofData,
                                                                                                                                 [
                                                                                                                                  { dup: { n: 0 } },
                                                                                                                                  { idx: { cached: false,
                                                                                                                                           pushPath: false,
                                                                                                                                           path: [
                                                                                                                                                  { tag: 'value',
                                                                                                                                                    value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                  { popeq: { cached: false,
                                                                                                                                             result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    return await this._do_withdraw_shielded_0(context,
                                              partialProofData,
                                              recipient_0,
                                              amount_0,
                                              coin_0);
  }
  async _withdraw_shielded_with_evm_0(context,
                                      partialProofData,
                                      recipient_0,
                                      color_0,
                                      amount_0,
                                      pk_0,
                                      use_counter_0,
                                      sig_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_withdraw_shielded_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                               partialProofData,
                                                                                                                               [
                                                                                                                                { dup: { n: 2 } },
                                                                                                                                { idx: { cached: true,
                                                                                                                                         pushPath: false,
                                                                                                                                         path: [
                                                                                                                                                { tag: 'value',
                                                                                                                                                  value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                { popeq: { cached: true,
                                                                                                                                           result: undefined } }]).value),
                                                                     address_0,
                                                                     recipient_0,
                                                                     color_0,
                                                                     amount_0,
                                                                     coin_0,
                                                                     _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 0 } },
                                                                                                                                 { idx: { cached: false,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: false,
                                                                                                                                            result: undefined } }]).value));
    const digest_0 = this._evm_digest_withdraw_shielded_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                    partialProofData,
                                                                                                                    [
                                                                                                                     { dup: { n: 2 } },
                                                                                                                     { idx: { cached: true,
                                                                                                                              pushPath: false,
                                                                                                                              path: [
                                                                                                                                     { tag: 'value',
                                                                                                                                       value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                     { popeq: { cached: true,
                                                                                                                                result: undefined } }]).value).bytes,
                                                          _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                    partialProofData,
                                                                                                                    [
                                                                                                                     { dup: { n: 0 } },
                                                                                                                     { idx: { cached: false,
                                                                                                                              pushPath: false,
                                                                                                                              path: [
                                                                                                                                     { tag: 'value',
                                                                                                                                       value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                     { popeq: { cached: false,
                                                                                                                                result: undefined } }]).value),
                                                          address_0,
                                                          _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 0 } },
                                                                                                                      { idx: { cached: false,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: false,
                                                                                                                                 result: undefined } }]).value),
                                                          color_0,
                                                          amount_0,
                                                          recipient_0.bytes,
                                                          challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    return await this._do_withdraw_shielded_0(context,
                                              partialProofData,
                                              recipient_0,
                                              amount_0,
                                              coin_0);
  }
  async _withdraw_shielded_to_contract_with_jubjub_0(context,
                                                     partialProofData,
                                                     recipient_0,
                                                     color_0,
                                                     amount_0,
                                                     pk_0,
                                                     use_counter_0,
                                                     sig_r_0,
                                                     sig_s_0,
                                                     grind_nonce_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const challenge_0 = this._challenge_withdraw_shielded_to_contract_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                              partialProofData,
                                                                                                                                              [
                                                                                                                                               { dup: { n: 2 } },
                                                                                                                                               { idx: { cached: true,
                                                                                                                                                        pushPath: false,
                                                                                                                                                        path: [
                                                                                                                                                               { tag: 'value',
                                                                                                                                                                 value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                               { popeq: { cached: true,
                                                                                                                                                          result: undefined } }]).value),
                                                                                    sig_r_0,
                                                                                    pk_0,
                                                                                    recipient_0,
                                                                                    color_0,
                                                                                    amount_0,
                                                                                    coin_0,
                                                                                    _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                               partialProofData,
                                                                                                                                               [
                                                                                                                                                { dup: { n: 0 } },
                                                                                                                                                { idx: { cached: false,
                                                                                                                                                         pushPath: false,
                                                                                                                                                         path: [
                                                                                                                                                                { tag: 'value',
                                                                                                                                                                  value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                { popeq: { cached: false,
                                                                                                                                                           result: undefined } }]).value),
                                                                                    grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    return await this._do_withdraw_shielded_to_contract_0(context,
                                                          partialProofData,
                                                          recipient_0,
                                                          amount_0,
                                                          coin_0);
  }
  async _withdraw_shielded_to_contract_with_k256_0(context,
                                                   partialProofData,
                                                   recipient_0,
                                                   color_0,
                                                   amount_0,
                                                   pk_0,
                                                   use_counter_0,
                                                   sig_0,
                                                   envelope_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const challenge_0 = this._challenge_withdraw_shielded_to_contract_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                            partialProofData,
                                                                                                                                            [
                                                                                                                                             { dup: { n: 2 } },
                                                                                                                                             { idx: { cached: true,
                                                                                                                                                      pushPath: false,
                                                                                                                                                      path: [
                                                                                                                                                             { tag: 'value',
                                                                                                                                                               value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                             { popeq: { cached: true,
                                                                                                                                                        result: undefined } }]).value),
                                                                                  pk_0,
                                                                                  recipient_0,
                                                                                  color_0,
                                                                                  amount_0,
                                                                                  coin_0,
                                                                                  _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                             partialProofData,
                                                                                                                                             [
                                                                                                                                              { dup: { n: 0 } },
                                                                                                                                              { idx: { cached: false,
                                                                                                                                                       pushPath: false,
                                                                                                                                                       path: [
                                                                                                                                                              { tag: 'value',
                                                                                                                                                                value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                              { popeq: { cached: false,
                                                                                                                                                         result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    return await this._do_withdraw_shielded_to_contract_0(context,
                                                          partialProofData,
                                                          recipient_0,
                                                          amount_0,
                                                          coin_0);
  }
  async _withdraw_shielded_to_contract_with_evm_0(context,
                                                  partialProofData,
                                                  recipient_0,
                                                  color_0,
                                                  amount_0,
                                                  pk_0,
                                                  use_counter_0,
                                                  sig_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_withdraw_shielded_to_contract_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                           partialProofData,
                                                                                                                                           [
                                                                                                                                            { dup: { n: 2 } },
                                                                                                                                            { idx: { cached: true,
                                                                                                                                                     pushPath: false,
                                                                                                                                                     path: [
                                                                                                                                                            { tag: 'value',
                                                                                                                                                              value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                       alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                            { popeq: { cached: true,
                                                                                                                                                       result: undefined } }]).value),
                                                                                 address_0,
                                                                                 recipient_0,
                                                                                 color_0,
                                                                                 amount_0,
                                                                                 coin_0,
                                                                                 _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                            partialProofData,
                                                                                                                                            [
                                                                                                                                             { dup: { n: 0 } },
                                                                                                                                             { idx: { cached: false,
                                                                                                                                                      pushPath: false,
                                                                                                                                                      path: [
                                                                                                                                                             { tag: 'value',
                                                                                                                                                               value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                             { popeq: { cached: false,
                                                                                                                                                        result: undefined } }]).value));
    const digest_0 = this._evm_digest_withdraw_shielded_to_contract_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 2 } },
                                                                                                                                 { idx: { cached: true,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: true,
                                                                                                                                            result: undefined } }]).value).bytes,
                                                                      _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 0 } },
                                                                                                                                 { idx: { cached: false,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: false,
                                                                                                                                            result: undefined } }]).value),
                                                                      address_0,
                                                                      _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                 partialProofData,
                                                                                                                                 [
                                                                                                                                  { dup: { n: 0 } },
                                                                                                                                  { idx: { cached: false,
                                                                                                                                           pushPath: false,
                                                                                                                                           path: [
                                                                                                                                                  { tag: 'value',
                                                                                                                                                    value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                  { popeq: { cached: false,
                                                                                                                                             result: undefined } }]).value),
                                                                      color_0,
                                                                      amount_0,
                                                                      recipient_0.bytes,
                                                                      challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    return await this._do_withdraw_shielded_to_contract_0(context,
                                                          partialProofData,
                                                          recipient_0,
                                                          amount_0,
                                                          coin_0);
  }
  async _rotate_enc_key_with_jubjub_0(context,
                                      partialProofData,
                                      new_key_0,
                                      pk_0,
                                      use_counter_0,
                                      sig_r_0,
                                      sig_s_0,
                                      grind_nonce_0)
  {
    const challenge_0 = this._challenge_rotate_enc_key_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                               partialProofData,
                                                                                                                               [
                                                                                                                                { dup: { n: 2 } },
                                                                                                                                { idx: { cached: true,
                                                                                                                                         pushPath: false,
                                                                                                                                         path: [
                                                                                                                                                { tag: 'value',
                                                                                                                                                  value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                { popeq: { cached: true,
                                                                                                                                           result: undefined } }]).value),
                                                                     sig_r_0,
                                                                     pk_0,
                                                                     new_key_0,
                                                                     _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 0 } },
                                                                                                                                 { idx: { cached: false,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: false,
                                                                                                                                            result: undefined } }]).value),
                                                                     grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    await this._do_rotate_enc_key_0(context, partialProofData, new_key_0);
    return [];
  }
  async _rotate_enc_key_with_k256_0(context,
                                    partialProofData,
                                    new_key_0,
                                    pk_0,
                                    use_counter_0,
                                    sig_0,
                                    envelope_0)
  {
    const challenge_0 = this._challenge_rotate_enc_key_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                             partialProofData,
                                                                                                                             [
                                                                                                                              { dup: { n: 2 } },
                                                                                                                              { idx: { cached: true,
                                                                                                                                       pushPath: false,
                                                                                                                                       path: [
                                                                                                                                              { tag: 'value',
                                                                                                                                                value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                              { popeq: { cached: true,
                                                                                                                                         result: undefined } }]).value),
                                                                   pk_0,
                                                                   new_key_0,
                                                                   _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                              partialProofData,
                                                                                                                              [
                                                                                                                               { dup: { n: 0 } },
                                                                                                                               { idx: { cached: false,
                                                                                                                                        pushPath: false,
                                                                                                                                        path: [
                                                                                                                                               { tag: 'value',
                                                                                                                                                 value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                                               { popeq: { cached: false,
                                                                                                                                          result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    await this._do_rotate_enc_key_0(context, partialProofData, new_key_0);
    return [];
  }
  async _rotate_enc_key_with_evm_0(context,
                                   partialProofData,
                                   new_key_0,
                                   pk_0,
                                   use_counter_0,
                                   sig_0)
  {
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_rotate_enc_key_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                            partialProofData,
                                                                                                                            [
                                                                                                                             { dup: { n: 2 } },
                                                                                                                             { idx: { cached: true,
                                                                                                                                      pushPath: false,
                                                                                                                                      path: [
                                                                                                                                             { tag: 'value',
                                                                                                                                               value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                             { popeq: { cached: true,
                                                                                                                                        result: undefined } }]).value),
                                                                  address_0,
                                                                  new_key_0,
                                                                  _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                             partialProofData,
                                                                                                                             [
                                                                                                                              { dup: { n: 0 } },
                                                                                                                              { idx: { cached: false,
                                                                                                                                       pushPath: false,
                                                                                                                                       path: [
                                                                                                                                              { tag: 'value',
                                                                                                                                                value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                              { popeq: { cached: false,
                                                                                                                                         result: undefined } }]).value));
    const digest_0 = this._evm_digest_rotate_enc_key_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                 partialProofData,
                                                                                                                 [
                                                                                                                  { dup: { n: 2 } },
                                                                                                                  { idx: { cached: true,
                                                                                                                           pushPath: false,
                                                                                                                           path: [
                                                                                                                                  { tag: 'value',
                                                                                                                                    value: { value: _descriptor_3.toValue(0n),
                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                  { popeq: { cached: true,
                                                                                                                             result: undefined } }]).value).bytes,
                                                       _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                 partialProofData,
                                                                                                                 [
                                                                                                                  { dup: { n: 0 } },
                                                                                                                  { idx: { cached: false,
                                                                                                                           pushPath: false,
                                                                                                                           path: [
                                                                                                                                  { tag: 'value',
                                                                                                                                    value: { value: _descriptor_3.toValue(12n),
                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                  { popeq: { cached: false,
                                                                                                                             result: undefined } }]).value),
                                                       address_0,
                                                       _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                  partialProofData,
                                                                                                                  [
                                                                                                                   { dup: { n: 0 } },
                                                                                                                   { idx: { cached: false,
                                                                                                                            pushPath: false,
                                                                                                                            path: [
                                                                                                                                   { tag: 'value',
                                                                                                                                     value: { value: _descriptor_3.toValue(9n),
                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                   { popeq: { cached: false,
                                                                                                                              result: undefined } }]).value),
                                                       new_key_0,
                                                       challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    await this._do_rotate_enc_key_0(context, partialProofData, new_key_0);
    return [];
  }
  async _add_device_with_jubjub_0(context,
                                  partialProofData,
                                  new_entry_0,
                                  pk_0,
                                  use_counter_0,
                                  sig_r_0,
                                  sig_s_0,
                                  grind_nonce_0)
  {
    const challenge_0 = this._challenge_add_device_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                           partialProofData,
                                                                                                                           [
                                                                                                                            { dup: { n: 2 } },
                                                                                                                            { idx: { cached: true,
                                                                                                                                     pushPath: false,
                                                                                                                                     path: [
                                                                                                                                            { tag: 'value',
                                                                                                                                              value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                       alignment: _descriptor_3.alignment() } }] } },
                                                                                                                            { popeq: { cached: true,
                                                                                                                                       result: undefined } }]).value),
                                                                 sig_r_0,
                                                                 pk_0,
                                                                 new_entry_0,
                                                                 _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                            partialProofData,
                                                                                                                            [
                                                                                                                             { dup: { n: 0 } },
                                                                                                                             { idx: { cached: false,
                                                                                                                                      pushPath: false,
                                                                                                                                      path: [
                                                                                                                                             { tag: 'value',
                                                                                                                                               value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                             { popeq: { cached: false,
                                                                                                                                        result: undefined } }]).value),
                                                                 grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    await this._do_add_device_0(context, partialProofData, new_entry_0);
    return [];
  }
  async _add_device_with_k256_0(context,
                                partialProofData,
                                new_entry_0,
                                pk_0,
                                use_counter_0,
                                sig_0,
                                envelope_0)
  {
    const challenge_0 = this._challenge_add_device_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                         partialProofData,
                                                                                                                         [
                                                                                                                          { dup: { n: 2 } },
                                                                                                                          { idx: { cached: true,
                                                                                                                                   pushPath: false,
                                                                                                                                   path: [
                                                                                                                                          { tag: 'value',
                                                                                                                                            value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                                                                          { popeq: { cached: true,
                                                                                                                                     result: undefined } }]).value),
                                                               pk_0,
                                                               new_entry_0,
                                                               _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                          partialProofData,
                                                                                                                          [
                                                                                                                           { dup: { n: 0 } },
                                                                                                                           { idx: { cached: false,
                                                                                                                                    pushPath: false,
                                                                                                                                    path: [
                                                                                                                                           { tag: 'value',
                                                                                                                                             value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                                                                           { popeq: { cached: false,
                                                                                                                                      result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    await this._do_add_device_0(context, partialProofData, new_entry_0);
    return [];
  }
  async _add_device_with_evm_0(context,
                               partialProofData,
                               new_entry_0,
                               pk_0,
                               use_counter_0,
                               sig_0)
  {
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_add_device_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 2 } },
                                                                                                                         { idx: { cached: true,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: true,
                                                                                                                                    result: undefined } }]).value),
                                                              address_0,
                                                              new_entry_0,
                                                              _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                         partialProofData,
                                                                                                                         [
                                                                                                                          { dup: { n: 0 } },
                                                                                                                          { idx: { cached: false,
                                                                                                                                   pushPath: false,
                                                                                                                                   path: [
                                                                                                                                          { tag: 'value',
                                                                                                                                            value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                                                                          { popeq: { cached: false,
                                                                                                                                     result: undefined } }]).value));
    const digest_0 = this._evm_digest_add_device_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                             partialProofData,
                                                                                                             [
                                                                                                              { dup: { n: 2 } },
                                                                                                              { idx: { cached: true,
                                                                                                                       pushPath: false,
                                                                                                                       path: [
                                                                                                                              { tag: 'value',
                                                                                                                                value: { value: _descriptor_3.toValue(0n),
                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                              { popeq: { cached: true,
                                                                                                                         result: undefined } }]).value).bytes,
                                                   _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                             partialProofData,
                                                                                                             [
                                                                                                              { dup: { n: 0 } },
                                                                                                              { idx: { cached: false,
                                                                                                                       pushPath: false,
                                                                                                                       path: [
                                                                                                                              { tag: 'value',
                                                                                                                                value: { value: _descriptor_3.toValue(12n),
                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                              { popeq: { cached: false,
                                                                                                                         result: undefined } }]).value),
                                                   address_0,
                                                   _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                              partialProofData,
                                                                                                              [
                                                                                                               { dup: { n: 0 } },
                                                                                                               { idx: { cached: false,
                                                                                                                        pushPath: false,
                                                                                                                        path: [
                                                                                                                               { tag: 'value',
                                                                                                                                 value: { value: _descriptor_3.toValue(9n),
                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                               { popeq: { cached: false,
                                                                                                                          result: undefined } }]).value),
                                                   new_entry_0,
                                                   challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    await this._do_add_device_0(context, partialProofData, new_entry_0);
    return [];
  }
  async _remove_device_with_jubjub_0(context,
                                     partialProofData,
                                     entry_0,
                                     pk_0,
                                     use_counter_0,
                                     sig_r_0,
                                     sig_s_0,
                                     grind_nonce_0)
  {
    const challenge_0 = this._challenge_remove_device_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                              partialProofData,
                                                                                                                              [
                                                                                                                               { dup: { n: 2 } },
                                                                                                                               { idx: { cached: true,
                                                                                                                                        pushPath: false,
                                                                                                                                        path: [
                                                                                                                                               { tag: 'value',
                                                                                                                                                 value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                                               { popeq: { cached: true,
                                                                                                                                          result: undefined } }]).value),
                                                                    sig_r_0,
                                                                    pk_0,
                                                                    entry_0,
                                                                    _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                               partialProofData,
                                                                                                                               [
                                                                                                                                { dup: { n: 0 } },
                                                                                                                                { idx: { cached: false,
                                                                                                                                         pushPath: false,
                                                                                                                                         path: [
                                                                                                                                                { tag: 'value',
                                                                                                                                                  value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                { popeq: { cached: false,
                                                                                                                                           result: undefined } }]).value),
                                                                    grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    await this._do_remove_device_0(context,
                                   partialProofData,
                                   entry_0,
                                   this._derive_device_entry_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                     partialProofData,
                                                                                                                                     [
                                                                                                                                      { dup: { n: 2 } },
                                                                                                                                      { idx: { cached: true,
                                                                                                                                               pushPath: false,
                                                                                                                                               path: [
                                                                                                                                                      { tag: 'value',
                                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                      { popeq: { cached: true,
                                                                                                                                                 result: undefined } }]).value),
                                                                           pk_0,
                                                                           _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                      partialProofData,
                                                                                                                                      [
                                                                                                                                       { dup: { n: 0 } },
                                                                                                                                       { idx: { cached: false,
                                                                                                                                                pushPath: false,
                                                                                                                                                path: [
                                                                                                                                                       { tag: 'value',
                                                                                                                                                         value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                       { popeq: { cached: false,
                                                                                                                                                  result: undefined } }]).value),
                                                                           ((t1) => {
                                                                             if (t1 > 18446744073709551615n) {
                                                                               throw new __compactRuntime.CompactError('account.compact line 2178 char 39: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                                             }
                                                                             return t1;
                                                                           })(use_counter_0
                                                                              +
                                                                              1n)));
    return [];
  }
  async _remove_device_with_k256_0(context,
                                   partialProofData,
                                   entry_0,
                                   pk_0,
                                   use_counter_0,
                                   sig_0,
                                   envelope_0)
  {
    const challenge_0 = this._challenge_remove_device_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                            partialProofData,
                                                                                                                            [
                                                                                                                             { dup: { n: 2 } },
                                                                                                                             { idx: { cached: true,
                                                                                                                                      pushPath: false,
                                                                                                                                      path: [
                                                                                                                                             { tag: 'value',
                                                                                                                                               value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                             { popeq: { cached: true,
                                                                                                                                        result: undefined } }]).value),
                                                                  pk_0,
                                                                  entry_0,
                                                                  _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                             partialProofData,
                                                                                                                             [
                                                                                                                              { dup: { n: 0 } },
                                                                                                                              { idx: { cached: false,
                                                                                                                                       pushPath: false,
                                                                                                                                       path: [
                                                                                                                                              { tag: 'value',
                                                                                                                                                value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                              { popeq: { cached: false,
                                                                                                                                         result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    await this._do_remove_device_0(context,
                                   partialProofData,
                                   entry_0,
                                   this._derive_device_entry_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 2 } },
                                                                                                                                    { idx: { cached: true,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: true,
                                                                                                                                               result: undefined } }]).value),
                                                                         pk_0,
                                                                         envelope_0,
                                                                         _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                    partialProofData,
                                                                                                                                    [
                                                                                                                                     { dup: { n: 0 } },
                                                                                                                                     { idx: { cached: false,
                                                                                                                                              pushPath: false,
                                                                                                                                              path: [
                                                                                                                                                     { tag: 'value',
                                                                                                                                                       value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                     { popeq: { cached: false,
                                                                                                                                                result: undefined } }]).value),
                                                                         ((t1) => {
                                                                           if (t1 > 18446744073709551615n) {
                                                                             throw new __compactRuntime.CompactError('account.compact line 2196 char 6: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                                           }
                                                                           return t1;
                                                                         })(use_counter_0
                                                                            +
                                                                            1n)));
    return [];
  }
  async _remove_device_with_evm_0(context,
                                  partialProofData,
                                  entry_0,
                                  pk_0,
                                  use_counter_0,
                                  sig_0)
  {
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_remove_device_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                           partialProofData,
                                                                                                                           [
                                                                                                                            { dup: { n: 2 } },
                                                                                                                            { idx: { cached: true,
                                                                                                                                     pushPath: false,
                                                                                                                                     path: [
                                                                                                                                            { tag: 'value',
                                                                                                                                              value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                       alignment: _descriptor_3.alignment() } }] } },
                                                                                                                            { popeq: { cached: true,
                                                                                                                                       result: undefined } }]).value),
                                                                 address_0,
                                                                 entry_0,
                                                                 _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                            partialProofData,
                                                                                                                            [
                                                                                                                             { dup: { n: 0 } },
                                                                                                                             { idx: { cached: false,
                                                                                                                                      pushPath: false,
                                                                                                                                      path: [
                                                                                                                                             { tag: 'value',
                                                                                                                                               value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                             { popeq: { cached: false,
                                                                                                                                        result: undefined } }]).value));
    const digest_0 = this._evm_digest_remove_device_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                partialProofData,
                                                                                                                [
                                                                                                                 { dup: { n: 2 } },
                                                                                                                 { idx: { cached: true,
                                                                                                                          pushPath: false,
                                                                                                                          path: [
                                                                                                                                 { tag: 'value',
                                                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                 { popeq: { cached: true,
                                                                                                                            result: undefined } }]).value).bytes,
                                                      _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                partialProofData,
                                                                                                                [
                                                                                                                 { dup: { n: 0 } },
                                                                                                                 { idx: { cached: false,
                                                                                                                          pushPath: false,
                                                                                                                          path: [
                                                                                                                                 { tag: 'value',
                                                                                                                                   value: { value: _descriptor_3.toValue(12n),
                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                 { popeq: { cached: false,
                                                                                                                            result: undefined } }]).value),
                                                      address_0,
                                                      _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                 partialProofData,
                                                                                                                 [
                                                                                                                  { dup: { n: 0 } },
                                                                                                                  { idx: { cached: false,
                                                                                                                           pushPath: false,
                                                                                                                           path: [
                                                                                                                                  { tag: 'value',
                                                                                                                                    value: { value: _descriptor_3.toValue(9n),
                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                  { popeq: { cached: false,
                                                                                                                             result: undefined } }]).value),
                                                      entry_0,
                                                      challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    await this._do_remove_device_0(context,
                                   partialProofData,
                                   entry_0,
                                   this._derive_device_entry_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                  partialProofData,
                                                                                                                                  [
                                                                                                                                   { dup: { n: 2 } },
                                                                                                                                   { idx: { cached: true,
                                                                                                                                            pushPath: false,
                                                                                                                                            path: [
                                                                                                                                                   { tag: 'value',
                                                                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                   { popeq: { cached: true,
                                                                                                                                              result: undefined } }]).value),
                                                                        address_0,
                                                                        _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 0 } },
                                                                                                                                    { idx: { cached: false,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: false,
                                                                                                                                               result: undefined } }]).value),
                                                                        ((t1) => {
                                                                          if (t1 > 18446744073709551615n) {
                                                                            throw new __compactRuntime.CompactError('account.compact line 2217 char 6: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                                          }
                                                                          return t1;
                                                                        })(use_counter_0
                                                                           +
                                                                           1n)));
    return [];
  }
  async _open_swap_shielded_with_jubjub_0(context,
                                          partialProofData,
                                          give_color_0,
                                          give_amount_0,
                                          recipient_kind_0,
                                          recipient_0,
                                          want_0,
                                          want_entry_0,
                                          change_entry_0,
                                          valid_until_0,
                                          pk_0,
                                          use_counter_0,
                                          sig_r_0,
                                          sig_s_0,
                                          grind_nonce_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, give_color_0);
    this._assert_open_swap_terms_0(give_color_0,
                                   give_amount_0,
                                   recipient_kind_0,
                                   recipient_0,
                                   want_0,
                                   coin_0.color,
                                   coin_0.value);
    await this._assert_offer_live_0(context, partialProofData, valid_until_0);
    const challenge_0 = this._challenge_open_swap_shielded_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 2 } },
                                                                                                                                    { idx: { cached: true,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: true,
                                                                                                                                               result: undefined } }]).value),
                                                                         sig_r_0,
                                                                         pk_0,
                                                                         give_color_0,
                                                                         give_amount_0,
                                                                         recipient_kind_0,
                                                                         recipient_0,
                                                                         want_0,
                                                                         want_entry_0,
                                                                         change_entry_0,
                                                                         valid_until_0,
                                                                         coin_0,
                                                                         _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                    partialProofData,
                                                                                                                                    [
                                                                                                                                     { dup: { n: 0 } },
                                                                                                                                     { idx: { cached: false,
                                                                                                                                              pushPath: false,
                                                                                                                                              path: [
                                                                                                                                                     { tag: 'value',
                                                                                                                                                       value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                     { popeq: { cached: false,
                                                                                                                                                result: undefined } }]).value),
                                                                         grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    return await this._do_open_swap_0(context,
                                      partialProofData,
                                      coin_0,
                                      give_amount_0,
                                      recipient_kind_0,
                                      recipient_0,
                                      want_0,
                                      want_entry_0,
                                      change_entry_0);
  }
  async _open_swap_shielded_with_evm_0(context,
                                       partialProofData,
                                       give_color_0,
                                       give_amount_0,
                                       recipient_kind_0,
                                       recipient_0,
                                       want_0,
                                       want_entry_0,
                                       change_entry_0,
                                       valid_until_0,
                                       pk_0,
                                       use_counter_0,
                                       sig_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, give_color_0);
    this._assert_open_swap_terms_0(give_color_0,
                                   give_amount_0,
                                   recipient_kind_0,
                                   recipient_0,
                                   want_0,
                                   coin_0.color,
                                   coin_0.value);
    await this._assert_offer_live_0(context, partialProofData, valid_until_0);
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_open_swap_shielded_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 2 } },
                                                                                                                                 { idx: { cached: true,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: true,
                                                                                                                                            result: undefined } }]).value),
                                                                      address_0,
                                                                      give_color_0,
                                                                      give_amount_0,
                                                                      recipient_kind_0,
                                                                      recipient_0,
                                                                      want_0,
                                                                      want_entry_0,
                                                                      change_entry_0,
                                                                      valid_until_0,
                                                                      coin_0,
                                                                      _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                 partialProofData,
                                                                                                                                 [
                                                                                                                                  { dup: { n: 0 } },
                                                                                                                                  { idx: { cached: false,
                                                                                                                                           pushPath: false,
                                                                                                                                           path: [
                                                                                                                                                  { tag: 'value',
                                                                                                                                                    value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                  { popeq: { cached: false,
                                                                                                                                             result: undefined } }]).value));
    const digest_0 = this._evm_digest_open_swap_shielded_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 2 } },
                                                                                                                      { idx: { cached: true,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: true,
                                                                                                                                 result: undefined } }]).value).bytes,
                                                           _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 0 } },
                                                                                                                      { idx: { cached: false,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: false,
                                                                                                                                 result: undefined } }]).value),
                                                           address_0,
                                                           _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 0 } },
                                                                                                                       { idx: { cached: false,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: false,
                                                                                                                                  result: undefined } }]).value),
                                                           give_color_0,
                                                           give_amount_0,
                                                           recipient_kind_0,
                                                           recipient_0,
                                                           want_0.nonce,
                                                           want_0.color,
                                                           want_0.value,
                                                           valid_until_0,
                                                           challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    return await this._do_open_swap_0(context,
                                      partialProofData,
                                      coin_0,
                                      give_amount_0,
                                      recipient_kind_0,
                                      recipient_0,
                                      want_0,
                                      want_entry_0,
                                      change_entry_0);
  }
  async _bridge_deposit_start_with_evm_0(context,
                                         partialProofData,
                                         erc20_0,
                                         amount_0,
                                         evm_nonce_0,
                                         gas_limit_0,
                                         max_fee_0,
                                         max_priority_fee_0,
                                         key_version_0,
                                         pk_0,
                                         use_counter_0,
                                         sig_0)
  {
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_bridge_deposit_start_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                  partialProofData,
                                                                                                                                  [
                                                                                                                                   { dup: { n: 2 } },
                                                                                                                                   { idx: { cached: true,
                                                                                                                                            pushPath: false,
                                                                                                                                            path: [
                                                                                                                                                   { tag: 'value',
                                                                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                   { popeq: { cached: true,
                                                                                                                                              result: undefined } }]).value),
                                                                        address_0,
                                                                        erc20_0,
                                                                        amount_0,
                                                                        evm_nonce_0,
                                                                        gas_limit_0,
                                                                        max_fee_0,
                                                                        max_priority_fee_0,
                                                                        key_version_0,
                                                                        _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 0 } },
                                                                                                                                    { idx: { cached: false,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: false,
                                                                                                                                               result: undefined } }]).value));
    const digest_0 = this._evm_digest_bridge_deposit_start_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 2 } },
                                                                                                                        { idx: { cached: true,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: true,
                                                                                                                                   result: undefined } }]).value).bytes,
                                                             _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 0 } },
                                                                                                                        { idx: { cached: false,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: false,
                                                                                                                                   result: undefined } }]).value),
                                                             address_0,
                                                             _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value),
                                                             erc20_0,
                                                             amount_0,
                                                             evm_nonce_0,
                                                             gas_limit_0,
                                                             max_fee_0,
                                                             max_priority_fee_0,
                                                             key_version_0,
                                                             challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    await __compactRuntime.crossContractCall(context,
                                             __compactContractsImport_Erc20Vault,
                                             'startDeposit',
                                             __compactRuntime.decodeContractAddress((_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                               partialProofData,
                                                                                                                                               [
                                                                                                                                                { dup: { n: 0 } },
                                                                                                                                                { idx: { cached: false,
                                                                                                                                                         pushPath: false,
                                                                                                                                                         path: [
                                                                                                                                                                { tag: 'value',
                                                                                                                                                                  value: { value: _descriptor_3.toValue(13n),
                                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                { popeq: { cached: false,
                                                                                                                                                           result: undefined } }]).value)).bytes),
                                             false,
                                             partialProofData,
                                             evm_nonce_0,
                                             gas_limit_0,
                                             max_fee_0,
                                             max_priority_fee_0,
                                             key_version_0,
                                             erc20_0,
                                             amount_0,
                                             this._right_1(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 2 } },
                                                                                                                      { idx: { cached: true,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: true,
                                                                                                                                 result: undefined } }]).value)));
    return [];
  }
  async _bridge_deposit_complete_0(context,
                                   partialProofData,
                                   request_id_0,
                                   attestation_0,
                                   output_0,
                                   mint_nonce_0,
                                   entry_0)
  {
    const minted_0 = await __compactRuntime.crossContractCall(context,
                                                              __compactContractsImport_Erc20Vault,
                                                              'completeDeposit',
                                                              __compactRuntime.decodeContractAddress((_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                                                partialProofData,
                                                                                                                                                                [
                                                                                                                                                                 { dup: { n: 0 } },
                                                                                                                                                                 { idx: { cached: false,
                                                                                                                                                                          pushPath: false,
                                                                                                                                                                          path: [
                                                                                                                                                                                 { tag: 'value',
                                                                                                                                                                                   value: { value: _descriptor_3.toValue(13n),
                                                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                                 { popeq: { cached: false,
                                                                                                                                                                            result: undefined } }]).value)).bytes),
                                                              false,
                                                              partialProofData,
                                                              request_id_0,
                                                              attestation_0,
                                                              output_0,
                                                              mint_nonce_0);
    if (minted_0.is_some) {
      await this._receiveShielded_0(context, partialProofData, minted_0.value);
      await this._do_append_inbox_0(context, partialProofData, entry_0);
      await this._bump_round_0(context, partialProofData);
      return this._some_0(minted_0.value);
    } else {
      await this._bump_round_0(context, partialProofData);
      return this._none_0();
    }
  }
  async _bridge_withdraw_start_with_evm_0(context,
                                          partialProofData,
                                          dest_0,
                                          color_0,
                                          amount_0,
                                          evm_nonce_0,
                                          gas_limit_0,
                                          max_fee_0,
                                          max_priority_fee_0,
                                          key_version_0,
                                          erc20_0,
                                          change_entry_0,
                                          pk_0,
                                          use_counter_0,
                                          sig_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_bridge_withdraw_start_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 2 } },
                                                                                                                                    { idx: { cached: true,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: true,
                                                                                                                                               result: undefined } }]).value),
                                                                         address_0,
                                                                         dest_0,
                                                                         color_0,
                                                                         amount_0,
                                                                         evm_nonce_0,
                                                                         gas_limit_0,
                                                                         max_fee_0,
                                                                         max_priority_fee_0,
                                                                         key_version_0,
                                                                         erc20_0,
                                                                         coin_0,
                                                                         _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                    partialProofData,
                                                                                                                                    [
                                                                                                                                     { dup: { n: 0 } },
                                                                                                                                     { idx: { cached: false,
                                                                                                                                              pushPath: false,
                                                                                                                                              path: [
                                                                                                                                                     { tag: 'value',
                                                                                                                                                       value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                     { popeq: { cached: false,
                                                                                                                                                result: undefined } }]).value));
    const digest_0 = this._evm_digest_bridge_withdraw_start_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 2 } },
                                                                                                                         { idx: { cached: true,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: true,
                                                                                                                                    result: undefined } }]).value).bytes,
                                                              _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value),
                                                              address_0,
                                                              _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                         partialProofData,
                                                                                                                         [
                                                                                                                          { dup: { n: 0 } },
                                                                                                                          { idx: { cached: false,
                                                                                                                                   pushPath: false,
                                                                                                                                   path: [
                                                                                                                                          { tag: 'value',
                                                                                                                                            value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                                                                          { popeq: { cached: false,
                                                                                                                                     result: undefined } }]).value),
                                                              dest_0,
                                                              color_0,
                                                              amount_0,
                                                              evm_nonce_0,
                                                              gas_limit_0,
                                                              max_fee_0,
                                                              max_priority_fee_0,
                                                              key_version_0,
                                                              challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    const result_0 = await this._sendShielded_0(context,
                                                partialProofData,
                                                coin_0,
                                                this._right_1(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(14n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value)),
                                                amount_0);
    await __compactRuntime.crossContractCall(context,
                                             __compactContractsImport_Erc20Vault,
                                             'startWithdraw',
                                             __compactRuntime.decodeContractAddress((_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                               partialProofData,
                                                                                                                                               [
                                                                                                                                                { dup: { n: 0 } },
                                                                                                                                                { idx: { cached: false,
                                                                                                                                                         pushPath: false,
                                                                                                                                                         path: [
                                                                                                                                                                { tag: 'value',
                                                                                                                                                                  value: { value: _descriptor_3.toValue(13n),
                                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                { popeq: { cached: false,
                                                                                                                                                           result: undefined } }]).value)).bytes),
                                             false,
                                             partialProofData,
                                             evm_nonce_0,
                                             gas_limit_0,
                                             max_fee_0,
                                             max_priority_fee_0,
                                             key_version_0,
                                             erc20_0,
                                             amount_0,
                                             dest_0,
                                             result_0.sent,
                                             this._right_1(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 2 } },
                                                                                                                      { idx: { cached: true,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: true,
                                                                                                                                 result: undefined } }]).value)));
    if (result_0.change.is_some) {
      await this._do_append_inbox_0(context, partialProofData, change_entry_0);
      return this._some_0(result_0.change.value);
    } else {
      return this._none_0();
    }
  }
  async _bridge_withdraw_complete_0(context,
                                    partialProofData,
                                    request_id_0,
                                    attestation_0,
                                    output_0,
                                    mint_nonce_0,
                                    entry_0)
  {
    const refunded_0 = await __compactRuntime.crossContractCall(context,
                                                                __compactContractsImport_Erc20Vault,
                                                                'completeWithdraw',
                                                                __compactRuntime.decodeContractAddress((_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                                                  partialProofData,
                                                                                                                                                                  [
                                                                                                                                                                   { dup: { n: 0 } },
                                                                                                                                                                   { idx: { cached: false,
                                                                                                                                                                            pushPath: false,
                                                                                                                                                                            path: [
                                                                                                                                                                                   { tag: 'value',
                                                                                                                                                                                     value: { value: _descriptor_3.toValue(13n),
                                                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                                   { popeq: { cached: false,
                                                                                                                                                                              result: undefined } }]).value)).bytes),
                                                                false,
                                                                partialProofData,
                                                                request_id_0,
                                                                attestation_0,
                                                                output_0,
                                                                mint_nonce_0);
    if (refunded_0.is_some) {
      await this._receiveShielded_0(context, partialProofData, refunded_0.value);
      await this._do_append_inbox_0(context, partialProofData, entry_0);
      await this._bump_round_0(context, partialProofData);
      return this._some_0(refunded_0.value);
    } else {
      await this._bump_round_0(context, partialProofData);
      return this._none_0();
    }
  }
  async _bridge_withdraw_refund_0(context,
                                  partialProofData,
                                  request_id_0,
                                  attestation_0,
                                  output_0,
                                  mint_nonce_0,
                                  entry_0)
  {
    const refunded_0 = await __compactRuntime.crossContractCall(context,
                                                                __compactContractsImport_Erc20Vault,
                                                                'refundWithdraw',
                                                                __compactRuntime.decodeContractAddress((_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                                                  partialProofData,
                                                                                                                                                                  [
                                                                                                                                                                   { dup: { n: 0 } },
                                                                                                                                                                   { idx: { cached: false,
                                                                                                                                                                            pushPath: false,
                                                                                                                                                                            path: [
                                                                                                                                                                                   { tag: 'value',
                                                                                                                                                                                     value: { value: _descriptor_3.toValue(13n),
                                                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                                   { popeq: { cached: false,
                                                                                                                                                                              result: undefined } }]).value)).bytes),
                                                                false,
                                                                partialProofData,
                                                                request_id_0,
                                                                attestation_0,
                                                                output_0,
                                                                mint_nonce_0);
    await this._receiveShielded_0(context, partialProofData, refunded_0);
    await this._do_append_inbox_0(context, partialProofData, entry_0);
    await this._bump_round_0(context, partialProofData);
    return refunded_0;
  }
  _equal_0(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_1(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_2(x0, y0) {
    if (x0.identity) { return y0.identity; }
    if (y0.identity || x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_3(x0, y0) {
    if (x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_4(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_5(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_6(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_7(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_8(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_9(x0, y0) {
    if (x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_10(x0, y0) {
    if (x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_11(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_12(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_13(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_14(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_15(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
}
export function ledger(stateOrChargedState) {
  const state = stateOrChargedState instanceof __compactRuntime.StateValue ? stateOrChargedState : stateOrChargedState.state;
  const chargedState = stateOrChargedState instanceof __compactRuntime.StateValue ? new __compactRuntime.ChargedState(stateOrChargedState) : stateOrChargedState;
  const context = {
    callContext: { currentQueryContext: new __compactRuntime.QueryContext(chargedState, __compactRuntime.dummyContractAddress()), currentGasCost: __compactRuntime.emptyRunningCost() },
    costModel: __compactRuntime.CostModel.initialCostModel()
  };
  const partialProofData = {
    input: { value: [], alignment: [] },
    output: undefined,
    publicTranscript: [],
    privateTranscriptOutputs: []
  };
  return {
    get round() {
      return _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                        partialProofData,
                                                                        [
                                                                         { dup: { n: 0 } },
                                                                         { idx: { cached: false,
                                                                                  pushPath: false,
                                                                                  path: [
                                                                                         { tag: 'value',
                                                                                           value: { value: _descriptor_3.toValue(0n),
                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                         { popeq: { cached: false,
                                                                                    result: undefined } }]).value);
    },
    get enc_key() {
      return _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(1n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    },
    inbox: {
      isEmpty(...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`isEmpty: expected 0 arguments, received ${args_0.length}`);
        }
        return _descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                         partialProofData,
                                                                         [
                                                                          { dup: { n: 0 } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_3.toValue(2n),
                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                          'size',
                                                                          { push: { storage: false,
                                                                                    value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(0n),
                                                                                                                                 alignment: _descriptor_13.alignment() }).encode() } },
                                                                          'eq',
                                                                          { popeq: { cached: true,
                                                                                     result: undefined } }]).value);
      },
      size(...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`size: expected 0 arguments, received ${args_0.length}`);
        }
        return _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                          partialProofData,
                                                                          [
                                                                           { dup: { n: 0 } },
                                                                           { idx: { cached: false,
                                                                                    pushPath: false,
                                                                                    path: [
                                                                                           { tag: 'value',
                                                                                             value: { value: _descriptor_3.toValue(2n),
                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                           'size',
                                                                           { popeq: { cached: true,
                                                                                      result: undefined } }]).value);
      },
      member(...args_0) {
        if (args_0.length !== 1) {
          throw new __compactRuntime.CompactError(`member: expected 1 argument, received ${args_0.length}`);
        }
        const key_0 = args_0[0];
        if (!(typeof(key_0) === 'bigint' && key_0 >= 0n && key_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('member',
                                     'argument 1',
                                     'account.compact line 374 char 1',
                                     'Uint<0..18446744073709551616>',
                                     key_0)
        }
        return _descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                         partialProofData,
                                                                         [
                                                                          { dup: { n: 0 } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_3.toValue(2n),
                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                          { push: { storage: false,
                                                                                    value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(key_0),
                                                                                                                                 alignment: _descriptor_13.alignment() }).encode() } },
                                                                          'member',
                                                                          { popeq: { cached: true,
                                                                                     result: undefined } }]).value);
      },
      lookup(...args_0) {
        if (args_0.length !== 1) {
          throw new __compactRuntime.CompactError(`lookup: expected 1 argument, received ${args_0.length}`);
        }
        const key_0 = args_0[0];
        if (!(typeof(key_0) === 'bigint' && key_0 >= 0n && key_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('lookup',
                                     'argument 1',
                                     'account.compact line 374 char 1',
                                     'Uint<0..18446744073709551616>',
                                     key_0)
        }
        return _descriptor_7.fromValue(__compactRuntime.queryLedgerState(context,
                                                                         partialProofData,
                                                                         [
                                                                          { dup: { n: 0 } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_3.toValue(2n),
                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_13.toValue(key_0),
                                                                                                     alignment: _descriptor_13.alignment() } }] } },
                                                                          { popeq: { cached: false,
                                                                                     result: undefined } }]).value);
      },
      [Symbol.iterator](...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`iter: expected 0 arguments, received ${args_0.length}`);
        }
        const self_0 = state.asArray()[2];
        return self_0.asMap().keys().map(  (key) => {    const value = self_0.asMap().get(key).asCell();    return [      _descriptor_13.fromValue(key.value),      _descriptor_7.fromValue(value.value)    ];  })[Symbol.iterator]();
      }
    },
    get inbox_count() {
      return _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                        partialProofData,
                                                                        [
                                                                         { dup: { n: 0 } },
                                                                         { idx: { cached: false,
                                                                                  pushPath: false,
                                                                                  path: [
                                                                                         { tag: 'value',
                                                                                           value: { value: _descriptor_3.toValue(3n),
                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                         { popeq: { cached: false,
                                                                                    result: undefined } }]).value);
    },
    unshielded_balances: {
      isEmpty(...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`isEmpty: expected 0 arguments, received ${args_0.length}`);
        }
        return _descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                         partialProofData,
                                                                         [
                                                                          { dup: { n: 0 } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_3.toValue(4n),
                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                          'size',
                                                                          { push: { storage: false,
                                                                                    value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(0n),
                                                                                                                                 alignment: _descriptor_13.alignment() }).encode() } },
                                                                          'eq',
                                                                          { popeq: { cached: true,
                                                                                     result: undefined } }]).value);
      },
      size(...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`size: expected 0 arguments, received ${args_0.length}`);
        }
        return _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                          partialProofData,
                                                                          [
                                                                           { dup: { n: 0 } },
                                                                           { idx: { cached: false,
                                                                                    pushPath: false,
                                                                                    path: [
                                                                                           { tag: 'value',
                                                                                             value: { value: _descriptor_3.toValue(4n),
                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                           'size',
                                                                           { popeq: { cached: true,
                                                                                      result: undefined } }]).value);
      },
      member(...args_0) {
        if (args_0.length !== 1) {
          throw new __compactRuntime.CompactError(`member: expected 1 argument, received ${args_0.length}`);
        }
        const key_0 = args_0[0];
        if (!(key_0.buffer instanceof ArrayBuffer && key_0.BYTES_PER_ELEMENT === 1 && key_0.length === 32)) {
          __compactRuntime.typeError('member',
                                     'argument 1',
                                     'account.compact line 379 char 1',
                                     'Bytes<32>',
                                     key_0)
        }
        return _descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                         partialProofData,
                                                                         [
                                                                          { dup: { n: 0 } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_3.toValue(4n),
                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                          { push: { storage: false,
                                                                                    value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(key_0),
                                                                                                                                 alignment: _descriptor_0.alignment() }).encode() } },
                                                                          'member',
                                                                          { popeq: { cached: true,
                                                                                     result: undefined } }]).value);
      },
      lookup(...args_0) {
        if (args_0.length !== 1) {
          throw new __compactRuntime.CompactError(`lookup: expected 1 argument, received ${args_0.length}`);
        }
        const key_0 = args_0[0];
        if (!(key_0.buffer instanceof ArrayBuffer && key_0.BYTES_PER_ELEMENT === 1 && key_0.length === 32)) {
          __compactRuntime.typeError('lookup',
                                     'argument 1',
                                     'account.compact line 379 char 1',
                                     'Bytes<32>',
                                     key_0)
        }
        return _descriptor_9.fromValue(__compactRuntime.queryLedgerState(context,
                                                                         partialProofData,
                                                                         [
                                                                          { dup: { n: 0 } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_3.toValue(4n),
                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_0.toValue(key_0),
                                                                                                     alignment: _descriptor_0.alignment() } }] } },
                                                                          { popeq: { cached: false,
                                                                                     result: undefined } }]).value);
      },
      [Symbol.iterator](...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`iter: expected 0 arguments, received ${args_0.length}`);
        }
        const self_0 = state.asArray()[4];
        return self_0.asMap().keys().map(  (key) => {    const value = self_0.asMap().get(key).asCell();    return [      _descriptor_0.fromValue(key.value),      _descriptor_9.fromValue(value.value)    ];  })[Symbol.iterator]();
      }
    },
    get spec_version() {
      return _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                        partialProofData,
                                                                        [
                                                                         { dup: { n: 0 } },
                                                                         { idx: { cached: false,
                                                                                  pushPath: false,
                                                                                  path: [
                                                                                         { tag: 'value',
                                                                                           value: { value: _descriptor_3.toValue(5n),
                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                         { popeq: { cached: false,
                                                                                    result: undefined } }]).value);
    },
    devices: {
      isEmpty(...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`isEmpty: expected 0 arguments, received ${args_0.length}`);
        }
        return _descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                         partialProofData,
                                                                         [
                                                                          { dup: { n: 0 } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_3.toValue(6n),
                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                          'size',
                                                                          { push: { storage: false,
                                                                                    value: __compactRuntime.StateValue.newCell({ value: _descriptor_13.toValue(0n),
                                                                                                                                 alignment: _descriptor_13.alignment() }).encode() } },
                                                                          'eq',
                                                                          { popeq: { cached: true,
                                                                                     result: undefined } }]).value);
      },
      size(...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`size: expected 0 arguments, received ${args_0.length}`);
        }
        return _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                          partialProofData,
                                                                          [
                                                                           { dup: { n: 0 } },
                                                                           { idx: { cached: false,
                                                                                    pushPath: false,
                                                                                    path: [
                                                                                           { tag: 'value',
                                                                                             value: { value: _descriptor_3.toValue(6n),
                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                           'size',
                                                                           { popeq: { cached: true,
                                                                                      result: undefined } }]).value);
      },
      member(...args_0) {
        if (args_0.length !== 1) {
          throw new __compactRuntime.CompactError(`member: expected 1 argument, received ${args_0.length}`);
        }
        const elem_0 = args_0[0];
        if (!(elem_0.buffer instanceof ArrayBuffer && elem_0.BYTES_PER_ELEMENT === 1 && elem_0.length === 32)) {
          __compactRuntime.typeError('member',
                                     'argument 1',
                                     'account.compact line 388 char 1',
                                     'Bytes<32>',
                                     elem_0)
        }
        return _descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                         partialProofData,
                                                                         [
                                                                          { dup: { n: 0 } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_3.toValue(6n),
                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                          { push: { storage: false,
                                                                                    value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(elem_0),
                                                                                                                                 alignment: _descriptor_0.alignment() }).encode() } },
                                                                          'member',
                                                                          { popeq: { cached: true,
                                                                                     result: undefined } }]).value);
      },
      [Symbol.iterator](...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`iter: expected 0 arguments, received ${args_0.length}`);
        }
        const self_0 = state.asArray()[6];
        return self_0.asMap().keys().map((elem) => _descriptor_0.fromValue(elem.value))[Symbol.iterator]();
      }
    },
    get device_epoch() {
      return _descriptor_18.fromValue(__compactRuntime.queryLedgerState(context,
                                                                        partialProofData,
                                                                        [
                                                                         { dup: { n: 0 } },
                                                                         { idx: { cached: false,
                                                                                  pushPath: false,
                                                                                  path: [
                                                                                         { tag: 'value',
                                                                                           value: { value: _descriptor_3.toValue(7n),
                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                         { popeq: { cached: false,
                                                                                    result: undefined } }]).value);
    },
    get device_count() {
      return _descriptor_3.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(8n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    },
    get auth_nonce() {
      return _descriptor_13.fromValue(__compactRuntime.queryLedgerState(context,
                                                                        partialProofData,
                                                                        [
                                                                         { dup: { n: 0 } },
                                                                         { idx: { cached: false,
                                                                                  pushPath: false,
                                                                                  path: [
                                                                                         { tag: 'value',
                                                                                           value: { value: _descriptor_3.toValue(9n),
                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                         { popeq: { cached: false,
                                                                                    result: undefined } }]).value);
    },
    get boot() {
      return _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(10n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    },
    get booted() {
      return _descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(11n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    },
    get evm_domain_salt() {
      return _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(12n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    },
    get vault() {
      return _descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(13n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    },
    get vault_address() {
      return _descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(14n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    }
  };
}
const _emptyContext = {
  callContext: { currentQueryContext: new __compactRuntime.QueryContext(new __compactRuntime.ContractState().data, __compactRuntime.dummyContractAddress()), currentGasCost: __compactRuntime.emptyRunningCost() }
};
const _dummyContract = new Contract({ held_coin: (...args) => undefined });
export const pureCircuits = {
  evm_account_alias: (...args_0) => {
    if (args_0.length !== 1) {
      throw new __compactRuntime.CompactError(`evm_account_alias: expected 1 argument (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_account_alias',
                                 'argument 1',
                                 'Eip712.compact line 202 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    return _dummyContract._evm_account_alias_0(account_0);
  },
  evm_domain_separator_for: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`evm_domain_separator_for: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_domain_separator_for',
                                 'argument 1',
                                 'Eip712.compact line 209 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_domain_separator_for',
                                 'argument 2',
                                 'Eip712.compact line 209 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    return _dummyContract._evm_domain_separator_for_0(account_0, salt_0);
  },
  evm_struct_hash_withdraw_unshielded: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_withdraw_unshielded: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const recipient_0 = args_0[5];
    const challenge_0 = args_0[6];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 1',
                                 'Eip712.compact line 225 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 2',
                                 'Eip712.compact line 225 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 3',
                                 'Eip712.compact line 225 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 4',
                                 'Eip712.compact line 225 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 5',
                                 'Eip712.compact line 225 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 6',
                                 'Eip712.compact line 225 char 3',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 7',
                                 'Eip712.compact line 225 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_withdraw_unshielded_0(account_0,
                                                                 owner_0,
                                                                 auth_nonce_value_0,
                                                                 color_0,
                                                                 amount_0,
                                                                 recipient_0,
                                                                 challenge_0);
  },
  evm_struct_hash_withdraw_shielded: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_withdraw_shielded: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const recipient_coin_public_key_0 = args_0[5];
    const challenge_0 = args_0[6];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 1',
                                 'Eip712.compact line 243 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 2',
                                 'Eip712.compact line 243 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 3',
                                 'Eip712.compact line 243 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 4',
                                 'Eip712.compact line 243 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 5',
                                 'Eip712.compact line 243 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(recipient_coin_public_key_0.buffer instanceof ArrayBuffer && recipient_coin_public_key_0.BYTES_PER_ELEMENT === 1 && recipient_coin_public_key_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 6',
                                 'Eip712.compact line 243 char 3',
                                 'Bytes<32>',
                                 recipient_coin_public_key_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 7',
                                 'Eip712.compact line 243 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_withdraw_shielded_0(account_0,
                                                               owner_0,
                                                               auth_nonce_value_0,
                                                               color_0,
                                                               amount_0,
                                                               recipient_coin_public_key_0,
                                                               challenge_0);
  },
  evm_struct_hash_withdraw_shielded_to_contract: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_withdraw_shielded_to_contract: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const recipient_contract_0 = args_0[5];
    const challenge_0 = args_0[6];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 1',
                                 'Eip712.compact line 261 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 2',
                                 'Eip712.compact line 261 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 3',
                                 'Eip712.compact line 261 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 4',
                                 'Eip712.compact line 261 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 5',
                                 'Eip712.compact line 261 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(recipient_contract_0.buffer instanceof ArrayBuffer && recipient_contract_0.BYTES_PER_ELEMENT === 1 && recipient_contract_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 6',
                                 'Eip712.compact line 261 char 3',
                                 'Bytes<32>',
                                 recipient_contract_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 7',
                                 'Eip712.compact line 261 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_withdraw_shielded_to_contract_0(account_0,
                                                                           owner_0,
                                                                           auth_nonce_value_0,
                                                                           color_0,
                                                                           amount_0,
                                                                           recipient_contract_0,
                                                                           challenge_0);
  },
  evm_struct_hash_append_inbox: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_append_inbox: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const entry_hash_0 = args_0[3];
    const challenge_0 = args_0[4];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_append_inbox',
                                 'argument 1',
                                 'Eip712.compact line 282 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_append_inbox',
                                 'argument 2',
                                 'Eip712.compact line 282 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_append_inbox',
                                 'argument 3',
                                 'Eip712.compact line 282 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(entry_hash_0.buffer instanceof ArrayBuffer && entry_hash_0.BYTES_PER_ELEMENT === 1 && entry_hash_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_append_inbox',
                                 'argument 4',
                                 'Eip712.compact line 282 char 3',
                                 'Bytes<32>',
                                 entry_hash_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_append_inbox',
                                 'argument 5',
                                 'Eip712.compact line 282 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_append_inbox_0(account_0,
                                                          owner_0,
                                                          auth_nonce_value_0,
                                                          entry_hash_0,
                                                          challenge_0);
  },
  evm_struct_hash_rotate_enc_key: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_rotate_enc_key: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const new_key_0 = args_0[3];
    const challenge_0 = args_0[4];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_rotate_enc_key',
                                 'argument 1',
                                 'Eip712.compact line 297 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_rotate_enc_key',
                                 'argument 2',
                                 'Eip712.compact line 297 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_rotate_enc_key',
                                 'argument 3',
                                 'Eip712.compact line 297 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_rotate_enc_key',
                                 'argument 4',
                                 'Eip712.compact line 297 char 3',
                                 'Bytes<32>',
                                 new_key_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_rotate_enc_key',
                                 'argument 5',
                                 'Eip712.compact line 297 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_rotate_enc_key_0(account_0,
                                                            owner_0,
                                                            auth_nonce_value_0,
                                                            new_key_0,
                                                            challenge_0);
  },
  evm_struct_hash_add_device: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_add_device: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const new_entry_0 = args_0[3];
    const challenge_0 = args_0[4];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_add_device',
                                 'argument 1',
                                 'Eip712.compact line 312 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_add_device',
                                 'argument 2',
                                 'Eip712.compact line 312 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_add_device',
                                 'argument 3',
                                 'Eip712.compact line 312 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_add_device',
                                 'argument 4',
                                 'Eip712.compact line 312 char 3',
                                 'Bytes<32>',
                                 new_entry_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_add_device',
                                 'argument 5',
                                 'Eip712.compact line 312 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_add_device_0(account_0,
                                                        owner_0,
                                                        auth_nonce_value_0,
                                                        new_entry_0,
                                                        challenge_0);
  },
  evm_struct_hash_remove_device: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_remove_device: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const entry_0 = args_0[3];
    const challenge_0 = args_0[4];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_remove_device',
                                 'argument 1',
                                 'Eip712.compact line 327 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_remove_device',
                                 'argument 2',
                                 'Eip712.compact line 327 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_remove_device',
                                 'argument 3',
                                 'Eip712.compact line 327 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_remove_device',
                                 'argument 4',
                                 'Eip712.compact line 327 char 3',
                                 'Bytes<32>',
                                 entry_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_remove_device',
                                 'argument 5',
                                 'Eip712.compact line 327 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_remove_device_0(account_0,
                                                           owner_0,
                                                           auth_nonce_value_0,
                                                           entry_0,
                                                           challenge_0);
  },
  evm_struct_hash_open_swap_shielded: (...args_0) => {
    if (args_0.length !== 12) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_open_swap_shielded: expected 12 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const give_color_0 = args_0[3];
    const give_amount_0 = args_0[4];
    const recipient_kind_0 = args_0[5];
    const recipient_0 = args_0[6];
    const want_nonce_0 = args_0[7];
    const want_color_0 = args_0[8];
    const want_amount_0 = args_0[9];
    const valid_until_0 = args_0[10];
    const challenge_0 = args_0[11];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 1',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 2',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 3',
                                 'Eip712.compact line 353 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 4',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<32>',
                                 give_color_0)
    }
    if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 5',
                                 'Eip712.compact line 353 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 give_amount_0)
    }
    if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 6',
                                 'Eip712.compact line 353 char 3',
                                 'Uint<0..256>',
                                 recipient_kind_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 7',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(want_nonce_0.buffer instanceof ArrayBuffer && want_nonce_0.BYTES_PER_ELEMENT === 1 && want_nonce_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 8',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<32>',
                                 want_nonce_0)
    }
    if (!(want_color_0.buffer instanceof ArrayBuffer && want_color_0.BYTES_PER_ELEMENT === 1 && want_color_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 9',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<32>',
                                 want_color_0)
    }
    if (!(typeof(want_amount_0) === 'bigint' && want_amount_0 >= 0n && want_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 10',
                                 'Eip712.compact line 353 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 want_amount_0)
    }
    if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 11',
                                 'Eip712.compact line 353 char 3',
                                 'Uint<0..18446744073709551616>',
                                 valid_until_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 12',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_open_swap_shielded_0(account_0,
                                                                owner_0,
                                                                auth_nonce_value_0,
                                                                give_color_0,
                                                                give_amount_0,
                                                                recipient_kind_0,
                                                                recipient_0,
                                                                want_nonce_0,
                                                                want_color_0,
                                                                want_amount_0,
                                                                valid_until_0,
                                                                challenge_0);
  },
  evm_struct_hash_bridge_deposit_start: (...args_0) => {
    if (args_0.length !== 11) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_bridge_deposit_start: expected 11 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const erc20_0 = args_0[3];
    const amount_0 = args_0[4];
    const evm_nonce_0 = args_0[5];
    const gas_limit_0 = args_0[6];
    const max_fee_0 = args_0[7];
    const max_priority_fee_0 = args_0[8];
    const key_version_0 = args_0[9];
    const challenge_0 = args_0[10];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 1',
                                 'Eip712.compact line 386 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 2',
                                 'Eip712.compact line 386 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 3',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(erc20_0.buffer instanceof ArrayBuffer && erc20_0.BYTES_PER_ELEMENT === 1 && erc20_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 4',
                                 'Eip712.compact line 386 char 3',
                                 'Bytes<20>',
                                 erc20_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 5',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 6',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..18446744073709551616>',
                                 evm_nonce_0)
    }
    if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 7',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..18446744073709551616>',
                                 gas_limit_0)
    }
    if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 8',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_fee_0)
    }
    if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 9',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_priority_fee_0)
    }
    if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 10',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..256>',
                                 key_version_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 11',
                                 'Eip712.compact line 386 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_bridge_deposit_start_0(account_0,
                                                                  owner_0,
                                                                  auth_nonce_value_0,
                                                                  erc20_0,
                                                                  amount_0,
                                                                  evm_nonce_0,
                                                                  gas_limit_0,
                                                                  max_fee_0,
                                                                  max_priority_fee_0,
                                                                  key_version_0,
                                                                  challenge_0);
  },
  evm_struct_hash_bridge_withdraw_start: (...args_0) => {
    if (args_0.length !== 12) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_bridge_withdraw_start: expected 12 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const dest_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const evm_nonce_0 = args_0[6];
    const gas_limit_0 = args_0[7];
    const max_fee_0 = args_0[8];
    const max_priority_fee_0 = args_0[9];
    const key_version_0 = args_0[10];
    const challenge_0 = args_0[11];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 1',
                                 'Eip712.compact line 415 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 2',
                                 'Eip712.compact line 415 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 3',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(dest_0.buffer instanceof ArrayBuffer && dest_0.BYTES_PER_ELEMENT === 1 && dest_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 4',
                                 'Eip712.compact line 415 char 3',
                                 'Bytes<20>',
                                 dest_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 5',
                                 'Eip712.compact line 415 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 6',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 7',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..18446744073709551616>',
                                 evm_nonce_0)
    }
    if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 8',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..18446744073709551616>',
                                 gas_limit_0)
    }
    if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 9',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_fee_0)
    }
    if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 10',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_priority_fee_0)
    }
    if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 11',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..256>',
                                 key_version_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 12',
                                 'Eip712.compact line 415 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_bridge_withdraw_start_0(account_0,
                                                                   owner_0,
                                                                   auth_nonce_value_0,
                                                                   dest_0,
                                                                   color_0,
                                                                   amount_0,
                                                                   evm_nonce_0,
                                                                   gas_limit_0,
                                                                   max_fee_0,
                                                                   max_priority_fee_0,
                                                                   key_version_0,
                                                                   challenge_0);
  },
  evm_digest_withdraw_unshielded: (...args_0) => {
    if (args_0.length !== 8) {
      throw new __compactRuntime.CompactError(`evm_digest_withdraw_unshielded: expected 8 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const recipient_0 = args_0[6];
    const challenge_0 = args_0[7];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 1',
                                 'Eip712.compact line 447 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 2',
                                 'Eip712.compact line 447 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 3',
                                 'Eip712.compact line 447 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 4',
                                 'Eip712.compact line 447 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 5',
                                 'Eip712.compact line 447 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 6',
                                 'Eip712.compact line 447 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 7',
                                 'Eip712.compact line 447 char 3',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 8',
                                 'Eip712.compact line 447 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_withdraw_unshielded_0(account_0,
                                                            salt_0,
                                                            owner_0,
                                                            auth_nonce_value_0,
                                                            color_0,
                                                            amount_0,
                                                            recipient_0,
                                                            challenge_0);
  },
  evm_digest_withdraw_shielded: (...args_0) => {
    if (args_0.length !== 8) {
      throw new __compactRuntime.CompactError(`evm_digest_withdraw_shielded: expected 8 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const recipient_coin_public_key_0 = args_0[6];
    const challenge_0 = args_0[7];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 1',
                                 'Eip712.compact line 463 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 2',
                                 'Eip712.compact line 463 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 3',
                                 'Eip712.compact line 463 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 4',
                                 'Eip712.compact line 463 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 5',
                                 'Eip712.compact line 463 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 6',
                                 'Eip712.compact line 463 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(recipient_coin_public_key_0.buffer instanceof ArrayBuffer && recipient_coin_public_key_0.BYTES_PER_ELEMENT === 1 && recipient_coin_public_key_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 7',
                                 'Eip712.compact line 463 char 3',
                                 'Bytes<32>',
                                 recipient_coin_public_key_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 8',
                                 'Eip712.compact line 463 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_withdraw_shielded_0(account_0,
                                                          salt_0,
                                                          owner_0,
                                                          auth_nonce_value_0,
                                                          color_0,
                                                          amount_0,
                                                          recipient_coin_public_key_0,
                                                          challenge_0);
  },
  evm_digest_withdraw_shielded_to_contract: (...args_0) => {
    if (args_0.length !== 8) {
      throw new __compactRuntime.CompactError(`evm_digest_withdraw_shielded_to_contract: expected 8 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const recipient_contract_0 = args_0[6];
    const challenge_0 = args_0[7];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 1',
                                 'Eip712.compact line 479 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 2',
                                 'Eip712.compact line 479 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 3',
                                 'Eip712.compact line 479 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 4',
                                 'Eip712.compact line 479 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 5',
                                 'Eip712.compact line 479 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 6',
                                 'Eip712.compact line 479 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(recipient_contract_0.buffer instanceof ArrayBuffer && recipient_contract_0.BYTES_PER_ELEMENT === 1 && recipient_contract_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 7',
                                 'Eip712.compact line 479 char 3',
                                 'Bytes<32>',
                                 recipient_contract_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 8',
                                 'Eip712.compact line 479 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_withdraw_shielded_to_contract_0(account_0,
                                                                      salt_0,
                                                                      owner_0,
                                                                      auth_nonce_value_0,
                                                                      color_0,
                                                                      amount_0,
                                                                      recipient_contract_0,
                                                                      challenge_0);
  },
  evm_digest_append_inbox: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`evm_digest_append_inbox: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const entry_hash_0 = args_0[4];
    const challenge_0 = args_0[5];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_append_inbox',
                                 'argument 1',
                                 'Eip712.compact line 495 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_append_inbox',
                                 'argument 2',
                                 'Eip712.compact line 495 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_append_inbox',
                                 'argument 3',
                                 'Eip712.compact line 495 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_append_inbox',
                                 'argument 4',
                                 'Eip712.compact line 495 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(entry_hash_0.buffer instanceof ArrayBuffer && entry_hash_0.BYTES_PER_ELEMENT === 1 && entry_hash_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_append_inbox',
                                 'argument 5',
                                 'Eip712.compact line 495 char 3',
                                 'Bytes<32>',
                                 entry_hash_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_append_inbox',
                                 'argument 6',
                                 'Eip712.compact line 495 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_append_inbox_0(account_0,
                                                     salt_0,
                                                     owner_0,
                                                     auth_nonce_value_0,
                                                     entry_hash_0,
                                                     challenge_0);
  },
  evm_digest_rotate_enc_key: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`evm_digest_rotate_enc_key: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const new_key_0 = args_0[4];
    const challenge_0 = args_0[5];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_rotate_enc_key',
                                 'argument 1',
                                 'Eip712.compact line 509 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_rotate_enc_key',
                                 'argument 2',
                                 'Eip712.compact line 509 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_rotate_enc_key',
                                 'argument 3',
                                 'Eip712.compact line 509 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_rotate_enc_key',
                                 'argument 4',
                                 'Eip712.compact line 509 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_rotate_enc_key',
                                 'argument 5',
                                 'Eip712.compact line 509 char 3',
                                 'Bytes<32>',
                                 new_key_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_rotate_enc_key',
                                 'argument 6',
                                 'Eip712.compact line 509 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_rotate_enc_key_0(account_0,
                                                       salt_0,
                                                       owner_0,
                                                       auth_nonce_value_0,
                                                       new_key_0,
                                                       challenge_0);
  },
  evm_digest_add_device: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`evm_digest_add_device: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const new_entry_0 = args_0[4];
    const challenge_0 = args_0[5];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_add_device',
                                 'argument 1',
                                 'Eip712.compact line 523 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_add_device',
                                 'argument 2',
                                 'Eip712.compact line 523 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_add_device',
                                 'argument 3',
                                 'Eip712.compact line 523 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_add_device',
                                 'argument 4',
                                 'Eip712.compact line 523 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_add_device',
                                 'argument 5',
                                 'Eip712.compact line 523 char 3',
                                 'Bytes<32>',
                                 new_entry_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_add_device',
                                 'argument 6',
                                 'Eip712.compact line 523 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_add_device_0(account_0,
                                                   salt_0,
                                                   owner_0,
                                                   auth_nonce_value_0,
                                                   new_entry_0,
                                                   challenge_0);
  },
  evm_digest_open_swap_shielded: (...args_0) => {
    if (args_0.length !== 13) {
      throw new __compactRuntime.CompactError(`evm_digest_open_swap_shielded: expected 13 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const give_color_0 = args_0[4];
    const give_amount_0 = args_0[5];
    const recipient_kind_0 = args_0[6];
    const recipient_0 = args_0[7];
    const want_nonce_0 = args_0[8];
    const want_color_0 = args_0[9];
    const want_amount_0 = args_0[10];
    const valid_until_0 = args_0[11];
    const challenge_0 = args_0[12];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 1',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 2',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 3',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 4',
                                 'Eip712.compact line 537 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 5',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 give_color_0)
    }
    if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 6',
                                 'Eip712.compact line 537 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 give_amount_0)
    }
    if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 7',
                                 'Eip712.compact line 537 char 3',
                                 'Uint<0..256>',
                                 recipient_kind_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 8',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(want_nonce_0.buffer instanceof ArrayBuffer && want_nonce_0.BYTES_PER_ELEMENT === 1 && want_nonce_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 9',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 want_nonce_0)
    }
    if (!(want_color_0.buffer instanceof ArrayBuffer && want_color_0.BYTES_PER_ELEMENT === 1 && want_color_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 10',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 want_color_0)
    }
    if (!(typeof(want_amount_0) === 'bigint' && want_amount_0 >= 0n && want_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 11',
                                 'Eip712.compact line 537 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 want_amount_0)
    }
    if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 12',
                                 'Eip712.compact line 537 char 3',
                                 'Uint<0..18446744073709551616>',
                                 valid_until_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 13',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_open_swap_shielded_0(account_0,
                                                           salt_0,
                                                           owner_0,
                                                           auth_nonce_value_0,
                                                           give_color_0,
                                                           give_amount_0,
                                                           recipient_kind_0,
                                                           recipient_0,
                                                           want_nonce_0,
                                                           want_color_0,
                                                           want_amount_0,
                                                           valid_until_0,
                                                           challenge_0);
  },
  evm_digest_remove_device: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`evm_digest_remove_device: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const entry_0 = args_0[4];
    const challenge_0 = args_0[5];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_remove_device',
                                 'argument 1',
                                 'Eip712.compact line 560 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_remove_device',
                                 'argument 2',
                                 'Eip712.compact line 560 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_remove_device',
                                 'argument 3',
                                 'Eip712.compact line 560 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_remove_device',
                                 'argument 4',
                                 'Eip712.compact line 560 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_remove_device',
                                 'argument 5',
                                 'Eip712.compact line 560 char 3',
                                 'Bytes<32>',
                                 entry_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_remove_device',
                                 'argument 6',
                                 'Eip712.compact line 560 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_remove_device_0(account_0,
                                                      salt_0,
                                                      owner_0,
                                                      auth_nonce_value_0,
                                                      entry_0,
                                                      challenge_0);
  },
  evm_digest_bridge_deposit_start: (...args_0) => {
    if (args_0.length !== 12) {
      throw new __compactRuntime.CompactError(`evm_digest_bridge_deposit_start: expected 12 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const erc20_0 = args_0[4];
    const amount_0 = args_0[5];
    const evm_nonce_0 = args_0[6];
    const gas_limit_0 = args_0[7];
    const max_fee_0 = args_0[8];
    const max_priority_fee_0 = args_0[9];
    const key_version_0 = args_0[10];
    const challenge_0 = args_0[11];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 1',
                                 'Eip712.compact line 574 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 2',
                                 'Eip712.compact line 574 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 3',
                                 'Eip712.compact line 574 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 4',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(erc20_0.buffer instanceof ArrayBuffer && erc20_0.BYTES_PER_ELEMENT === 1 && erc20_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 5',
                                 'Eip712.compact line 574 char 3',
                                 'Bytes<20>',
                                 erc20_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 6',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 7',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..18446744073709551616>',
                                 evm_nonce_0)
    }
    if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 8',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..18446744073709551616>',
                                 gas_limit_0)
    }
    if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 9',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_fee_0)
    }
    if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 10',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_priority_fee_0)
    }
    if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 11',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..256>',
                                 key_version_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 12',
                                 'Eip712.compact line 574 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_bridge_deposit_start_0(account_0,
                                                             salt_0,
                                                             owner_0,
                                                             auth_nonce_value_0,
                                                             erc20_0,
                                                             amount_0,
                                                             evm_nonce_0,
                                                             gas_limit_0,
                                                             max_fee_0,
                                                             max_priority_fee_0,
                                                             key_version_0,
                                                             challenge_0);
  },
  evm_digest_bridge_withdraw_start: (...args_0) => {
    if (args_0.length !== 13) {
      throw new __compactRuntime.CompactError(`evm_digest_bridge_withdraw_start: expected 13 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const dest_0 = args_0[4];
    const color_0 = args_0[5];
    const amount_0 = args_0[6];
    const evm_nonce_0 = args_0[7];
    const gas_limit_0 = args_0[8];
    const max_fee_0 = args_0[9];
    const max_priority_fee_0 = args_0[10];
    const key_version_0 = args_0[11];
    const challenge_0 = args_0[12];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 1',
                                 'Eip712.compact line 595 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 2',
                                 'Eip712.compact line 595 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 3',
                                 'Eip712.compact line 595 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 4',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(dest_0.buffer instanceof ArrayBuffer && dest_0.BYTES_PER_ELEMENT === 1 && dest_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 5',
                                 'Eip712.compact line 595 char 3',
                                 'Bytes<20>',
                                 dest_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 6',
                                 'Eip712.compact line 595 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 7',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 8',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..18446744073709551616>',
                                 evm_nonce_0)
    }
    if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 9',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..18446744073709551616>',
                                 gas_limit_0)
    }
    if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 10',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_fee_0)
    }
    if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 11',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_priority_fee_0)
    }
    if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 12',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..256>',
                                 key_version_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 13',
                                 'Eip712.compact line 595 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_bridge_withdraw_start_0(account_0,
                                                              salt_0,
                                                              owner_0,
                                                              auth_nonce_value_0,
                                                              dest_0,
                                                              color_0,
                                                              amount_0,
                                                              evm_nonce_0,
                                                              gas_limit_0,
                                                              max_fee_0,
                                                              max_priority_fee_0,
                                                              key_version_0,
                                                              challenge_0);
  },
  zswapNullifierOf: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`zswapNullifierOf: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const coin_0 = args_0[0];
    const addr_0 = args_0[1];
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('zswapNullifierOf',
                                 'argument 1',
                                 'ZswapPrimitives.compact line 91 char 3',
                                 'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                 coin_0)
    }
    if (!(typeof(addr_0) === 'object' && addr_0.bytes.buffer instanceof ArrayBuffer && addr_0.bytes.BYTES_PER_ELEMENT === 1 && addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('zswapNullifierOf',
                                 'argument 2',
                                 'ZswapPrimitives.compact line 91 char 3',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 addr_0)
    }
    return _dummyContract._zswapNullifierOf_0(coin_0, addr_0);
  },
  zswapCommitmentOf: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`zswapCommitmentOf: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const coin_0 = args_0[0];
    const recipient_0 = args_0[1];
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('zswapCommitmentOf',
                                 'argument 1',
                                 'ZswapPrimitives.compact line 95 char 3',
                                 'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                 coin_0)
    }
    if (!(typeof(recipient_0) === 'object' && typeof(recipient_0.is_left) === 'boolean' && typeof(recipient_0.left) === 'object' && recipient_0.left.bytes.buffer instanceof ArrayBuffer && recipient_0.left.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.left.bytes.length === 32 && typeof(recipient_0.right) === 'object' && recipient_0.right.bytes.buffer instanceof ArrayBuffer && recipient_0.right.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.right.bytes.length === 32)) {
      __compactRuntime.typeError('zswapCommitmentOf',
                                 'argument 2',
                                 'ZswapPrimitives.compact line 95 char 3',
                                 'struct Either<is_left: Boolean, left: struct ZswapCoinPublicKey<bytes: Bytes<32>>, right: struct ContractAddress<bytes: Bytes<32>>>',
                                 recipient_0)
    }
    return _dummyContract._zswapCommitmentOf_0(coin_0, recipient_0);
  },
  derive_boot_commitment_with_jubjub: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`derive_boot_commitment_with_jubjub: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const salt_0 = args_0[0];
    const pk_0 = args_0[1];
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('derive_boot_commitment_with_jubjub',
                                 'argument 1',
                                 'account.compact line 560 char 1',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
      __compactRuntime.typeError('derive_boot_commitment_with_jubjub',
                                 'argument 2',
                                 'account.compact line 560 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    return _dummyContract._derive_boot_commitment_with_jubjub_0(salt_0, pk_0);
  },
  derive_boot_commitment_with_k256: (...args_0) => {
    if (args_0.length !== 3) {
      throw new __compactRuntime.CompactError(`derive_boot_commitment_with_k256: expected 3 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const salt_0 = args_0[0];
    const pk_0 = args_0[1];
    const envelope_0 = args_0[2];
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('derive_boot_commitment_with_k256',
                                 'argument 1',
                                 'account.compact line 571 char 1',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
      __compactRuntime.typeError('derive_boot_commitment_with_k256',
                                 'argument 2',
                                 'account.compact line 571 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
      __compactRuntime.typeError('derive_boot_commitment_with_k256',
                                 'argument 3',
                                 'account.compact line 571 char 1',
                                 'Uint<0..256>',
                                 envelope_0)
    }
    return _dummyContract._derive_boot_commitment_with_k256_0(salt_0,
                                                              pk_0,
                                                              envelope_0);
  },
  derive_boot_commitment_with_evm: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`derive_boot_commitment_with_evm: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const salt_0 = args_0[0];
    const address_0 = args_0[1];
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('derive_boot_commitment_with_evm',
                                 'argument 1',
                                 'account.compact line 586 char 1',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('derive_boot_commitment_with_evm',
                                 'argument 2',
                                 'account.compact line 586 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    return _dummyContract._derive_boot_commitment_with_evm_0(salt_0, address_0);
  },
  derive_device_entry_with_jubjub: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`derive_device_entry_with_jubjub: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const epoch_0 = args_0[2];
    const counter_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('derive_device_entry_with_jubjub',
                                 'argument 1',
                                 'account.compact line 606 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
      __compactRuntime.typeError('derive_device_entry_with_jubjub',
                                 'argument 2',
                                 'account.compact line 606 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(typeof(epoch_0) === 'bigint' && epoch_0 >= 0n && epoch_0 <= 4294967295n)) {
      __compactRuntime.typeError('derive_device_entry_with_jubjub',
                                 'argument 3',
                                 'account.compact line 606 char 1',
                                 'Uint<0..4294967296>',
                                 epoch_0)
    }
    if (!(typeof(counter_0) === 'bigint' && counter_0 >= 0n && counter_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('derive_device_entry_with_jubjub',
                                 'argument 4',
                                 'account.compact line 606 char 1',
                                 'Uint<0..18446744073709551616>',
                                 counter_0)
    }
    return _dummyContract._derive_device_entry_with_jubjub_0(self_addr_0,
                                                             pk_0,
                                                             epoch_0,
                                                             counter_0);
  },
  derive_device_entry_with_k256: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`derive_device_entry_with_k256: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const envelope_0 = args_0[2];
    const epoch_0 = args_0[3];
    const counter_0 = args_0[4];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('derive_device_entry_with_k256',
                                 'argument 1',
                                 'account.compact line 631 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
      __compactRuntime.typeError('derive_device_entry_with_k256',
                                 'argument 2',
                                 'account.compact line 631 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
      __compactRuntime.typeError('derive_device_entry_with_k256',
                                 'argument 3',
                                 'account.compact line 631 char 1',
                                 'Uint<0..256>',
                                 envelope_0)
    }
    if (!(typeof(epoch_0) === 'bigint' && epoch_0 >= 0n && epoch_0 <= 4294967295n)) {
      __compactRuntime.typeError('derive_device_entry_with_k256',
                                 'argument 4',
                                 'account.compact line 631 char 1',
                                 'Uint<0..4294967296>',
                                 epoch_0)
    }
    if (!(typeof(counter_0) === 'bigint' && counter_0 >= 0n && counter_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('derive_device_entry_with_k256',
                                 'argument 5',
                                 'account.compact line 631 char 1',
                                 'Uint<0..18446744073709551616>',
                                 counter_0)
    }
    return _dummyContract._derive_device_entry_with_k256_0(self_addr_0,
                                                           pk_0,
                                                           envelope_0,
                                                           epoch_0,
                                                           counter_0);
  },
  derive_device_entry_with_evm: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`derive_device_entry_with_evm: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const epoch_0 = args_0[2];
    const counter_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('derive_device_entry_with_evm',
                                 'argument 1',
                                 'account.compact line 664 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('derive_device_entry_with_evm',
                                 'argument 2',
                                 'account.compact line 664 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(typeof(epoch_0) === 'bigint' && epoch_0 >= 0n && epoch_0 <= 4294967295n)) {
      __compactRuntime.typeError('derive_device_entry_with_evm',
                                 'argument 3',
                                 'account.compact line 664 char 1',
                                 'Uint<0..4294967296>',
                                 epoch_0)
    }
    if (!(typeof(counter_0) === 'bigint' && counter_0 >= 0n && counter_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('derive_device_entry_with_evm',
                                 'argument 4',
                                 'account.compact line 664 char 1',
                                 'Uint<0..18446744073709551616>',
                                 counter_0)
    }
    return _dummyContract._derive_device_entry_with_evm_0(self_addr_0,
                                                          address_0,
                                                          epoch_0,
                                                          counter_0);
  },
  envelope_digest: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`envelope_digest: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const envelope_0 = args_0[0];
    const challenge_0 = args_0[1];
    if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
      __compactRuntime.typeError('envelope_digest',
                                 'argument 1',
                                 'account.compact line 710 char 1',
                                 'Uint<0..256>',
                                 envelope_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('envelope_digest',
                                 'argument 2',
                                 'account.compact line 710 char 1',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._envelope_digest_0(envelope_0, challenge_0);
  },
  compute_public_point_with_jubjub: (...args_0) => {
    if (args_0.length !== 1) {
      throw new __compactRuntime.CompactError(`compute_public_point_with_jubjub: expected 1 argument (as invoked from Typescript), received ${args_0.length}`);
    }
    const scalar_0 = args_0[0];
    if (!(typeof(scalar_0) === 'bigint' && scalar_0 >= 0 && scalar_0 <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('compute_public_point_with_jubjub',
                                 'argument 1',
                                 'account.compact line 723 char 1',
                                 'Field',
                                 scalar_0)
    }
    return _dummyContract._compute_public_point_with_jubjub_0(scalar_0);
  },
  compute_public_point_with_k256: (...args_0) => {
    if (args_0.length !== 1) {
      throw new __compactRuntime.CompactError(`compute_public_point_with_k256: expected 1 argument (as invoked from Typescript), received ${args_0.length}`);
    }
    const scalar_0 = args_0[0];
    if (!(typeof(scalar_0) === 'bigint' && scalar_0 >= 0 && scalar_0 <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
      __compactRuntime.typeError('compute_public_point_with_k256',
                                 'argument 1',
                                 'account.compact line 727 char 1',
                                 'Secp256k1Scalar',
                                 scalar_0)
    }
    return _dummyContract._compute_public_point_with_k256_0(scalar_0);
  },
  challenge_withdraw_unshielded_with_jubjub: (...args_0) => {
    if (args_0.length !== 8) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_unshielded_with_jubjub: expected 8 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const recipient_0 = args_0[5];
    const nonce_value_0 = args_0[6];
    const grind_nonce_0 = args_0[7];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 1',
                                 'account.compact line 744 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 2',
                                 'account.compact line 744 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 3',
                                 'account.compact line 744 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 4',
                                 'account.compact line 744 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 5',
                                 'account.compact line 744 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 6',
                                 'account.compact line 744 char 1',
                                 'struct UserAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 7',
                                 'account.compact line 744 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 8',
                                 'account.compact line 744 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_withdraw_unshielded_with_jubjub_0(self_addr_0,
                                                                       sig_r_0,
                                                                       pk_0,
                                                                       color_0,
                                                                       amount_0,
                                                                       recipient_0,
                                                                       nonce_value_0,
                                                                       grind_nonce_0);
  },
  challenge_withdraw_shielded_with_jubjub: (...args_0) => {
    if (args_0.length !== 9) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_with_jubjub: expected 9 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const recipient_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const coin_0 = args_0[6];
    const nonce_value_0 = args_0[7];
    const grind_nonce_0 = args_0[8];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 1',
                                 'account.compact line 766 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 2',
                                 'account.compact line 766 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 3',
                                 'account.compact line 766 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 4',
                                 'account.compact line 766 char 1',
                                 'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 5',
                                 'account.compact line 766 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 6',
                                 'account.compact line 766 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 7',
                                 'account.compact line 766 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 8',
                                 'account.compact line 766 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 9',
                                 'account.compact line 766 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_withdraw_shielded_with_jubjub_0(self_addr_0,
                                                                     sig_r_0,
                                                                     pk_0,
                                                                     recipient_0,
                                                                     color_0,
                                                                     amount_0,
                                                                     coin_0,
                                                                     nonce_value_0,
                                                                     grind_nonce_0);
  },
  challenge_withdraw_shielded_to_contract_with_jubjub: (...args_0) => {
    if (args_0.length !== 9) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_to_contract_with_jubjub: expected 9 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const recipient_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const coin_0 = args_0[6];
    const nonce_value_0 = args_0[7];
    const grind_nonce_0 = args_0[8];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 1',
                                 'account.compact line 785 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 2',
                                 'account.compact line 785 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 3',
                                 'account.compact line 785 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 4',
                                 'account.compact line 785 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 5',
                                 'account.compact line 785 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 6',
                                 'account.compact line 785 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 7',
                                 'account.compact line 785 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 8',
                                 'account.compact line 785 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 9',
                                 'account.compact line 785 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_withdraw_shielded_to_contract_with_jubjub_0(self_addr_0,
                                                                                 sig_r_0,
                                                                                 pk_0,
                                                                                 recipient_0,
                                                                                 color_0,
                                                                                 amount_0,
                                                                                 coin_0,
                                                                                 nonce_value_0,
                                                                                 grind_nonce_0);
  },
  challenge_append_inbox_with_jubjub: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`challenge_append_inbox_with_jubjub: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const entry_0 = args_0[3];
    const nonce_value_0 = args_0[4];
    const grind_nonce_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_append_inbox_with_jubjub',
                                 'argument 1',
                                 'account.compact line 804 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_append_inbox_with_jubjub',
                                 'argument 2',
                                 'account.compact line 804 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_append_inbox_with_jubjub',
                                 'argument 3',
                                 'account.compact line 804 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_append_inbox_with_jubjub',
                                 'argument 4',
                                 'account.compact line 804 char 1',
                                 'Bytes<192>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_append_inbox_with_jubjub',
                                 'argument 5',
                                 'account.compact line 804 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_append_inbox_with_jubjub',
                                 'argument 6',
                                 'account.compact line 804 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_append_inbox_with_jubjub_0(self_addr_0,
                                                                sig_r_0,
                                                                pk_0,
                                                                entry_0,
                                                                nonce_value_0,
                                                                grind_nonce_0);
  },
  challenge_rotate_enc_key_with_jubjub: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`challenge_rotate_enc_key_with_jubjub: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const new_key_0 = args_0[3];
    const nonce_value_0 = args_0[4];
    const grind_nonce_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_jubjub',
                                 'argument 1',
                                 'account.compact line 820 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_jubjub',
                                 'argument 2',
                                 'account.compact line 820 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_jubjub',
                                 'argument 3',
                                 'account.compact line 820 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_jubjub',
                                 'argument 4',
                                 'account.compact line 820 char 1',
                                 'Bytes<32>',
                                 new_key_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_jubjub',
                                 'argument 5',
                                 'account.compact line 820 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_jubjub',
                                 'argument 6',
                                 'account.compact line 820 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_rotate_enc_key_with_jubjub_0(self_addr_0,
                                                                  sig_r_0,
                                                                  pk_0,
                                                                  new_key_0,
                                                                  nonce_value_0,
                                                                  grind_nonce_0);
  },
  challenge_add_device_with_jubjub: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`challenge_add_device_with_jubjub: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const new_entry_0 = args_0[3];
    const nonce_value_0 = args_0[4];
    const grind_nonce_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_add_device_with_jubjub',
                                 'argument 1',
                                 'account.compact line 840 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_add_device_with_jubjub',
                                 'argument 2',
                                 'account.compact line 840 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_add_device_with_jubjub',
                                 'argument 3',
                                 'account.compact line 840 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
      __compactRuntime.typeError('challenge_add_device_with_jubjub',
                                 'argument 4',
                                 'account.compact line 840 char 1',
                                 'Bytes<32>',
                                 new_entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_add_device_with_jubjub',
                                 'argument 5',
                                 'account.compact line 840 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_add_device_with_jubjub',
                                 'argument 6',
                                 'account.compact line 840 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_add_device_with_jubjub_0(self_addr_0,
                                                              sig_r_0,
                                                              pk_0,
                                                              new_entry_0,
                                                              nonce_value_0,
                                                              grind_nonce_0);
  },
  challenge_remove_device_with_jubjub: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`challenge_remove_device_with_jubjub: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const entry_0 = args_0[3];
    const nonce_value_0 = args_0[4];
    const grind_nonce_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_remove_device_with_jubjub',
                                 'argument 1',
                                 'account.compact line 856 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_remove_device_with_jubjub',
                                 'argument 2',
                                 'account.compact line 856 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_remove_device_with_jubjub',
                                 'argument 3',
                                 'account.compact line 856 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
      __compactRuntime.typeError('challenge_remove_device_with_jubjub',
                                 'argument 4',
                                 'account.compact line 856 char 1',
                                 'Bytes<32>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_remove_device_with_jubjub',
                                 'argument 5',
                                 'account.compact line 856 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_remove_device_with_jubjub',
                                 'argument 6',
                                 'account.compact line 856 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_remove_device_with_jubjub_0(self_addr_0,
                                                                 sig_r_0,
                                                                 pk_0,
                                                                 entry_0,
                                                                 nonce_value_0,
                                                                 grind_nonce_0);
  },
  challenge_open_swap_shielded_with_jubjub: (...args_0) => {
    if (args_0.length !== 14) {
      throw new __compactRuntime.CompactError(`challenge_open_swap_shielded_with_jubjub: expected 14 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const give_color_0 = args_0[3];
    const give_amount_0 = args_0[4];
    const recipient_kind_0 = args_0[5];
    const recipient_0 = args_0[6];
    const want_0 = args_0[7];
    const want_entry_0 = args_0[8];
    const change_entry_0 = args_0[9];
    const valid_until_0 = args_0[10];
    const coin_0 = args_0[11];
    const nonce_value_0 = args_0[12];
    const grind_nonce_0 = args_0[13];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 1',
                                 'account.compact line 877 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && typeof(sig_r_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 2',
                                 'account.compact line 877 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint')) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 3',
                                 'account.compact line 877 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 4',
                                 'account.compact line 877 char 1',
                                 'Bytes<32>',
                                 give_color_0)
    }
    if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 5',
                                 'account.compact line 877 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 give_amount_0)
    }
    if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 6',
                                 'account.compact line 877 char 1',
                                 'Uint<0..256>',
                                 recipient_kind_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 7',
                                 'account.compact line 877 char 1',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 8',
                                 'account.compact line 877 char 1',
                                 'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                 want_0)
    }
    if (!(want_entry_0.buffer instanceof ArrayBuffer && want_entry_0.BYTES_PER_ELEMENT === 1 && want_entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 9',
                                 'account.compact line 877 char 1',
                                 'Bytes<192>',
                                 want_entry_0)
    }
    if (!(change_entry_0.buffer instanceof ArrayBuffer && change_entry_0.BYTES_PER_ELEMENT === 1 && change_entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 10',
                                 'account.compact line 877 char 1',
                                 'Bytes<192>',
                                 change_entry_0)
    }
    if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 11',
                                 'account.compact line 877 char 1',
                                 'Uint<0..18446744073709551616>',
                                 valid_until_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 12',
                                 'account.compact line 877 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 13',
                                 'account.compact line 877 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 14',
                                 'account.compact line 877 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_open_swap_shielded_with_jubjub_0(self_addr_0,
                                                                      sig_r_0,
                                                                      pk_0,
                                                                      give_color_0,
                                                                      give_amount_0,
                                                                      recipient_kind_0,
                                                                      recipient_0,
                                                                      want_0,
                                                                      want_entry_0,
                                                                      change_entry_0,
                                                                      valid_until_0,
                                                                      coin_0,
                                                                      nonce_value_0,
                                                                      grind_nonce_0);
  },
  challenge_withdraw_unshielded_with_k256: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_unshielded_with_k256: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const color_0 = args_0[2];
    const amount_0 = args_0[3];
    const recipient_0 = args_0[4];
    const nonce_value_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_k256',
                                 'argument 1',
                                 'account.compact line 911 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_k256',
                                 'argument 2',
                                 'account.compact line 911 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_k256',
                                 'argument 3',
                                 'account.compact line 911 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_k256',
                                 'argument 4',
                                 'account.compact line 911 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_k256',
                                 'argument 5',
                                 'account.compact line 911 char 1',
                                 'struct UserAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_k256',
                                 'argument 6',
                                 'account.compact line 911 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_unshielded_with_k256_0(self_addr_0,
                                                                     pk_0,
                                                                     color_0,
                                                                     amount_0,
                                                                     recipient_0,
                                                                     nonce_value_0);
  },
  challenge_withdraw_shielded_with_k256: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_with_k256: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const recipient_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const coin_0 = args_0[5];
    const nonce_value_0 = args_0[6];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 1',
                                 'account.compact line 929 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 2',
                                 'account.compact line 929 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 3',
                                 'account.compact line 929 char 1',
                                 'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 4',
                                 'account.compact line 929 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 5',
                                 'account.compact line 929 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 6',
                                 'account.compact line 929 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 7',
                                 'account.compact line 929 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_shielded_with_k256_0(self_addr_0,
                                                                   pk_0,
                                                                   recipient_0,
                                                                   color_0,
                                                                   amount_0,
                                                                   coin_0,
                                                                   nonce_value_0);
  },
  challenge_withdraw_shielded_to_contract_with_k256: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_to_contract_with_k256: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const recipient_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const coin_0 = args_0[5];
    const nonce_value_0 = args_0[6];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 1',
                                 'account.compact line 948 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 2',
                                 'account.compact line 948 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 3',
                                 'account.compact line 948 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 4',
                                 'account.compact line 948 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 5',
                                 'account.compact line 948 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 6',
                                 'account.compact line 948 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 7',
                                 'account.compact line 948 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_shielded_to_contract_with_k256_0(self_addr_0,
                                                                               pk_0,
                                                                               recipient_0,
                                                                               color_0,
                                                                               amount_0,
                                                                               coin_0,
                                                                               nonce_value_0);
  },
  challenge_append_inbox_with_k256: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_append_inbox_with_k256: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const entry_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_append_inbox_with_k256',
                                 'argument 1',
                                 'account.compact line 967 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
      __compactRuntime.typeError('challenge_append_inbox_with_k256',
                                 'argument 2',
                                 'account.compact line 967 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_append_inbox_with_k256',
                                 'argument 3',
                                 'account.compact line 967 char 1',
                                 'Bytes<192>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_append_inbox_with_k256',
                                 'argument 4',
                                 'account.compact line 967 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_append_inbox_with_k256_0(self_addr_0,
                                                              pk_0,
                                                              entry_0,
                                                              nonce_value_0);
  },
  challenge_rotate_enc_key_with_k256: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_rotate_enc_key_with_k256: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const new_key_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_k256',
                                 'argument 1',
                                 'account.compact line 983 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_k256',
                                 'argument 2',
                                 'account.compact line 983 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_k256',
                                 'argument 3',
                                 'account.compact line 983 char 1',
                                 'Bytes<32>',
                                 new_key_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_k256',
                                 'argument 4',
                                 'account.compact line 983 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_rotate_enc_key_with_k256_0(self_addr_0,
                                                                pk_0,
                                                                new_key_0,
                                                                nonce_value_0);
  },
  challenge_add_device_with_k256: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_add_device_with_k256: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const new_entry_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_add_device_with_k256',
                                 'argument 1',
                                 'account.compact line 999 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
      __compactRuntime.typeError('challenge_add_device_with_k256',
                                 'argument 2',
                                 'account.compact line 999 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
      __compactRuntime.typeError('challenge_add_device_with_k256',
                                 'argument 3',
                                 'account.compact line 999 char 1',
                                 'Bytes<32>',
                                 new_entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_add_device_with_k256',
                                 'argument 4',
                                 'account.compact line 999 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_add_device_with_k256_0(self_addr_0,
                                                            pk_0,
                                                            new_entry_0,
                                                            nonce_value_0);
  },
  challenge_remove_device_with_k256: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_remove_device_with_k256: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const entry_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_remove_device_with_k256',
                                 'argument 1',
                                 'account.compact line 1015 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && typeof(pk_0.y) === 'bigint' && typeof(pk_0.identity) == 'boolean')) {
      __compactRuntime.typeError('challenge_remove_device_with_k256',
                                 'argument 2',
                                 'account.compact line 1015 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
      __compactRuntime.typeError('challenge_remove_device_with_k256',
                                 'argument 3',
                                 'account.compact line 1015 char 1',
                                 'Bytes<32>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_remove_device_with_k256',
                                 'argument 4',
                                 'account.compact line 1015 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_remove_device_with_k256_0(self_addr_0,
                                                               pk_0,
                                                               entry_0,
                                                               nonce_value_0);
  },
  challenge_withdraw_unshielded_with_evm: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_unshielded_with_evm: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const color_0 = args_0[2];
    const amount_0 = args_0[3];
    const recipient_0 = args_0[4];
    const nonce_value_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_evm',
                                 'argument 1',
                                 'account.compact line 1047 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_evm',
                                 'argument 2',
                                 'account.compact line 1047 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_evm',
                                 'argument 3',
                                 'account.compact line 1047 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_evm',
                                 'argument 4',
                                 'account.compact line 1047 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_evm',
                                 'argument 5',
                                 'account.compact line 1047 char 1',
                                 'struct UserAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_evm',
                                 'argument 6',
                                 'account.compact line 1047 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_unshielded_with_evm_0(self_addr_0,
                                                                    address_0,
                                                                    color_0,
                                                                    amount_0,
                                                                    recipient_0,
                                                                    nonce_value_0);
  },
  challenge_withdraw_shielded_with_evm: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_with_evm: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const recipient_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const coin_0 = args_0[5];
    const nonce_value_0 = args_0[6];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 1',
                                 'account.compact line 1063 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 2',
                                 'account.compact line 1063 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 3',
                                 'account.compact line 1063 char 1',
                                 'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 4',
                                 'account.compact line 1063 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 5',
                                 'account.compact line 1063 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 6',
                                 'account.compact line 1063 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 7',
                                 'account.compact line 1063 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_shielded_with_evm_0(self_addr_0,
                                                                  address_0,
                                                                  recipient_0,
                                                                  color_0,
                                                                  amount_0,
                                                                  coin_0,
                                                                  nonce_value_0);
  },
  challenge_withdraw_shielded_to_contract_with_evm: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_to_contract_with_evm: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const recipient_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const coin_0 = args_0[5];
    const nonce_value_0 = args_0[6];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 1',
                                 'account.compact line 1080 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 2',
                                 'account.compact line 1080 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 3',
                                 'account.compact line 1080 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 4',
                                 'account.compact line 1080 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 5',
                                 'account.compact line 1080 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 6',
                                 'account.compact line 1080 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 7',
                                 'account.compact line 1080 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_shielded_to_contract_with_evm_0(self_addr_0,
                                                                              address_0,
                                                                              recipient_0,
                                                                              color_0,
                                                                              amount_0,
                                                                              coin_0,
                                                                              nonce_value_0);
  },
  challenge_append_inbox_with_evm: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_append_inbox_with_evm: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const entry_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_append_inbox_with_evm',
                                 'argument 1',
                                 'account.compact line 1097 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_append_inbox_with_evm',
                                 'argument 2',
                                 'account.compact line 1097 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_append_inbox_with_evm',
                                 'argument 3',
                                 'account.compact line 1097 char 1',
                                 'Bytes<192>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_append_inbox_with_evm',
                                 'argument 4',
                                 'account.compact line 1097 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_append_inbox_with_evm_0(self_addr_0,
                                                             address_0,
                                                             entry_0,
                                                             nonce_value_0);
  },
  challenge_rotate_enc_key_with_evm: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_rotate_enc_key_with_evm: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const new_key_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_evm',
                                 'argument 1',
                                 'account.compact line 1111 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_evm',
                                 'argument 2',
                                 'account.compact line 1111 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_evm',
                                 'argument 3',
                                 'account.compact line 1111 char 1',
                                 'Bytes<32>',
                                 new_key_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_evm',
                                 'argument 4',
                                 'account.compact line 1111 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_rotate_enc_key_with_evm_0(self_addr_0,
                                                               address_0,
                                                               new_key_0,
                                                               nonce_value_0);
  },
  challenge_add_device_with_evm: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_add_device_with_evm: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const new_entry_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_add_device_with_evm',
                                 'argument 1',
                                 'account.compact line 1125 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_add_device_with_evm',
                                 'argument 2',
                                 'account.compact line 1125 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
      __compactRuntime.typeError('challenge_add_device_with_evm',
                                 'argument 3',
                                 'account.compact line 1125 char 1',
                                 'Bytes<32>',
                                 new_entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_add_device_with_evm',
                                 'argument 4',
                                 'account.compact line 1125 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_add_device_with_evm_0(self_addr_0,
                                                           address_0,
                                                           new_entry_0,
                                                           nonce_value_0);
  },
  challenge_remove_device_with_evm: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_remove_device_with_evm: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const entry_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_remove_device_with_evm',
                                 'argument 1',
                                 'account.compact line 1139 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_remove_device_with_evm',
                                 'argument 2',
                                 'account.compact line 1139 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
      __compactRuntime.typeError('challenge_remove_device_with_evm',
                                 'argument 3',
                                 'account.compact line 1139 char 1',
                                 'Bytes<32>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_remove_device_with_evm',
                                 'argument 4',
                                 'account.compact line 1139 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_remove_device_with_evm_0(self_addr_0,
                                                              address_0,
                                                              entry_0,
                                                              nonce_value_0);
  },
  challenge_open_swap_shielded_with_evm: (...args_0) => {
    if (args_0.length !== 12) {
      throw new __compactRuntime.CompactError(`challenge_open_swap_shielded_with_evm: expected 12 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const give_color_0 = args_0[2];
    const give_amount_0 = args_0[3];
    const recipient_kind_0 = args_0[4];
    const recipient_0 = args_0[5];
    const want_0 = args_0[6];
    const want_entry_0 = args_0[7];
    const change_entry_0 = args_0[8];
    const valid_until_0 = args_0[9];
    const coin_0 = args_0[10];
    const nonce_value_0 = args_0[11];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 1',
                                 'account.compact line 1158 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 2',
                                 'account.compact line 1158 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 3',
                                 'account.compact line 1158 char 1',
                                 'Bytes<32>',
                                 give_color_0)
    }
    if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 4',
                                 'account.compact line 1158 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 give_amount_0)
    }
    if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 5',
                                 'account.compact line 1158 char 1',
                                 'Uint<0..256>',
                                 recipient_kind_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 6',
                                 'account.compact line 1158 char 1',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 7',
                                 'account.compact line 1158 char 1',
                                 'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                 want_0)
    }
    if (!(want_entry_0.buffer instanceof ArrayBuffer && want_entry_0.BYTES_PER_ELEMENT === 1 && want_entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 8',
                                 'account.compact line 1158 char 1',
                                 'Bytes<192>',
                                 want_entry_0)
    }
    if (!(change_entry_0.buffer instanceof ArrayBuffer && change_entry_0.BYTES_PER_ELEMENT === 1 && change_entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 9',
                                 'account.compact line 1158 char 1',
                                 'Bytes<192>',
                                 change_entry_0)
    }
    if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 10',
                                 'account.compact line 1158 char 1',
                                 'Uint<0..18446744073709551616>',
                                 valid_until_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 11',
                                 'account.compact line 1158 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 12',
                                 'account.compact line 1158 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_open_swap_shielded_with_evm_0(self_addr_0,
                                                                   address_0,
                                                                   give_color_0,
                                                                   give_amount_0,
                                                                   recipient_kind_0,
                                                                   recipient_0,
                                                                   want_0,
                                                                   want_entry_0,
                                                                   change_entry_0,
                                                                   valid_until_0,
                                                                   coin_0,
                                                                   nonce_value_0);
  },
  challenge_bridge_deposit_start_with_evm: (...args_0) => {
    if (args_0.length !== 10) {
      throw new __compactRuntime.CompactError(`challenge_bridge_deposit_start_with_evm: expected 10 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const erc20_0 = args_0[2];
    const amount_0 = args_0[3];
    const evm_nonce_0 = args_0[4];
    const gas_limit_0 = args_0[5];
    const max_fee_0 = args_0[6];
    const max_priority_fee_0 = args_0[7];
    const key_version_0 = args_0[8];
    const nonce_value_0 = args_0[9];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 1',
                                 'account.compact line 1194 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 2',
                                 'account.compact line 1194 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(erc20_0.buffer instanceof ArrayBuffer && erc20_0.BYTES_PER_ELEMENT === 1 && erc20_0.length === 20)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 3',
                                 'account.compact line 1194 char 1',
                                 'Bytes<20>',
                                 erc20_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 4',
                                 'account.compact line 1194 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 5',
                                 'account.compact line 1194 char 1',
                                 'Uint<0..18446744073709551616>',
                                 evm_nonce_0)
    }
    if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 6',
                                 'account.compact line 1194 char 1',
                                 'Uint<0..18446744073709551616>',
                                 gas_limit_0)
    }
    if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 7',
                                 'account.compact line 1194 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_fee_0)
    }
    if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 8',
                                 'account.compact line 1194 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_priority_fee_0)
    }
    if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 9',
                                 'account.compact line 1194 char 1',
                                 'Uint<0..256>',
                                 key_version_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 10',
                                 'account.compact line 1194 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_bridge_deposit_start_with_evm_0(self_addr_0,
                                                                     address_0,
                                                                     erc20_0,
                                                                     amount_0,
                                                                     evm_nonce_0,
                                                                     gas_limit_0,
                                                                     max_fee_0,
                                                                     max_priority_fee_0,
                                                                     key_version_0,
                                                                     nonce_value_0);
  },
  challenge_bridge_withdraw_start_with_evm: (...args_0) => {
    if (args_0.length !== 13) {
      throw new __compactRuntime.CompactError(`challenge_bridge_withdraw_start_with_evm: expected 13 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const dest_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const evm_nonce_0 = args_0[5];
    const gas_limit_0 = args_0[6];
    const max_fee_0 = args_0[7];
    const max_priority_fee_0 = args_0[8];
    const key_version_0 = args_0[9];
    const erc20_0 = args_0[10];
    const coin_0 = args_0[11];
    const nonce_value_0 = args_0[12];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 1',
                                 'account.compact line 1237 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 2',
                                 'account.compact line 1237 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(dest_0.buffer instanceof ArrayBuffer && dest_0.BYTES_PER_ELEMENT === 1 && dest_0.length === 20)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 3',
                                 'account.compact line 1237 char 1',
                                 'Bytes<20>',
                                 dest_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 4',
                                 'account.compact line 1237 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 5',
                                 'account.compact line 1237 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 6',
                                 'account.compact line 1237 char 1',
                                 'Uint<0..18446744073709551616>',
                                 evm_nonce_0)
    }
    if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 7',
                                 'account.compact line 1237 char 1',
                                 'Uint<0..18446744073709551616>',
                                 gas_limit_0)
    }
    if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 8',
                                 'account.compact line 1237 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_fee_0)
    }
    if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 9',
                                 'account.compact line 1237 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_priority_fee_0)
    }
    if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 10',
                                 'account.compact line 1237 char 1',
                                 'Uint<0..256>',
                                 key_version_0)
    }
    if (!(erc20_0.buffer instanceof ArrayBuffer && erc20_0.BYTES_PER_ELEMENT === 1 && erc20_0.length === 20)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 11',
                                 'account.compact line 1237 char 1',
                                 'Bytes<20>',
                                 erc20_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 12',
                                 'account.compact line 1237 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 13',
                                 'account.compact line 1237 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_bridge_withdraw_start_with_evm_0(self_addr_0,
                                                                      address_0,
                                                                      dest_0,
                                                                      color_0,
                                                                      amount_0,
                                                                      evm_nonce_0,
                                                                      gas_limit_0,
                                                                      max_fee_0,
                                                                      max_priority_fee_0,
                                                                      key_version_0,
                                                                      erc20_0,
                                                                      coin_0,
                                                                      nonce_value_0);
  },
  assert_open_swap_terms: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`assert_open_swap_terms: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const give_color_0 = args_0[0];
    const give_amount_0 = args_0[1];
    const recipient_kind_0 = args_0[2];
    const recipient_0 = args_0[3];
    const want_0 = args_0[4];
    const coin_color_0 = args_0[5];
    const coin_value_0 = args_0[6];
    if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 1',
                                 'account.compact line 1528 char 1',
                                 'Bytes<32>',
                                 give_color_0)
    }
    if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 2',
                                 'account.compact line 1528 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 give_amount_0)
    }
    if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 3',
                                 'account.compact line 1528 char 1',
                                 'Uint<0..256>',
                                 recipient_kind_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 4',
                                 'account.compact line 1528 char 1',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 5',
                                 'account.compact line 1528 char 1',
                                 'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                 want_0)
    }
    if (!(coin_color_0.buffer instanceof ArrayBuffer && coin_color_0.BYTES_PER_ELEMENT === 1 && coin_color_0.length === 32)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 6',
                                 'account.compact line 1528 char 1',
                                 'Bytes<32>',
                                 coin_color_0)
    }
    if (!(typeof(coin_value_0) === 'bigint' && coin_value_0 >= 0n && coin_value_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 7',
                                 'account.compact line 1528 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 coin_value_0)
    }
    return _dummyContract._assert_open_swap_terms_0(give_color_0,
                                                    give_amount_0,
                                                    recipient_kind_0,
                                                    recipient_0,
                                                    want_0,
                                                    coin_color_0,
                                                    coin_value_0);
  },
  swap_change_nonce: (...args_0) => {
    if (args_0.length !== 1) {
      throw new __compactRuntime.CompactError(`swap_change_nonce: expected 1 argument (as invoked from Typescript), received ${args_0.length}`);
    }
    const coin_nonce_0 = args_0[0];
    if (!(coin_nonce_0.buffer instanceof ArrayBuffer && coin_nonce_0.BYTES_PER_ELEMENT === 1 && coin_nonce_0.length === 32)) {
      __compactRuntime.typeError('swap_change_nonce',
                                 'argument 1',
                                 'account.compact line 1567 char 1',
                                 'Bytes<32>',
                                 coin_nonce_0)
    }
    return _dummyContract._swap_change_nonce_0(coin_nonce_0);
  }
};
export const contractReferenceLocations =
  {
   tag: 'publicLedgerArray',
   indices: {
     13: { 
          tag: 'cell',
          valueType: {
                      tag: 'compactValue',
                      descriptor: _descriptor_1,
                      sparseType: { tag: 'contractAddress' }
                     }
         }
   }
  };
export const expectedVk = {};

//# sourceMappingURL=index.js.map
